module.exports = {
  alarms: 'Alarmen',
  contacts: 'Contacten',
  groups: 'Groepen',
  settings: 'Instellingen',
  notificationsTab: 'Meldingen',
  specifyTimeInFutureForAlarm: 'Alarm kan niet in het verleden liggen.',
  specifyTimeInFutureForPreReminder:
    'Herinnering vooraf voor alarm is verleden tijd.',
  specifyNameForGroup: 'De groepsnaam is vereist.',
  updatingGroupName: 'Groepsinformatie bijwerken.',
  unableToEditGroupName:
    'Groepsinformatie kan niet worden bijgewerkt. Probeer het na enige tijd opnieuw.',
  selectSmallerImage:
    'Afbeelding is groter dan 10 MB. Selecteer een kleinere afbeelding.',
  sendingVerificationCode:
    'Verificatiecode verzenden naar {{formattedMobileNumber}}.',
  verifyingCode: 'De code controleren.',
  creatingUserProfile: 'Instellen...',
  unabeToCreateUserProfile:
    'Op dit moment kan er geen account worden aangemaakt. Probeer het over enkele ogenblikken opnieuw.',
  unableToSendVerificationCode: 'Kan geen verificatiecode verzenden. {{error}}',
  unableToVerifyCode: 'Kan code niet verifiëren. {{error}}',
  unableToRegisterUserWithoutMobileNumber:
    'Kan setup niet uitvoeren. {{error}}',
  permissionDeniedToAccessCameraIos:
    'Galarm heeft geen toegang tot de camera. \n\nGa naar Instellingen > Galarm en geef toegang tot de camera.',
  permissionDeniedToAccessCameraAndroid:
    'Galarm heeft geen toegang tot de camera.\n\nGa naar Instellingen > Apps > Galarm > Machtigingen en geef toegang tot de camera.',
  permissionDeniedToAccessPhotosIos:
    "Galarm heeft geen toegang tot foto's.\n\nGa naar Instellingen > Galarm en geef toegang tot foto's.",
  permissionDeniedToAccessPhotosAndroid:
    "Galarm heeft geen toegang tot foto's.\n\nGa naar Instellingen > Apps > Galarm > Machtigingen en geef toegang tot opslagruimte.",
  permissionDeniedToAccessCalendarIos:
    "Galarm heeft geen toegang tot de agenda.\nGa naar Instellingen > Agenda's en geef Galarm toegang.",
  permissionDeniedToAccessCalendarAndroid:
    'Galarm heeft geen toegang tot de kalender.\nGa naar Instellingen > Apps > Galarm > Machtigingen en geef toegang tot Agenda.',
  verificationCodeSent:
    'Verificatiecode verzonden naar {{formattedMobileNumber}}.',
  rateTheApp:
    'We hopen dat je Galarm nuttig vindt. Neem even de tijd om ons te beoordelen in de Play Store. Bedankt voor uw steun.',
  backgroundAppRefreshDisabledPermission:
    'Alarmen gaan mogelijk niet af omdat Galarm geen toestemming heeft om app-verversing op de achtergrond uit te voeren.\n\nTik op "Inschakelen" en schakel "Verversen van app op achtergrond" in.',
  selectedGroupUnselected:
    'U kunt een groep of een reeks contactpersonen als deelnemers selecteren. Uw eerder geselecteerde groep wordt ongeselecteerd. Doorgaan?',
  selectedContactsUnselected:
    'U kunt een groep of een reeks contactpersonen selecteren als deelnemers. Uw eerder geselecteerde contactpersonen worden niet meer geselecteerd. Doorgaan?',
  notificationsDisabledIos:
    'Alarmen gaan niet af omdat Galarm geen toestemming heeft om meldingen te tonen.\n\nGa naar Instellingen > Galarm > Meldingen en schakel "Waarschuwingen", "Geluiden" en "Banners" in.',
  notificationsDisabledAndroid:
    'Alarmmeldingen verschijnen niet op het scherm.\n\nTik op "Inschakelen", selecteer "Meldingen" en sta meldingen toe.',
  alarmNotificationChannelDisabled:
    'Alarmmeldingen verschijnen niet op het scherm. \n\nTik op "Inschakelen" en laat de alarmmeldingen op het scherm verschijnen.',
  alarmLockScreenNotificationlDisabled:
    'Alarmmeldingen worden niet weergegeven op het vergrendelscherm. \n\nTik op "Inschakelen" om de alarmmeldingen weer te geven op het vergrendelscherm.',
  alarmWillNotRingDueToNotificationsDisabledIos:
    'Alarmen gaan niet af omdat meldingen zijn uitgeschakeld.\n\nGa naar Instellingen > Galarm > Meldingen en schakel "Waarschuwingen", "Geluiden" en "Banners" in.',
  alarmWillNotRingDueToCriticalAlertsDisabledIos:
    'Alarmen gaan niet af als de telefoon is gedempt omdat kritieke waarschuwingen zijn uitgeschakeld.\n\nGa naar Instellingen > Galarm > Meldingen en schakel "Kritieke waarschuwingen" in.',
  alarmWillNotRingDueToNotificationsDisabledAndroid:
    'Het alarm verschijnt niet op het scherm omdat meldingen zijn uitgeschakeld.\n\nTik op "Inschakelen", selecteer "Meldingen" en sta meldingen toe.',
  noNotificationsScheduledAlarmInPast:
    'Het alarm is verleden tijd. Er zijn geen meldingen gepland.',
  alarmOverAllowedLimit: {
    zero: '\nU hebt uw alarmlimiet van {{limit}} alarmen bereikt.\n\nVerwijder een bestaand alarm of gebruik het opnieuw.',
    one: 'U hebt uw alarmlimiet van {{limit}} alarmen bereikt.\n\nU hebt 1 inactief alarm dat u kunt verwijderen of hergebruiken.',
    other:
      'U hebt uw alarmlimiet van {{limit}} alarmen bereikt.\n\nU hebt {{count}} inactieve alarmen die u kunt verwijderen of hergebruiken.'
  },
  alarmAlreadyConfirmed: 'Je hebt het al bevestigd.',
  alarmAlreadyDeclined: 'Je hebt al geweigerd.',
  participantMovedToPosition: '{{name}} verplaatst naar positie {{count}}.',
  memberIsFirstParticpant: '{{name}} is de eerste deelnemer.',
  memberIsLastParticpant: '{{name}} is de laatste deelnemer.',
  cantContinueWithRegistrationWhenOffline:
    'Kan niet doorgaan met registreren omdat apparaat offline is.',
  cantContinueWithRegistrationWhenOfflineWithTryAgain:
    'Kan niet doorgaan met registreren omdat het apparaat offline is. Zorg ervoor dat je verbinding hebt met het internet.',
  confirmBlockContact:
    'U zult geen alarmen meer ontvangen van {{name}}. Doorgaan?',
  confirmUnblockContact:
    'Door {{name}} te deblokkeren, worden geblokkeerde alarmen ook hersteld. Doorgaan?',
  unblockingContact: '{{name}} deblokkeren en alarmen herstellen.',
  unableToUnblockContact: 'Kan het contact niet deblokkeren. {{error}}',
  blockingContact: 'Blokkeren {{name}}.',
  unableToBlockContact: 'Kan contact niet blokkeren. {{error}}',
  cantAddContactToAlarmBecauseBlocked:
    'Je hebt {{name}} geblokkeerd. Deblokkeer ze om ze toe te voegen als deelnemer aan het alarm.',
  cantAddContactToGroupBecauseBlocked:
    'Je hebt {{name}} geblokkeerd. Deblokkeer ze om ze toe te voegen als lid van de groep.',
  sendMessageNotAllowedForPastAlarms:
    'Berichten kunnen niet worden verzonden voor inactieve alarmen.',
  nameIsRequired: 'Naam is vereist.',
  confirmDisableGroupAlarm:
    'Als je het groepsalarm uitschakelt, wordt het alarm ook voor andere deelnemers uitgeschakeld. Doorgaan?',
  removeMemberFromGroup: 'Wil je {{name}} uit deze groep verwijderen?',
  leaveGroupConfirm: 'Wil je deze groep verlaten?',
  deviceOffline:
    'Apparaat is offline. Zorg ervoor dat je verbinding hebt met het internet en probeer het opnieuw.',
  mustBeOnlineForEnhancedAutoSnoozeCount:
    'Je moet online zijn om een alarm op te slaan met een sluimerstand hoger dan 2.',
  cantUpdateTimezoneForAllAlarms:
    'Tijdzone voor bestaande alarmen kan niet worden bijgewerkt',
  cantUpdateRingtonesForAllAlarms:
    'Kan de geluids- en trilinstellingen voor bestaande alarmen niet bijwerken',
  cantUpdateGroupDefaulConfigWhenOffline:
    'De gewijzigde groepsconfiguratie wordt niet toegepast op toekomstige alarmen omdat het apparaat offline is.',
  specifyFeedback: 'Feedback is vereist.',
  specifyEmailId: 'E-mailadres is vereist.',
  specifyValidEmailId: 'E-mailadres is ongeldig.',
  specifyProblem: 'Probleembeschrijving is vereist.',
  appInstalledUsingSameNumberOnDifferentPhone:
    'U hebt Galarm op een ander apparaat geïnstalleerd met hetzelfde nummer. De app op dit apparaat is gereset.',
  invalidUid:
    'Dit gebruikersaccount bestaat niet meer. De Galarm-app op dit apparaat is gereset.',
  accountDeleted: 'Je account is verwijderd.',
  deleteAccount: 'Mijn account verwijderen',
  deletingAccount: 'Je account verwijderen',
  howCanWeImprove:
    'We vinden het jammer dat je weggaat. Hoe kunnen we verbeteren?',
  noMusicAlert: 'Geen muziekbestanden gevonden.',
  noLongerAvailableMusic:
    '{{fileName}} is niet langer beschikbaar. Ringtone is gewijzigd in {{defaultRingtoneName}}',
  userInactiveTitle: 'Welkom terug!',
  userInactiveMessage:
    'Maak alarmen aan voor belangrijke dingen en mis ze nooit.',
  createAlarm: 'Alarm maken',
  updatedAppAvailable: 'Er is een nieuwe versie van de app beschikbaar.',
  alarmOccurrenceDisabled: 'Uitgeschakeld voor dit voorval',
  ownAlarmOccurrenceDone: {
    zero: 'Gemarkeerd op {{timeString}}',
    one: 'Gemarkeerd op {{timeString}} op {{dateString}}'
  },
  ownAlarmOccurrenceSkipped: {
    zero: 'Overgeslagen bij {{timeString}}',
    one: 'Overgeslagen op {{timeString}} op {{dateString}}'
  },
  enabledAlarmsCount: {
    one: '1 alarm ingeschakeld.',
    other: '{{count}} alarmen ingeschakeld.'
  },
  enabledAndNotEnabledAlarmsCount: {
    one: '1 alarm ingeschakeld. Alarmen zonder toekomstige gebeurtenissen blijven uitgeschakeld.',
    other:
      '{{count}} alarmen ingeschakeld. Alarmen zonder toekomstige gebeurtenissen blijven uitgeschakeld.'
  },
  disabledAlarmsCount: {
    one: '1 alarm uitgeschakeld.',
    other: '{{count}} alarmen uitgeschakeld.'
  },
  ownAlarmOccurrenceUnacknowledged: 'Niet gereageerd',
  participantAlarmOccurrenceDone: {
    zero: 'Gemarkeerd door {{participantName}} op {{timeString}}',
    one: 'Gemarkeerd door {{participantName}} op {{timeString}} op {{dateString}}'
  },
  participantAlarmOccurrenceSkipped: {
    zero: 'Overgeslagen door {{participantName}} op {{timeString}}',
    one: 'Overgeslagen door {{participantName}} op {{timeString}} op {{dateString}}'
  },
  participantAlarmOccurrenceUnacknowledged:
    '{{participantName}} reageerde niet',
  groupAlarmOccurrenceConfirmed: {
    zero: 'Bevestigd op {{timeString}}',
    one: 'Bevestigd op {{timeString}} op {{dateString}}'
  },
  groupAlarmOccurrenceDeclined: {
    zero: 'Afgewezen op {{timeString}}',
    one: 'Afgewezen op {{timeString}} op {{dateString}}'
  },
  warning: 'Waarschuwing',
  info: 'Info',
  confirm: 'Bevestig',
  error: 'Fout',
  cantUploadImage: 'Kan geen afbeelding uploaden',
  cantDeleteImage: 'Kan afbeelding niet verwijderen',
  cantEditGroup: 'Kan groep niet bewerken',
  cantAddNewContact: 'Kan geen nieuw contact toevoegen',
  cantDeleteContact: 'Kan contact niet verwijderen',
  cantEditContact: 'Kan contact niet bewerken',
  cantSaveAlarm: 'Kan alarm niet redden',
  cantSaveGroup: 'Kan groep niet opslaan',
  cantReloadContacts: 'Contacten kunnen niet opnieuw worden geladen',
  cantTakePhoto: 'Kan geen foto nemen',
  cantExportToCalendar: 'Kan niet exporteren naar kalender',
  cantOpenPhotoLibrary: 'Kan fotobibliotheek niet openen',
  cantDeleteAlarmHistory: 'Kan de alarmgeschiedenis niet verwijderen',
  cannotDuplicateAlarm: 'Kan alarm niet dupliceren',
  upgradeToPremiumToDuplicateAlarm:
    'Upgrade naar Premium om meer groeps- en buddyalarmen te maken.',
  confirmAcceptAlarm: 'Alarm accepteren?',
  confirmRejectAlarm: 'Alarm weigeren?',
  deleteAlarm: 'Alarm verwijderen?',
  restoreAlarmConfirmation: 'Alarm herstellen?',
  respondToRepeatingAlarm: {
    zero: 'U bent toegevoegd als ontvanger van alarm {{alarmName}} door {{alarmCreatorName}}. U wordt gealarmeerd op {{alarmTimeString}} {{alarmRepetitionString}} vanaf {{alarmDateString}}',
    one: 'U bent toegevoegd als deelnemer aan alarm {{alarmName}} door {{alarmCreatorName}}. U wordt gealarmeerd op {{alarmTimeString}} {{alarmRepetitionString}} vanaf {{alarmDateString}}'
  },
  respondToOneTimeAlarm: {
    zero: 'U bent toegevoegd als ontvanger van alarm {{alarmName}} door {{alarmCreatorName}}. U wordt gealarmeerd op {{alarmTimeString}} {{alarmDateString}}',
    one: 'U bent toegevoegd als deelnemer aan alarm {{alarmName}} door {{alarmCreatorName}}. U wordt gealarmeerd op {{alarmTimeString}} {{alarmDateString}}'
  },
  cantMoveMemberUp: 'Kan {{name}} niet omhoog bewegen',
  cantMoveMemberDown: 'Kan niet bewegen {{name}} Omlaag',
  decline: 'Weigeren',
  cantEditProfile: 'Kan profiel niet bewerken',
  cantSelectContact: 'Kan geen contact selecteren',
  cantSendMessage: 'Kan bericht niet verzenden',
  cantSendVerificationCode: 'Kan verificatiecode niet verzenden',
  confirmBlockContactTitle: 'Blok contact bevestigen',
  confirmUnblockContactTitle: 'Contact deblokkeren bevestigen',
  cantSaveProfile: 'Kan profiel niet opslaan',
  cantBlockContact: 'Contact niet blokkeren',
  cantUnblockContact: 'Contact deblokkeren lukt niet',
  cantLoadEarlierMessages: 'Kan eerdere berichten niet laden',
  cantRestoreAlarm: 'Kan het alarm niet herstellen',
  cantSendFeedback: 'Kan geen feedback geven',
  cantSubmitProblem: 'Kan niet indienen probleem',
  cantDeletePastAlarmsInBulk: 'Kan inactieve alarmen niet in bulk verwijderen',
  cantAddNewGroup: 'Kan geen nieuwe groep toevoegen',
  alreadySnoozing: 'Al aan het dutten',
  markAlarmUndone:
    "Je hebt dit alarm gemarkeerd als 'Gedaan' {{durationString}} ago. Ongedaan maken?",
  markAlarmUnskipped:
    'Je hebt dit alarm {{durationString}} geleden overgeslagen. Ongedaan maken?',
  cantUndo: 'Kan niet ongedaan maken',
  fetchMusicFromPhone: 'Beschikbare muziek vinden.',
  enableAllAlarmsInCategory: 'Alle alarmen in deze categorie inschakelen?',
  disableAllAlarmsInCategory: 'Alle alarmen in deze categorie uitschakelen?',
  allAlarmsAlreadyEnabled:
    'Alle alarmen in deze categorie zijn al ingeschakeld.',
  allAlarmsAlreadyDisabled:
    'Alle alarmen in deze categorie zijn al uitgeschakeld.',
  time: 'Tijd',
  timeForBuddy: 'Tijd voor Buddy',
  timeForYou: 'Herinner me aan',
  name: 'Naam',
  title: 'Titel',
  notes: 'Opmerkingen',
  repeat: 'Herhaal',
  preReminder: 'Herinnering vooraf',
  remove: 'Verwijder',
  considerEventsEndingWith: 'Stel alarmen in voor evenementen die eindigen met',
  considerEventsContaining: 'Stel alarmen in voor evenementen die bevatten',
  eventsEndingWith: 'Evenementen die eindigen met',
  eventsContaining: 'Evenementen die bevatten',
  preReminderShortAlert: '{{duration}} Herinnering vooraf',
  preReminderTitle: '{{alarmName}} op {{date}}',
  preReminderGroupHelperText:
    'Deze herinnering is alleen voor jou. Andere deelnemers aan het alarm kunnen hun eigen herinneringen instellen zodra ze het alarm ontvangen.',
  addPreReminder: 'Herinnering toevoegen',
  helperTextForPreReminder:
    'Tik op de resetknop bovenaan om de herinnering te verwijderen.',
  edit: 'Bewerk',
  delete: 'Verwijder',
  creator: 'Schepper',
  useAsDefaultGroupConfiguration: 'Toepassen op toekomstige alarmen',
  done: 'Gedaan',
  selectAll: 'Alles selecteren',
  skipped: 'Overgeslagen',
  save: 'Opslaan',
  members: 'Leden',
  mobileNumber: 'Telefoonnummer',
  enter: 'Ga naar',
  addMembers: 'Leden toevoegen',
  respond: 'Reageer op',
  yes: 'Ja',
  no: 'Geen',
  notAvailable: 'Niet beschikbaar',
  cancel: 'Annuleren',
  participants: 'Deelnemers',
  takePhoto: 'Foto maken',
  chooseFromLibrary: 'Kies uit bibliotheek',
  resendCode: 'Code opnieuw verzenden',
  register: 'Registreer',
  inviteFriends: 'Deze app delen',
  invite: 'Uitnodigen',
  incorrectNumber: 'Verkeerd nummer?',
  date: 'Datum',
  cascadingAlarmInterval: 'Tijd tussen deelnemerswaarschuwingen',
  ringParticipantAlarmsByDefault: 'Alarmbellen zonder te accepteren',
  alarmRingtone: 'Alarm Beltoon',
  pickASong: 'Kies muziek van de telefoon',
  privacyPolicy: 'Privacybeleid',
  sendFeedback: 'Feedback',
  galarmWeb: 'Galarm Web',
  galarmEnterprise: 'Galarm Pro',
  galarmAdmin: 'Galarm Admin',
  troubleshooting: 'Problemen oplossen',
  alarmDidntRingHelp: 'Help! Mijn wekker is niet afgegaan',
  autoStartSettingHelperText:
    'Als uw telefoon een auto-start instelling heeft, zorg er dan voor dat auto-start is ingeschakeld voor Galarm.',
  batteryOptimizationHelperText:
    'Batterijoptimalisatie uitschakelen voor Galarm',
  troubleshootingHelperText:
    'De volgende instellingen kunnen voorkomen dat alarmen afgaan zoals verwacht. Controleer deze instellingen.',
  getMoreHelpText: 'Heb je nog steeds problemen?',
  autoStartSetting: 'Autostart',
  batteryOptimization: 'Batterij optimaliseren',
  battery: 'Batterij',
  rateTheAppSettings: 'Beoordeel deze app',
  about: 'Over & Hulp',
  leaveGroup: 'Groep verlaten',
  removeGroup: 'Groep verwijderen',
  viewMember: 'Bekijk {{memberName}}',
  removeMember: 'Verwijder {{memberName}}',
  changeMemberState: 'Wijzigen wie kan waarschuwen {{memberName}}',
  changeYourGroupState: 'Wijzig wie u kan waarschuwen',
  numMembersInGroup: 'Leden: {{count}}',
  notifications: 'App-meldingen zijn uitgeschakeld',
  backgroundAppRefresh: 'Vernieuwen van app op achtergrond is uitgeschakeld',
  groupsInCommon: 'Gemeenschappelijke groepen',
  alarmsInCommon: 'Algemene alarmen',
  close: 'Sluit',
  responsePending: 'Uw reactie?',
  later: 'Later',
  install: 'Installeer',
  all: 'Alle',
  numYears: {
    one: '1 jaar',
    other: '{{count}} jaren'
  },
  numMonths: {
    one: '1 maand',
    other: '{{count}} maanden'
  },
  numDays: {
    one: '1 dag',
    other: '{{count}} dagen'
  },
  hours: {
    one: '1 uur',
    other: '{{count}} uren'
  },
  minutes: {
    one: '1 minuut',
    other: '{{count}} minuten'
  },
  seconds: {
    one: '1 seconde',
    other: '{{count}} seconden'
  },
  minutesSmall: '{{count}} min',
  secondsSmall: '{{count}} sec',
  hoursAfter: {
    one: '1 uur na',
    other: '{{count}} uren na'
  },
  minutesAfter: {
    one: '1 minuut na',
    other: '{{count}} minuten na'
  },
  hoursAfterBuddy: {
    one: '1 uur na buddy',
    other: '{{count}} uren na buddy'
  },
  minutesAfterBuddy: {
    one: '1 minuut na buddy',
    other: '{{count}} minuten na buddy'
  },
  longerThanAnHour: '> 1 uur',
  licenses: 'Licenties van derden',
  version: 'Versie',
  termsOfService: 'Servicevoorwaarden',
  showPrivacyPolicy: '> Privacybeleid',
  showTermsOfService: '> Servicevoorwaarden',
  showLicenses: '> Licenties van derden',
  change: 'Verander',
  snooze: 'Snooze',
  somethingWentWrong: 'Er is iets misgegaan. Vernieuw de pagina alstublieft.',
  ringOnVibrate: 'Ring op Stil',
  vibrate: 'Trillen',
  ringOnEarphoneOnly: 'Belalarm alleen op oortelefoon',
  ringOnSpeakerAndEarphone: 'Belalarm op luidspreker en oortelefoon',
  whenEarphoneIsConnected: 'Wanneer de oortelefoon is aangesloten',
  tapGesture: 'Tik op',
  slideGesture: 'Dia',
  silent: 'Stille',
  volume: 'Volume',
  soundAndVibration: 'Geluid en trillingen',
  advancedSettings: 'Geavanceerde instellingen',
  gestureToDismissAnAlarm: 'Gebaar om een alarm af te zetten',
  someNotificationsAreMuted: 'Sommige meldingen zijn gedempt',
  allNotificationsEnabled: 'Alle meldingen zijn ingeschakeld',
  notificationSettings: 'Instellingen meldingen',
  missedAlarmsPlacement: 'Plaatsing van gemiste alarmen',
  missedAlarmsPlacementTooltipMessage:
    'Kies waar gemiste alarmen in je alarmlijst verschijnen.',
  showMissedAlarmsOnTop: 'Bovenaan weergeven',
  showMissedAlarmsAfterUpcoming: 'Weergeven na aankomende alarmen',
  showMissedAlarmsNotification: 'Melding bovenaan weergeven',
  hideMissedAlarms: 'Gemiste alarmen niet weergeven',
  galarmWebNotifications: 'Galarm Web Meldingen',
  alarmsfromOthersNotifications: 'Deelnemersalarmen Meldingen',
  sharedAlarmNotifications: 'Gedeelde alarmmeldingen',
  alarmChatNotifictions: 'Alarm-chatmeldingen',
  groupNotifications: 'Groepsmeldingen',
  alarmAcknowledgementNotifications: 'Alarmbevestigingsmeldingen',
  send: 'Stuur',
  prev: 'Vorige',
  snoozing: '{{timeString}}',
  snoozingStatus: 'Sluimeren',
  specifySnoozeDuartion: 'Duur van sluimerstand opgeven',
  chooseDifferentDuration: 'Kies een andere duur',
  noCalendarsFound: 'Geen kalenders gevonden op het apparaat.',
  eventWillEndAt: 'Het evenement eindigt op {{timeString}}.',
  selectDurationWithinTheSameDay:
    'Het evenement kan de daggrens niet overschrijden.',
  cannotMapRepeatTypeInTheDeviceCalendar:
    'Kan niet "Exporteren naar kalender" omdat de instelling "Herhalen" van je wekker niet wordt ondersteund door de kalender.',
  alarmSavedToCalendar: 'Het alarm is succesvol opgeslagen in de kalender.',
  faq: 'Veelgestelde vragen',
  searchingFaqs: 'Zoeken naar gerelateerde helpartikelen...',
  faqsMayHelp:
    'We hebben enkele helpartikelen gevonden die uw vraag kunnen beantwoorden:',
  noFaqsFound: 'Geen gerelateerde helpartikelen gevonden.',
  sendFeedbackAnyway: 'Feedback toch verzenden',
  editFeedback: 'Feedback bewerken',
  submitProblemAnyway: 'Probleem toch indienen',
  editProblem: 'Probleem bewerken',
  openSettings: 'Instellingen openen',
  openAppSettings: 'App-instellingen openen',
  alreadyDone: 'Gedaan',
  enableAutoStart: 'Automatisch opstarten inschakelen',
  restrictedApps: 'Beperkte apps',
  unmonitoredApps: 'Onbewaakte apps',
  enableProtected: 'Beschermde apps',
  manageAppLaunch: 'De lancering van apps beheren',
  unblockContact: 'Contact deblokkeren',
  blockContact: 'Contactpersoon blokkeren',
  call: 'Bel {{name}}',
  text: 'Tekst {{name}}',
  chat: 'Chat',
  ok: 'OK',
  stopSnooze: 'Snooze stoppen',
  emailId: 'Uw e-mailadres',
  feedback: 'Feedback',
  submit: 'Stuur  in',
  reportAProblem: 'Een probleem melden',
  enableAlarm: 'Alarm inschakelen',
  restoreAlarm: 'Herstel alarm',
  deletePastAlarms: 'Inactieve alarmen verwijderen',
  accept: 'Accepteer',
  defaultPersonalAlarmName: 'Persoonlijke herinnering',
  defaultGroupAlarmName: 'Groepsevenement',
  defaultRecipientAlarmName: 'Buddy Alarm',
  search: 'Zoek op',
  recent: 'Recent',
  upcoming: 'Komende',
  missed: 'Gemist',
  expired: 'Gemist',
  past: 'Verleden',
  active: 'Actief',
  inactive: 'Inactief',
  allAlarms: 'Alle alarmen',
  myAlarms: 'Mijn alarmen',
  participantAlarms: 'Deelnemersalarmen',
  pendingParticipantAlarms: 'Nieuwe alarmen van anderen',
  alarmsWithUnreadChatMessages: 'Alarmen met nieuwe chat',
  systemNotifications: 'Systeemberichten',
  missedAlarms: 'Gemiste alarmen',
  missedAlarmsInCategory: '{{name}} Gemiste alarmen',
  showMissedAlarms: 'Gemiste alarmen weergeven',
  recentlyDeletedAlarms: 'Onlangs verwijderde alarmen',
  searchAlarms: 'Alarmen zoeken',
  searchTasks: 'Taken zoeken',
  startTypingToSearchTasks: 'Begin met typen om taken te zoeken',
  noTasksFoundForSearch:
    'Geen taken gevonden die overeenkomen met "{{searchText}}"',
  participant: 'Deelnemer',
  you: 'U',
  none: 'Geen',
  onceOnly: 'Eenmalig',
  weekdays: 'Weekdagen',
  weekends: 'Weekenden',
  everyDayString: 'Dagelijks',
  everySunday: 'Elke zondag',
  everyMonday: 'Elke maandag',
  everyTuesday: 'Elke dinsdag',
  everyWednesday: 'Elke woensdag',
  everyThursday: 'Elke donderdag',
  everyFriday: 'Elke vrijdag',
  everySaturday: 'Elke zaterdag',
  sunday: 'Zondag',
  monday: 'Maandag',
  tuesday: 'Dinsdag',
  wednesday: 'Woensdag',
  thursday: 'Donderdag',
  friday: 'Vrijdag',
  saturday: 'Zaterdag',
  january: 'Januari',
  february: 'Februari',
  march: 'Maart',
  april: 'April',
  may: 'Mei',
  june: 'Juni',
  july: 'Juli',
  august: 'Augustus',
  september: 'September',
  october: 'Oktober',
  november: 'November',
  december: 'December',
  jan: 'Jan',
  feb: 'Feb',
  mar: 'Mar',
  apr: 'Apr',
  shortMay: 'Mei',
  jun: 'Jun',
  jul: 'Jul',
  aug: 'Aug',
  sep: 'Sep',
  oct: 'Okt',
  nov: 'Nov',
  dec: 'Dec',
  sun: 'Zo',
  mon: 'Ma',
  tue: 'Di',
  wed: 'Wo',
  thu: 'Do',
  fri: 'Vr',
  sat: 'Za',
  first: '1e',
  second: '2e',
  third: '3e',
  fourth: '4e',
  fifth: '5e',
  every: 'Elke',
  oddNumberedDays: 'Oneven genummerde data',
  evenNumberedDays: 'Even genummerde data',
  noParticipants: 'Geen deelnemers',
  typeYourMessage: 'Type je bericht',
  cantPostMessageToPastAlarm:
    'Kan geen bericht plaatsen bij een inactief alarm',
  groupName: 'Groep: {{name}}',
  confirmed: 'bevestigd',
  declined: 'geweigerd',
  Done: 'Gedaan',
  Skip: 'Skip',
  Confirm: 'Bevestig',
  Decline: 'Weigeren',
  Accept: 'Accepteer',
  today: 'vandaag',
  on: 'op',
  recipientAlarm: 'Buddy Alarm',
  recipient: 'Ontvanger',
  remindMeAfter: 'Herinner me eraan',
  remindMeIn: 'Herinner me eraan in',
  newRecipientAlarm: 'Nieuw Buddy Alarm',
  editRecipientAlarm: 'Buddy alarm bewerken',
  newInstantAlarm: 'Nieuw Direct Alarm',
  instantAlarms: 'Directe Alarmen',
  noTaskAlarms: `Geen taakwekkers

Taakwekkers worden ingesteld vanuit taken en takenlijsten.`,
  taskAlarmName: 'Taak: {{alarmName}}',
  noInstantAlarms: `Geen directe alarmen

Directe alarmen kunnen worden gebruikt om een contactpersoon of een groep onmiddellijk te waarschuwen bij noodgevallen of dringende taken.`,
  alarmDone: 'Alarm gemarkeerd als Gereed',
  alarmSkipped: 'Alarm overgeslagen',
  undo: 'Ongedaan maken',
  enterVerificationCode: 'Voer hieronder de 4-cijferige code in:',
  initializing: 'initialiseren',
  tryAgain: 'Probeer het opnieuw',
  nMore: '+ {{count}} meer',
  enableNotification: 'inschakelen',
  enableAlarmNotificationChannel: 'inschakelen',
  enableBackgroundAppRefresh: 'inschakelen',
  viewImpactedAlarms: 'Alarmen',
  viewImpactedGroups: 'Groepen',
  dismiss: 'Ontsla',
  minsInterval: '+ {{count}}m',
  secsInterval: '+ {{count}}s',
  hoursInterval: '+ {{count}}h',
  daysInterval: '+ {{count}}d',
  snoozeUnitHours: 'Uren',
  snoozeUnitMinutes: 'Minuten',
  snoozeUnitDays: 'Dagen',
  selectMinutes: 'Selecteer minuten',
  selectHours: 'Selecteer uren',
  selectDays: 'Selecteer dagen',
  selectHoursAndMinutes: 'Selecteer uren en minuten',
  enterDuration: 'Duur',
  snoozeUnit: 'Eenheid',
  specifySnoozeUnit: 'Sluimereenheid opgeven',
  specifySnoozeDuration: 'Duur van sluimerstand opgeven',
  duration: 'Duur',
  quickAlarmName: {
    zero: '{{minutes}} min herinnering',
    one: '{{hours}} uur herinnering',
    other: '{{hours}} uur {{minutes}} min herinnering'
  },
  alarmTitleForGoogleVoiceTimerCommand: '{{durationString}} herinnering',
  addedAlarmFromVoiceCommand:
    'Een alarm toegevoegd voor {{alarmName}} op {{dateString}}',
  addedTimerFromVoiceCommand: 'Een timer toegevoegd voor {{duration}}',
  clear: 'Duidelijk',
  ringtoneDuration: 'Ringtone duur',
  chooseDuration: 'Kies een duur. Tik meerdere keren om op te tellen.',
  newAlarm: 'Nieuw alarm',
  quickAlarm: 'Snelle herinnering',
  quickAlarmWillRingAt: 'Het alarm gaat af op {{timeString}}.',
  alarmWithSnoozeAt: 'Het alarm gaat vervolgens af op {{timeString}}',
  preReminderWillRingAt: {
    zero: 'Er gaat een herinnering af voor dit alarm \nop {{timeString}}.',
    one: 'Een herinnering voor dit alarm gaat \nop {{timeString}} de vorige dag.',
    other:
      'Een herinnering voor dit alarm gaat af \nop {{timeString}} {{count}} dagen van tevoren.'
  },
  random: 'Willekeurig',
  enableAllAlarms: 'Alle alarmen inschakelen',
  disableAllAlarms: 'Alle alarmen uitschakelen',
  deleteAllAlarms: 'Alle alarmen verwijderen',
  hideCategory: 'Verberg categorie',
  unhideCategory: 'Categorie weergeven',
  dontShowHiddenCategories: 'Verborgen categorieën niet weergeven',
  showHiddenCategories: 'Verborgen categorieën weergeven',
  welcomeAlarmsTitle: 'Laten we beginnen!',
  welcomeAlarmsMessage: 'Hier zijn enkele veelgebruikte alarmen:',
  onboardingAlarms: 'Alarmen bij het inwerken',
  hiddenAlarmCategories: 'Verborgen categorieën',
  restorePurchases: 'Aankopen herstellen',
  noAvailablePurchasesFound:
    'Geen beschikbare aankopen gevonden voor je account.\n\nStuur ons een feedback via "Instellingen > Feedback" als je een geldige aankoop hebt die je niet kunt herstellen.',
  restoringPurchases: 'Aankopen herstellen',
  fetchingContacts: 'Controleren welke contactpersonen Galarm gebruiken',
  enterNameAndUploadPhotoForUser:
    'Voer hieronder je naam in en upload optioneel je profielfoto',
  enterNameAndUploadPhotoForGroup:
    'Voer hieronder een naam in en upload optioneel een groepsfoto',
  noContactsWithAppInstalled: 'Niemand in je contacten gebruikt Galarm.',
  galarmContacts: {
    one: '1 Galarm contact',
    other: '{{count}} Galarm contacten'
  },
  contactsPendingInvitation: {
    one: '1 in afwachting van uitnodiging',
    other: '{{count}} in afwachting van uitnodigingen'
  },
  otherContacts: {
    one: '1 ander contact',
    other: '{{count}} andere contacten'
  },
  over100Contacts: 'Meer dan 100 andere contacten',
  noAlarms: 'Je hebt geen alarmen. Tik op + om een nieuw alarm toe te voegen.',
  noContactsWeb: {
    one: 'We hebben geen contactpersonen gevonden die Galarm gebruiken. Of we hebben geen toegang tot je contacten of niemand in je contacten gebruikt Galarm. Je kunt je contacten synchroniseren via de mobiele app.\n\nU kunt contacten die Galarm gebruiken op verschillende manieren toevoegen aan uw alarmen om te profiteren van de app',
    other:
      'Registreer je op de mobiele app om te beginnen met het toevoegen van contacten aan je alarmen.'
  },
  viewingAlarmsInCommon: 'Alarmen gemeen met {{name}}',
  viewingGroupsInCommon: 'Groepen gemeen met {{contactName}}',
  changeGroupMemberConfigTextForCascadingAlarm:
    'Actieve deelnemers worden gewaarschuwd in de weergegeven volgorde.',
  changeGroupMemberConfigTextForSimultaneousAlarm:
    'Alleen actieve deelnemers worden gewaarschuwd.',
  changeGroupMemberStateText: {
    zero: 'Wijzig de leden die je kunnen waarschuwen wanneer er een alarm wordt aangemaakt voor de groep "{{groupName}}".\n\nU wordt alleen gewaarschuwd als het alarm is aangemaakt door toegestane leden.',
    one: 'Wijzig de leden die {{memberName}} kunnen waarschuwen wanneer er een alarm wordt aangemaakt voor de groep "{{groupName}}".\n\n{{memberName}} wordt alleen gewaarschuwd als het alarm is aangemaakt door toegestane leden.'
  },
  allowed: 'Toegestaan',
  notAllowed: 'Niet toegestaan',
  changeStatus: 'Toegestane leden',
  noUpcomingAlarms: 'Geen aankomende alarmen',
  showMore: 'Meer tonen',
  nMorePastAlarms: {
    one: '1 meer inactief alarm',
    other: '{{count}} meer inactieve alarmen'
  },
  shareAppMessage:
    'Ik krijg al mijn dingen op tijd gedaan door herinneringen voor ze te maken met de Galarm-app. Via deze app kunnen we ook elkaar opnemen in onze herinneringen. Ik raad je aan om deze innovatieve alarm- en herinneringsapp te downloaden. {{downloadLink}}',
  addingMembers: 'Leden toevoegen.',
  unableToAddMembers: 'Kan geen leden toevoegen. {{error}}',
  removingMember: 'Lid verwijderen.',
  unableToRemoveMember: 'Kan lid niet verwijderen. {{error}}',
  leavingGroup: 'Groep verlaten.',
  unableToLeaveGroup: 'Kan groep niet verlaten. {{error}}',
  expiredPersonalAlarmForCreator: {
    zero: 'Dit alarm is {{durationString}} geleden verlopen. Tik op "Gereed" om het alarm te voltooien.',
    one: 'Dit alarm is {{durationString}} geleden verlopen. Tik op "Gereed" om het alarm te voltooien en deelnemers op de hoogte te stellen.',
    other:
      'Dit alarm is {{durationString}} geleden verlopen. Tik op "Gereed" om het alarm te voltooien en deelnemers op de hoogte te stellen.'
  },
  donePersonalAlarmForCreator:
    'Dit alarm is {{durationString}} geleden verlopen. Het alarm is gemarkeerd als gereed.',
  skippedPersonalAlarmForCreator:
    'Dit alarm is {{durationString}} geleden verlopen. U hebt het alarm overgeslagen.',
  expiredGroupAlarm:
    'Dit alarm is {{durationString}} geleden verlopen. Bevestig uw deelname.',
  expiredPersonalAlarmForParticipant:
    'Dit alarm is {{durationString}} geleden verlopen. Herinner {{creatorName}}.',
  alarmDurationAndroid: 'Wekker ingesteld op {{durationString}} vanaf nu.',
  alarmDurationIos: 'Wekker ingesteld op {{durationString}} vanaf nu.',
  alarmFeedbackHeader:
    'U zult een deel van de informatie van dit alarm verzenden voor debugdoeleinden. Persoonlijke gegevens zoals de naam van het alarm, opmerkingen of deelnemers worden niet gedeeld.',
  privacyPolicyHeader:
    "Respect voor je privacy tikt voortdurend aan in onze klokken. Net als jij hechten we veel waarde aan privacy, dus we willen dat je weet dat we je persoonlijke gegevens met niemand delen, tenzij dit nodig is voor het installeren van de applicatie of wanneer dit wettelijk verplicht is. In alle gevallen verkopen we je informatie nooit. Zo simpel is het!\n \nDe alarmen die je aanmaakt zijn alleen zichtbaar op jouw apparaat en, als een alarm andere deelnemers omvat, op de apparaten van die deelnemers.\n \nWe hebben alleen toegang tot het adresboek/contactlijst van uw telefoon om het tabblad Contacten in Galarm te vullen. We slaan die lijst niet op voor andere doeleinden. We respecteren dat het uw adresboek is!\n \nWe hebben alleen toegang tot je camera en foto's om je in staat te stellen een goede profielfoto in te stellen. Deze foto verschijnt als je avatar of als profielfoto van een groep die je bewerkt. Andere Galarm-gebruikers die lid zijn van alarmen die je hebt ingesteld kunnen deze foto zien.\n\nWe sturen het publieke IP-adres en de unieke ID van uw apparaat mee met alle verzoeken, bijvoorbeeld tijdens het aanvragen en verifiëren van de code tijdens het registratieproces. Deze informatie is niet gekoppeld aan je account en wordt alleen gebruikt om mogelijke kwaadaardige activiteiten vast te stellen.\n \nBekijk het volledige privacybeleid voor meer informatie over de informatie die we verzamelen en hoe we deze gebruiken.",
  termsOfServiceHeader:
    'Door de Galarm-app te gebruiken gaat u akkoord met onze Servicevoorwaarden, die van toepassing zijn op uw toegang tot en gebruik van deze mobiele app en de functies en services die deze biedt. \n\nHet motto van Galarm is eenvoudig -- u helpen om nooit een gebeurtenis te missen!  Of het nu gaat om het instellen van persoonlijke alarmen om wakker te worden, op tijd te zijn voor afspraken en herinneringen in te stellen voor activiteiten zoals het op tijd innemen van medicijnen, of het maken van groepsalarmen voor het organiseren van groepsactiviteiten zoals bioscoopuitjes, sportevenementen en feestjes, Galarm maakt het mogelijk om een sociale wekker te hebben om elkaar eraan te herinneren, elkaars status te volgen en met elkaar te communiceren.\n\nGebruik Galarm alleen als u akkoord gaat met deze voorwaarden. Hieronder vind je er een link naar.',
  acknowledgedPersonalAlarm:
    'Je hebt het alarm gemarkeerd als "Gereed" {{durationString}} geleden.',
  skippedPersonalAlarm:
    'Je hebt het alarm {{durationString}} geleden overgeslagen.',
  authenticatingWithServer: 'Aansluiten...',
  selectParticipantsForPersonalAlarm:
    'Selecteer een groep of een aantal mensen die als back-up dienen voor je persoonlijke alarm.',
  selectParticipantsForGroupAlarm:
    'Selecteer een groep of een groep mensen voor je groepsactiviteit.',
  acknowledgedGroupAlarm:
    'Je {{acknowledgedAsString}} dit alarm {{durationString}} geleden.',
  acknowledgedExpiredGroupAlarm:
    'Dit alarm is {{durationString}} geleden verlopen. U {{acknowledgedAsString}} dit alarm.',
  acknowledgedPersonalAlarmForParticipant:
    '{{creatorName}} markeerde het alarm "Gereed" {{durationString}} geleden.',
  acknowledgedExpiredPersonalAlarmForParticipant:
    'Dit alarm is {{durationString}} geleden verlopen. {{creatorName}} heeft het alarm gemarkeerd als "Gereed".',
  entityNotFound:
    'Oeps! We konden de geselecteerde {{entityType}} niet vinden. Mogelijk zijn we er nog mee bezig of is het verwijderd.',
  goBack: 'Ga terug',
  uploadingImageToServer: 'Afbeelding uploaden naar server.',
  deletingImageFromServer: 'Afbeelding van server verwijderen',
  errorUploadingImageToServer:
    'Fout bij het uploaden van de afbeelding naar de server. Probeer het later opnieuw.',
  unableToRemoveGroup: 'Kan groep niet verwijderen. {{error}}',
  addingGroup: 'Groep toevoegen.',
  editingGroup: 'Bewerkingsgroep.',
  unableToAddGroup: 'Kan groep niet toevoegen. {{error}}',
  unableToEditGroup: 'Kan groep niet bewerken. {{error}}',
  thanksForFeedback: 'Bedankt dat je ons helpt te verbeteren.',
  licensesHeader:
    'Galarm bevat software onder licentie van derden. Zie onze pagina Licenties van derden voor bijbehorende informatie over toeschrijving en licenties.',
  alarmAlreadyInSnooze: 'Je wordt eraan herinnerd in {{durationString}}.',
  carrierChargesMayApply: 'Er kunnen transportkosten van toepassing zijn.',
  verficationCodeInfo:
    'Je ontvangt een sms of telefoontje met een code van 4 cijfers.',
  verficationCodeInfoWhatsApp:
    'Je ontvangt een WhatsApp-bericht met een code van 4 cijfers.',
  selectCascadingInterval:
    'De eerste deelnemer wordt {{firstParticipantDurationString}} na de alarmtijd gewaarschuwd, de tweede deelnemer {{secondParticipantDurationString}} na de alarmtijd enzovoort als je het alarm niet als gedaan markeert.',
  reorderParticipantsScreenDescription:
    'Deelnemers worden gewaarschuwd in de weergegeven volgorde.',
  noMembers: 'Geen leden',
  selectedGroupDescription: {
    zero: '{{numActiveMembers}} deelnemers',
    one: '{{numActiveMembers}} actieve en {{numInactiveMembers}} inactieve deelnemer',
    other:
      '{{numActiveMembers}} actieve en {{numInactiveMembers}} inactieve deelnemers'
  },
  groupAlarmWillRingAtSameTime:
    'Alle deelnemers worden gewaarschuwd op {{timeString}}.',
  welcomeToGalarm: 'Welkom bij Galarm',
  checkingConnection: 'Verbinding controleren',
  deletePastAlarmsTitle: 'Inactieve alarmen ouder dan',
  deletePastAlarmsOption: {
    zero: '{{option}} (0 alarmen)',
    one: '{{option}} (1 alarm)',
    other: '{{option}} ({{count}} alarmen)'
  },
  deletePastAlarmsNotificationMessage:
    'U hebt verschillende inactieve alarmen. Verwijder de alarmen die u niet langer nodig hebt.',
  chooseSnoozeInterval: 'Herinner me er nog eens aan in',
  personalAlarmDescription:
    'Gebruik een persoonlijk alarm om wakker te worden, medicijnen in te nemen of een andere taak voor jezelf uit te voeren. Je kunt optioneel deelnemers toevoegen die worden gewaarschuwd als je een alarm mist, zodat ze je eraan kunnen herinneren. De deelnemers krijgen ook een melding als je het alarm als gedaan markeert.',
  groupAlarmDescription:
    'Gebruik een groepsalarm voor groepsactiviteiten zoals uitstapjes, feestjes of andere evenementen. Het alarm gaat op hetzelfde moment af voor alle deelnemers en zij kunnen hun deelname bevestigen.',
  instantAlarmDescription:
    'Gebruik dit alarm om een contactpersoon of groep contactpersonen te waarschuwen voor een noodoefening, het begin van een spel, een dringende taak/vergadering en andere dergelijke gebeurtenissen die onmiddellijke aandacht vereisen.',
  recipientAlarmDescription:
    'Maak alarmen aan voor iemand anders ("buddy") om ze te herinneren aan dingen die ze moeten doen. U wordt gewaarschuwd om de buddy eraan te herinneren als hij of zij het alarm mist. Je krijgt ook een melding als de buddy het alarm als gedaan markeert.\n  \nMerk op dat de alarmen worden aangemaakt in jouw tijdzone.',
  whatsThis: 'Wat is dit?',
  alarmCurrentlyDisabled: 'Dit alarm is momenteel uitgeschakeld',
  alarmCurrentlyRejected: 'Dit alarm wordt momenteel geweigerd',
  currentlyTypingUsers: {
    one: '{{currentlyTypingUsers}} typt...',
    other: '{{currentlyTypingUsers}} zijn aan het typen...'
  },
  noSearchResultsFound: 'Geen {{type}} gevonden',
  noGroupsCreated: 'Je hebt geen groepen gemaakt.',
  noGroupsWeb: {
    one: 'Je hebt geen groepen gemaakt.',
    other:
      'Registreer je op de mobiele app om te beginnen met het maken van groepen en deze toe te voegen aan alarmen.'
  },
  internalErrorDuringRegistration:
    'Er is een interne fout opgetreden tijdens de gebruikersregistratie. Probeer het opnieuw na een paar minuten',
  selectRecipientAlarmInterval: {
    zero: 'U wordt op hetzelfde moment gewaarschuwd als de ontvanger',
    one: "Je krijgt een waarschuwing op {{durationString}} na de alarmtijd als de ontvanger het alarm niet heeft gemarkeerd als 'Gereed'.",
    other:
      "Je krijgt een waarschuwing op {{durationString}} na de alarmtijd als de ontvanger het alarm niet heeft gemarkeerd als 'Gereed'."
  },
  selectRecipient: 'Selecteer ontvanger',
  acknowledgedExpiredRecipientAlarm:
    'Dit alarm is {{durationString}} geleden verlopen. Je hebt dit alarm gemarkeerd als "Gereed".',
  skippedExpiredRecipientAlarm:
    'Dit alarm is {{durationString}} geleden verlopen. U hebt dit alarm overgeslagen.',
  expiredRecipientAlarm:
    'Dit alarm is {{durationString}} geleden verlopen. Tik op "Gereed" om het alarm te voltooien en {{creatorName}} te waarschuwen.',
  acknowledgedRecipientAlarm:
    'Je hebt dit alarm gemarkeerd als "Gereed" {{durationString}} geleden.',
  skippedRecipientAlarm:
    'Je hebt dit alarm {{durationString}} geleden overgeslagen.',
  acknowledgedExpiredRecipientAlarmForCreator:
    'Dit alarm is {{durationString}} geleden verlopen. {{recipientName}} heeft het alarm gemarkeerd als "Gereed".',
  skippedExpiredRecipientAlarmForCreator:
    'Dit alarm is {{durationString}} geleden verlopen. {{recipientName}} heeft het alarm overgeslagen.',
  expiredRecipientAlarmForCreator:
    'Dit alarm is {{durationString}} geleden verlopen. Herinner {{recipientName}}.',
  acknowledgedRecipientAlarmForCreator:
    '{{recipientName}} markeerde het alarm "Gereed" {{durationString}} geleden.',
  selectRecipientForRecipientAlarm: 'Selecteer een ontvanger voor het alarm',
  selectAtLeastOneParticipantForGroupAlarm:
    'Ten minste één deelnemer toevoegen aan het alarm',
  addAtLeastOneMemberToGroup: 'Ten minste één lid aan de groep toevoegen',
  atTheSameTime: 'Tegelijkertijd',
  myself: 'Ikzelf',
  group: 'Groep',
  someoneElse: 'Iemand anders',
  participantsAreNotified: 'Deelnemers krijgen bericht.',
  creatorIsNotified: '{{creatorName}} wordt gemeld.',
  membersAddedToGroup: {
    one: '{{memberNames}} wordt toegevoegd aan groep {{groupName}}.',
    other: '{{memberNames}} worden toegevoegd aan groep {{groupName}}.'
  },
  memberRemovedFromGroup:
    '{{memberName}} is verwijderd uit groep {{groupName}}, wat van invloed kan zijn geweest op sommige van je alarmen.',
  youRemovedFromGroup:
    'Je bent verwijderd uit groep {{groupName}}, wat invloed kan hebben gehad op sommige van je alarmen.',
  memberLeftGroup:
    '{{memberName}} linkergroep {{groupName}}, wat van invloed kan zijn geweest op sommige van je alarmen.',
  youLeftGroup:
    'Je hebt groep {{groupName}} verlaten, wat van invloed kan zijn geweest op sommige van je alarmen.',
  groupLeft: 'Je hebt groep {{groupName}} verlaten.',
  memberMovedToADifferentTimezone:
    '{{memberName}} verhuisd naar een andere tijdzone, wat invloed kan hebben gehad op sommige van je wekkers.',
  memberDstChanged: {
    zero: '{{memberName}} is gestopt met de zomertijd. Relevante alarmen zijn bijgewerkt.',
    one: '{{memberName}} is begonnen met het in acht nemen van de zomertijd. Relevante alarmen zijn bijgewerkt.'
  },
  impactedAlarms: 'Geïmpacteerde alarmen:',
  alwaysRingParticipantAlarmsOn:
    'Alarmen van anderen gaan af, tenzij je ze weigert.',
  alwaysRingParticipantAlarmsOff:
    'Alarmen van anderen gaan niet af tenzij je ze aanvaardt.',
  agreeToTermsOfServiceAndPrivacyPolicy:
    'Door verder te gaan, accepteert u de Servicevoorwaarden en het Privacybeleid van Galarm.',
  deleteAccountWarningHeader:
    'Waarschuwing: Deze actie is onomkeerbaar. Het verwijderen van je account zal:',
  deleteAccountDeleteAlarms: '- Verwijder alle alarmen die u hebt gemaakt',
  deleteAccountDeleteRecipientAlarms:
    '- Alle buddy-alarmen verwijderen waarin u de ontvanger bent',
  deleteAccountRemoveFromGroups: '- Je verwijderen uit alle groepen',
  cancelSubscriptionWarning:
    'U heeft een actief premium-abonnement. Het verwijderen van uw account annuleert het niet automatisch. Annuleer uw abonnement om toekomstige kosten te voorkomen.',
  deleteAccountWarningFooter: {
    zero: 'Als je van telefoon verandert, kun je de app gewoon installeren op je nieuwe telefoon en je registreren met hetzelfde nummer. Je kunt de app op deze telefoon verwijderen.\n\nAls je je account verwijdert, kun je het niet meer herstellen.',
    one: 'Als je van telefoon verandert, kun je de app gewoon installeren op je nieuwe telefoon en je registreren met hetzelfde nummer. Je kunt de app op deze telefoon verwijderen.\n\nAls u uw account verwijdert, kunt u deze niet meer herstellen. U kunt uw actieve Galarm-abonnement beheren in de Play Store.',
    other:
      'Als je van telefoon verandert, kun je de app gewoon op je nieuwe telefoon installeren en de app op deze telefoon verwijderen.\n\nAls u uw account verwijdert, kunt u deze niet meer herstellen. U kunt uw actieve Galarm-abonnement beheren in de App Store.'
  },
  typeConfirmationStringToDeleteAccount:
    'Typ {{confirmationString}} om je account te verwijderen',
  unableToDeleteAccount: 'Kan account niet verwijderen. {{error}}',
  impactedGroups: 'Betrokken groepen:',
  memberDeletedAccount:
    '{{memberName}} zijn account heeft verwijderd, wat gevolgen kan hebben gehad voor sommige van je alarmen en groepen.',
  confirmCountryCodeAndEnterNumber:
    'Bevestig je landcode en voer je telefoonnummer in.',
  confirmCountryCodeAndEnterNumberForExistingUser:
    'Bevestig je landcode en voer het telefoonnummer in dat je eerder hebt gebruikt bij het registreren.',
  requiredPermissionsDisabledWarningIos:
    'Meldingen zijn uitgeschakeld. Alarmen gaan niet af. Tik op om te herstellen.',
  requiredPermissionsDisabledWarningAndroid:
    'Galarm heeft niet de vereiste machtigingen om alarmen af te laten gaan. Tik om te repareren.',
  notificationChannelPopupDisabledWarningAndroid:
    'Alarmmeldingen verschijnen niet op het scherm. Tik op om te herstellen.',
  alarmLockScreenNotificationDisabledWarningAndroid:
    'Alarmmeldingen verschijnen niet op het vergrendelscherm. Tik op om te herstellen.',
  contactPermissionNotGranted:
    'Galarm heeft geen toegang tot je contacten. Nieuwe contactpersonen die zijn toegevoegd aan het adresboek van uw telefoon worden niet gesynchroniseerd met Galarm. Tik op om te repareren.',
  why: 'Waarom',
  how: 'Hoe',
  registrationRequired: 'Registratie vereist',
  phoneNumberRequired: 'Telefoonnummer Verplicht',
  fewSeconds: 'enkele seconden',
  lessThanMinute: 'minder dan een minuut',
  updateUnsupportedVersion:
    'Een bijgewerkte versie van de app is vereist om Galarm te kunnen blijven gebruiken.',
  update: 'Update',
  back: 'Terug',
  unableToMarkAlarmDone:
    'Ik kan het alarm op dit moment niet als gereed markeren. Probeer het over enkele ogenblikken opnieuw.',
  unableToMarkAlarmUndone:
    'Het is op dit moment niet mogelijk om het alarm als ongedaan te markeren. Probeer het over enkele ogenblikken opnieuw.',
  unableToMarkAlarmUnskipped:
    'Kan het alarm op dit moment niet markeren als overgeslagen. Probeer het over enkele ogenblikken opnieuw.',
  unableToSkipAlarm:
    'Het alarm kan op dit moment niet worden overgeslagen. Probeer het over enkele ogenblikken opnieuw.',
  unableToSetGroupAlarmResponse:
    'Het groepsalarm kan momenteel niet worden {{response}}. Probeer het over enkele ogenblikken opnieuw.',
  unableToDeleteAlarm:
    'Het alarm kan momenteel niet worden verwijderd. Probeer het over enkele ogenblikken opnieuw.',
  unableToSetAlarmResponse:
    'Uw reactie kan op dit moment niet worden ingesteld. Probeer het over enkele ogenblikken opnieuw.',
  unableToSnoozeAlarm: 'Ik kan de wekker niet op snooze zetten.',
  unableToStopSnoozeForAlarm: 'Kan sluimerfunctie voor alarm niet stoppen.',
  unableToUpdateParticipantAlarmRingerSettings:
    'Kan belsignaalinstellingen momenteel niet bijwerken. Probeer het over enkele ogenblikken opnieuw.',
  updateParticipantPreReminderDuration:
    'Kan de duur van de herinnering op dit moment niet bijwerken. Probeer het over enkele ogenblikken opnieuw.',
  unableToUpdateAlarmRingerSettings:
    'Kan belsignaalinstellingen momenteel niet bijwerken. Probeer het over enkele ogenblikken opnieuw.',
  unableToUpdateAlarmPreReminderDuration:
    'Kan de duur van de herinnering op dit moment niet bijwerken. Probeer het over enkele ogenblikken opnieuw.',
  retrievingAlarmsFromServer: 'Alarmen ophalen van de server...',
  startApp: 'Start >',
  phoneNumberRequiredGroupListHeaderText:
    'Groep is een verzameling Galarm-contacten waarmee je snel alarmen kunt maken.\n\nRegistreer u met uw telefoonnummer om uw contactpersonen te vinden die Galarm gebruiken. U kunt ze toevoegen aan groepen.',
  phoneNumberRequiredBuddyAlarmHeaderText:
    'Buddy alarm kan worden gebruikt om alarmen in te stellen voor vrienden en familie om ze te herinneren aan dingen die ze moeten doen.\n\nOm deze en vele andere coole functies van de app te gebruiken, moet je je registreren met je telefoonnummer.',
  phoneNumberRequiredInstantAlarmHeaderText: `Instant-waarschuwingen kunnen worden gebruikt om een contact of een groep onmiddellijk te waarschuwen in geval van noodgevallen of dringende taken.

Om deze en vele andere coole functies van de app te gebruiken, moet je je registreren met je telefoonnummer.`,
  phoneNumberRequiredContactListHeaderText:
    'Contacten zijn mensen die kunnen worden toegevoegd als deelnemers aan alarmen.\n\nRegistreer u met uw telefoonnummer om uw contactpersonen te bekijken die Galarm gebruiken. U kunt hen toevoegen als deelnemers aan uw alarmen.',
  phoneNumberRequiredGroupAlarmHeaderText:
    'Groepsalarm kan worden gebruikt om een herinnering in te stellen voor een groep mensen.\n\nOm deze en vele andere coole functies van de app te gebruiken, moet je je registreren met je telefoonnummer.',
  phoneNumberRequiredParticipantsHeaderText:
    'Deelnemers fungeren als back-up voor dit alarm. Ze worden eraan herinnerd als je het alarm mist.\n\nOm deze en vele andere coole functies van de app te gebruiken, moet je je registreren met je telefoonnummer.',
  youHaveNotRegistered:
    'Van je alarmen wordt momenteel geen back-up gemaakt.\n\nRegistreer je met je telefoonnummer. Zodra je je hebt geregistreerd, wordt er een back-up van je wekkers gemaakt in de cloud. Hierdoor kun je je wekkers en andere instellingen herstellen als je van telefoon verandert.\n',
  registerNow: 'Nu registreren',
  hoursAndMinutes: 'Uren en minuten',
  days: 'Dagen',
  weeks: 'Weken',
  months: 'Maanden',
  years: 'Jaren',
  daysOfWeek: 'Wekelijks (geselecteerde dagen)',
  monthly: 'Maandelijks',
  yearly: 'Jaarlijks',
  everyDay: 'Dagelijks',
  selectDaysOfWeek: 'Selecteer dagen van de week',
  alarmRingMessageForSpecificDates:
    'Dit alarm gaat alleen af in maanden met minstens {{dayOfMonth}} dagen. Wilt u doorgaan?',
  alarmRingMessageForSpecificYear:
    'Dit alarm gaat alleen af in schrikkeljaren. Wil je doorgaan?',
  alarmRingMessageForSpecificDayOfWeekInMonth:
    'Dit alarm gaat alleen af in maanden met {{weekNumberOfDayInMonth}} {{dayName}} s. Wil je doorgaan? ',
  alarmRepetitionAdjustedBasedOnNewDate:
    'De alarmherhaling is bijgewerkt op basis van de nieuwe datum.',
  inviteFriendsToInstallGalarm:
    'Contacten zijn personen die als deelnemers aan uw alarmen kunnen worden toegevoegd. U kunt contacten uitnodigen:\n\n1. Vanuit uw adresboek\n\n2. Door handmatig hun naam en nummer in te voeren.\n\nTik rechtsboven op Vernieuwen om de Galarm-contacten opnieuw te laden nadat ze zich hebben geregistreerd.',
  whyCreateNewGroup:
    'Groepen zijn verzamelingen contactpersonen die kunnen worden toegevoegd als deelnemers aan je alarmen.\n  \nJe hebt geen groepen gemaakt.',
  noNotifications: 'Je hebt geen nieuwe meldingen.',
  createGroup: 'Groep maken',
  galarmRequiresAccessToContactsPermission:
    'Galarm vraagt toestemming om toegang te krijgen tot uw contactpersonen. Deze informatie wordt naar de servers gestuurd om uw contactpersonen te identificeren die Galarm gebruiken. Deze gebruikers kunnen worden toegevoegd als deelnemers aan uw alarmen.',
  galarmRequiresAccessToAudioFilesPermission:
    'Sommige wekkers gebruiken muziek van de telefoon als beltoon. Geef toestemming voor toegang tot audiobestanden op je apparaat om deze alarmen te laten afgaan met de gekozen beltoon.',
  galarmRequiresAccessToContactsSelectScreen:
    'Galarm heeft geen toegang tot contacten. Sta toegang tot contacten toe als u deze functie wilt gebruiken.',
  allow: 'Sta  toe.',
  deny: 'Weigeren',
  galarmRequiresAccessToContacts:
    'Contacten zijn mensen die kunnen worden toegevoegd als deelnemers aan je alarmen. U kunt contactpersonen toevoegen door:\n\n1. Automatisch importeren vanuit de telefooncontacten. Tik op "Toegang toestaan" en schakel "Contacten" in.\n\n2. Handmatig hun naam en nummer toevoegen. Tik op "Contact toevoegen" om te beginnen.',
  galarmRequiresAccessToAlarmAndRemindersPermission:
    'Galarm heeft de toestemming "Alarmen & herinneringen" nodig zodat het precies op gespecificeerde tijden alarmen kan laten afgaan. Schakel dit in op het volgende scherm.',
  accessToContactsPermissionRequiredAndroid:
    'Galarm heeft geen toegang tot je telefooncontacten.\n\nAls u toegang toestaat, worden mensen in uw telefooncontacten die Galarm gebruiken weergegeven als Galarm-contacten. Deze mensen kunnen worden toegevoegd als alarmdeelnemers. Tik op "Toegang toestaan", selecteer "Toestemming" en schakel "Contacten" in.\n\nU kunt nog steeds handmatig contactpersonen toevoegen aan Galarm.',
  accessToContactsPermissionRequiredIos:
    'Galarm heeft geen toegang tot je telefooncontacten.\n\nAls u toegang toestaat, worden mensen in uw telefooncontacten die Galarm gebruiken weergegeven als Galarm-contacten. Deze mensen kunnen worden toegevoegd als alarmdeelnemers. Tik op "Toegang toestaan" en schakel "Contacten" in.\n\nU kunt nog steeds handmatig contactpersonen toevoegen aan Galarm.',
  giveAccess: 'Toegang verlenen',
  enterValidMobileNumber:
    'Voer een geldig telefoonnummer in om te registreren.',
  proceedAnyway: 'Toch doorgaan',
  checkInvalidPhoneNumber:
    'We denken dat je een ongeldig nummer hebt ingevoerd als {{mobileNumber}}.',
  checkInvalidCountryCode:
    'Ongeldige landcode opgegeven als {{countryCode}}. Als er meer dan één landcode aanwezig is, bewerkt u het veld om de toepasselijke landcode te behouden.',
  editNumber: 'Bewerk nummer',
  editCountryCode: 'Landcode bewerken',
  sendingCodeOnCall: 'Ik bel je met de code.',
  sendCodeOnCall: 'Bel me met de code',
  sendCodeOnSms: 'Code verzenden via SMS',
  sendCodeOnWhatsApp: 'Code verzenden via WhatsApp',
  registrationLandingScreenRegisterText:
    'Tik op Doorgaan om te registreren met uw telefoonnummer.\n\nDoor te registreren:\n1) Kun je deelnemers aan je alarmen toevoegen en met ze chatten.\n2) Wordt er een back-up van uw alarmen gemaakt in de cloud, zodat wanneer u van telefoon verandert, uw alarmen op de nieuwe telefoon verschijnen.',
  continue: 'Ga verder',
  registerLater: 'Registratie overslaan',
  cancelRegistration: 'Registratie annuleren',
  welcome: 'Welkom',
  haventReceivedCodeYet: {
    one: 'Heb je de code nog niet ontvangen? Je kunt de code binnen 1 seconde opnieuw aanvragen.',
    other:
      'Heb je de code nog niet ontvangen? Je kunt de code binnen {{count}} seconden opnieuw aanvragen.'
  },
  storagePermissionDenied:
    'Geen toegang tot muziekbestanden omdat opslagtoestemming is geweigerd.',
  havingTroubleRegisteringMessage:
    'Galarm kan de code na meerdere pogingen niet verifiëren.\n\nWilt u de registratie overslaan en de app gebruiken?',
  autoDetectVerificationCode:
    'Om de registratie te vereenvoudigen, kan Galarm automatisch de verificatiecode detecteren als u Galarm toestaat sms-berichten te bekijken.',
  notNow: 'Niet nu',
  verifyNumberText:
    'We sturen een sms met de verificatiecode naar:\n\n{{formattedMobileNumber}}',
  verifyNumberWhatsApp:
    'We sturen een WhatsApp-bericht met de verificatiecode naar:\n\n{{formattedMobileNumber}}',
  verifyNumberCall:
    'Je ontvangt een telefoontje met de verificatiecode op:\n\n{{formattedMobileNumber}}',
  addToContacts: 'Toevoegen aan Contacten',
  todayString: 'Vandaag',
  tomorrowString: 'Morgen',
  backups: 'Back-ups',
  acintyoTrademark:
    '© 2026 Acintyo, Inc. Alle rechten voorbehouden.\nGalarm is een geregistreerd handelsmerk van Acintyo, Inc.\nBeschermd door Amerikaanse octrooien 10382613, 10867286.\nAndere octrooien aangevraagd.',
  acintyoTrademarkWeb:
    '© 2026 Acintyo, Inc. Alle rechten voorbehouden. Galarm is een geregistreerd handelsmerk van Acintyo, Inc.\nBeschermd door Amerikaanse octrooien 10382613, 10867286. Andere octrooien aangevraagd.',
  acintyoTrademarkEnterprise:
    '© 2026 Acintyo, Inc.\nAlle rechten voorbehouden.',
  markAlarmDone: 'Alarm markeren als Gereed',
  skipAlarm: 'Alarm overslaan',
  confirmGroupAlarm: 'Deelname bevestigen',
  declineGroupAlarm: 'Deelname weigeren',
  snoozeAlarm: 'Sluimerwekker',
  deleteAlarmQuickAction: 'Alarm verwijderen',
  disableAlarm: 'Alarm uitschakelen',
  confirmDisableAlarm: 'Alarm uitschakelen?',
  saveToCalendar: 'Exporteren naar kalender',
  stillRingGroupAlarmAfterConfirmingInAdvance:
    'Je bevestigt het groepsalarm van tevoren.  Wilt u nog steeds de herinnering op de wektijd?',
  updateNow: 'Nu bijwerken',
  nParticipants: {
    one: '1 andere deelnemer',
    other: '{{count}} andere deelnemers'
  },
  details: 'Details',
  changeParanthesis: '(veranderen)',
  loadMoreHistory: 'Meer bekijken',
  alarmSummaryForHistory:
    'Reacties uit het verleden voor {{alarmName}}.\nHerhaalt {{alarmRepetitionString}}\n{{previousOccurrencesString}}',
  alarmSummaryForHistoryWeb: 'Reacties uit het verleden voor {{alarmName}}',
  alarmSummaryForHistoryRepetitionWeb: 'Herhaalt {{alarmRepetitionString}}',
  dontSeeCompleteHistory: 'Zie je geen volledige geschiedenis?',
  dontSeeCompleteHistoryExplanation:
    'De alarmgeschiedenis wordt bijgehouden vanaf het moment dat het alarm wordt aangemaakt. We bewaren slechts een beperkte geschiedenis voor elk alarm, afhankelijk van de herhaling van het alarm. Als het alarm bijvoorbeeld elke dag wordt herhaald, bewaren we een geschiedenis van 30 dagen.\n\nDoor de alarmtijd of -herhaling te wijzigen, wordt de alarmgeschiedenis gereset.',
  noActionAvailableForAlarmOccurrence:
    'Geen acties beschikbaar voor dit voorval.',
  enterEmailIdForFeedback: 'Gebruikt om te reageren en updates te delen',
  noPreviousOccurrences: 'Nog geen alarmgeschiedenis',
  nMissedOccurrencesOfAlarmInLastNDays: {
    zero: 'Nog geen alarmgeschiedenis',
    one: '{{missedAlarmOccurrences}} miste de laatste {{count}}',
    other: '{{missedAlarmOccurrences}} miste de laatste {{count}}'
  },
  soundAndVibrationSummaryString: {
    zero: '{{volume}}% volume, {{ringtoneName}}',
    one: '{{volume}}% volume, {{ringtoneName}}, Titel aankondigen'
  },
  soundAndVibrationSummaryStringIos: {
    zero: '{{ringtoneName}}',
    one: 'Kritisch, {{volume}}% volume, {{ringtoneName}}'
  },
  previousOccurrences: 'Alarm Geschiedenis',
  retrieving: 'Ophalen...',
  startTimeOfDay: 'Begint bij',
  endTimeOfDay: 'Eindigt bij',
  ringEveryHours: 'Ringen elke',
  everyNHours: 'Uurlijks',
  everyMHoursNMinutes: 'Uren en minuten',
  selectHourlyRepetition: 'Herhaling per uur selecteren',
  everyNHoursRepetitionString: {
    one: 'Elk uur van {{startTimeString}} tot {{endTimeString}} {{daysString}}',
    other:
      'Elke {{count}} uur van {{startTimeString}} tot {{endTimeString}} elke {{daysString}}'
  },
  everyNHoursAndMinutesRepetitionString:
    'Elke {{hoursAndMinutes}} van {{startTimeString}} tot {{endTimeString}} elke {{daysString}}',
  everyMHoursAndNMinutesRepetitionString: 'Elke {{repeatString}}',
  everyNHoursRepetitionStringForCalendar: {
    one: 'Elk uur van {{startTimeString}} tot {{endTimeString}}',
    other: 'Elke {{count}} uur van {{startTimeString}} tot {{endTimeString}}'
  },
  everyNHoursAndMinutesRepetitionStringForCalendar:
    'Elke {{hoursAndMinutes}} van {{startTimeString}} tot {{endTimeString}}',
  everyNHoursAndMinutesRepetitionStringForAlarmSummary:
    'Elke {{hoursAndMinutes}} tot {{endTimeString}}',
  everyNHoursRepetitionStringForAlarmSummary: {
    one: 'Elk uur tot {{endTimeString}}',
    other: 'Elke {{count}} uur tot {{endTimeString}}'
  },
  daysRepetitionOddString: {
    other: 'Alle oneven genummerde data',
    one: 'Oneven genummerde data ({{daysString}})'
  },
  daysRepetitionEvenString: {
    other: 'Alle even genummerde data',
    one: 'Even genummerde data ({{daysString}})'
  },
  oddNumberedRepetitionPreviewString: {
    one: 'Het alarm gaat af op oneven data die vallen op {{daysString}} op het opgegeven tijdstip.',
    other:
      'Het alarm gaat af op alle oneven genummerde data op de aangegeven tijd.'
  },
  evenNumberedRepetitionPreviewString: {
    one: 'Het alarm gaat af op even genummerde data die vallen op {{daysString}} op de opgegeven tijd.',
    other:
      'Het alarm gaat af op alle even genummerde data op de opgegeven tijd.'
  },
  hourlyRepetitionPreviewString: {
    one: 'Dit alarm gaat elke {{daysString}} een keer af:',
    other: 'Dit alarm gaat elke {{daysString}} {{count}} keer af op:'
  },
  daysRepetitionPreviewString: {
    one: 'Dit alarm gaat elke dag af.',
    other: 'Dit alarm gaat elke {{count}} dagen af.'
  },
  weeksRepetitionPreviewString: {
    one: 'Het alarm gaat elke week af op {{daysString}}.',
    other: 'Het alarm gaat elke {{count}} weken af op {{daysString}}.'
  },
  weeksRepetitionPreviewStringEveryDay: {
    one: 'Het alarm gaat elke dag af.',
    other: 'Het alarm gaat elke dag af, elke week e{{count}}.'
  },
  specifyNumberOfWeeksAndChooseDays:
    'Geef het aantal weken op en kies de dagen voor herhaling.',
  everyNDays: {
    one: 'Elke dag',
    other: 'Elke {{count}} dagen'
  },
  everyNWeeks: {
    one: 'Elke week {{daysString}}',
    other: 'Elke {{count}} weken {{daysString}}'
  },
  everyNMonths: {
    one: 'Elke maand',
    other: 'Elke {{count}} maanden'
  },
  everyNYears: {
    one: 'Elk jaar',
    other: 'Elke {{count}} jaar'
  },
  cantSetEndTime: 'Kan eindtijd niet instellen',
  endTimeShouldBeGreater: 'De eindtijd moet groter zijn dan de starttijd.',
  cantSetStartTime: 'Kan starttijd niet instellen',
  startTimeShouldBeLess: 'De starttijd moet korter zijn dan de eindtijd.',
  everyDaySmall: 'dag',
  everyGivenDay: '{{day}}',
  everyGivenDays: '{{days}}',
  adjustingAlarmsAfterTimezoneChange:
    'We hebben gedetecteerd dat je naar een andere tijdzone bent verhuisd. We passen uw wekkers aan.',
  ringOnDays: 'Ringen op',
  yourAlarmsMayNotRing: 'Uw alarmen gaan misschien niet af',
  yourAlarmsMayNotRingTapToFix:
    'Uw alarmen rinkelen mogelijk niet. Tik op om te repareren.',
  unsyncedAlarmsWarning:
    'Sommige alarmen zijn niet gesynchroniseerd met de server. Maak verbinding met internet en tik om ze nu op te slaan.',
  pendingActionFailed:
    'Een alarmwijziging ({{actionName}}) kon na meerdere pogingen niet worden opgeslagen en werd verworpen. Controleer uw alarmen of neem contact op met de ondersteuning als gegevens ontbreken.',
  pendingActionFailedWithRef:
    'Een alarmwijziging ({{actionName}}) kon na meerdere pogingen niet worden opgeslagen en werd verworpen. Referentie-ID: {{referenceId}}. Neem contact op met de ondersteuning met deze ID om te helpen het te herstellen.',
  xiaomiSetupInstructions:
    'Volg deze instructies zodat je alarm altijd afgaat:\n\n - Tik op "Autostart inschakelen" en sta "Galarm" toe zodat je alarmen altijd afgaan. \n\nGa voor meer informatie naar www.galarmapp.com/setup-mi',
  oppoSetupInstructions:
    'Volg deze instructies zodat je alarm altijd afgaat:\n\n - Tik op "Autostart inschakelen" en schakel "Automatisch opstarten toestaan" in.\n\n - Tik op de knop "Recent Apps" op uw telefoon, veeg het pictogram van de Galarm-app naar beneden en tik op "Lock" (Vergrendelen).  \n\nGa voor meer informatie naar www.galarmapp.com/setup-oppo',
  oppo8AndLowerSetupInstructions:
    'Volg deze instructies zodat je alarm altijd afgaat:\n\n - Tik op "Autostart inschakelen" en schakel "Automatisch opstarten toestaan" in.\n\n - Tik op de knop "Recent Apps" op uw telefoon, veeg het pictogram van de Galarm-app naar beneden en tik op "Lock" (Vergrendelen).\n\nGa voor meer informatie naar www.galarmapp.com/setup-oppo-8-and-lower',
  vivo9And10SetupInstructions:
    'Volg deze instructies zodat je alarm altijd afgaat:\n\n - Tik op "Autostart inschakelen" en sta "Galarm" toe.\n\n - Tik op "Batterijgebruik", selecteer "Hoog energieverbruik op achtergrond" en sta "Galarm" toe.\n\nGa voor meer informatie naar www.galarmapp.com/setup-vivo',
  vivo11SetupInstructions:
    'Volg deze instructies zodat je alarm altijd afgaat:\n\n- Tik op "Autostart inschakelen" en sta "Galarm" toe.\n\n- Tik op "Batterijgebruik", selecteer "Hoog energieverbruik op achtergrond" en sta "Galarm" toe.\n\nGa voor meer informatie naar www.galarmapp.com/setup-vivo-11',
  vivoSetupInstructions:
    'Volg deze instructies zodat je alarm altijd afgaat:\n\n- Open "Telefooninstellingen > Apps > Speciale app-toegang > Autostart" en schakel autostart in voor Galarm.\n\n- Open "Telefooninstellingen > Batterij > Beheer stroomverbruik op achtergrond > Galarm" en kies "Stroomverbruik op achtergrond niet beperken".\n\nGa voor meer informatie naar www.galarmapp.com/setup-vivo-12-and-above',
  vivo8AndLowerSetupInstructions:
    'Volg deze instructies zodat je alarm altijd afgaat:\n\n - Tik op "Autostart inschakelen" en sta "Galarm" toe.\n\n - Tik op "Batterijgebruik", selecteer "Hoog energieverbruik op achtergrond" en sta "Galarm" toe.\n\nGa voor meer informatie naar www.galarmapp.com/setup-vivo-8-and-lower',
  huawei7AndLowerAdditionalSetupInstructions:
    'Volg deze instructies zodat je alarm altijd afgaat:\n\n - Tik op "Beschermde apps" en sta "Galarm" toe.\n\nGa voor meer informatie naar www.galarmapp.com/setup-huawei-7-and-lower',
  huaweiAdditionalSetupInstructions:
    'Volg deze instructies zodat je alarm altijd afgaat:\n\n - Tik op "App Launch beheren" en schakel "Galarm" uit naar "Handmatig beheren". Zorg er in de prompt die volgt voor dat "Auto Launch" en "Run in background" zijn ingeschakeld.\n\nGa voor meer informatie naar www.galarmapp.com/setup-huawei',
  meizuSetupInstructions:
    'Volg de instructies op de onderstaande link zodat je alarm altijd afgaat: https://dontkillmyapp.com/meizu',
  asusSetupInstructions:
    'Volg deze instructies zodat je alarm altijd afgaat:\n\n - Tik op "Autostart inschakelen" en klik op "Autostartmanager". Schakel "Galarm" in bij "Autostart manager".\n\nGa voor meer informatie naar www.galarmapp.com/setup-asus',
  nokia8AndLowerAdditionalSetupInstructions:
    'Volg deze instructies zodat je alarm altijd afgaat:\n\n - Tik op "Autostart inschakelen" en sta "Galarm" toe.\n\nGa voor meer informatie naar www.galarmapp.com/setup-nokia-8-and-lower',
  nokiaAdditionalSetupInstructions:
    'Volg deze instructies zodat je alarm altijd afgaat:\n\n - Tik op "Beperkte apps" en schakel "Galarm" uit.\n\nGa voor meer informatie naar www.galarmapp.com/setup-nokia',
  lenovoSetupInstructions:
    'Volg deze instructies zodat je alarm altijd afgaat:\n\n - Tik op de knop "Recente apps" op uw telefoon, zoek de Galarm-app en tik op het pictogram "Vergrendelen" in de rechterbovenhoek.\n  \nGa voor meer informatie naar https://dontkillmyapp.com/lenovo',
  samsungAdditionalSetupInstructions:
    'Volg deze instructies zodat je alarm altijd afgaat:\n\n - Tik op "Onbewaakte apps" en sta "Galarm" toe.\n\nGa voor meer informatie naar www.galarmapp.com/setup-samsung',
  tecnoSetupInstructions:
    'Volg de instructies op de onderstaande link zodat je alarm altijd afgaat: https://www.galarmapp.com/setup-tecno',
  infinixSetupInstructions:
    'Volg de instructies op de onderstaande link zodat je alarm altijd afgaat: https://www.galarmapp.com/setup-infinix',
  samsungAdditionalSetupInstructionsAndroid11AndAbove:
    'Samsung toont standaard "Korte" meldingen die snel verdwijnen. Volg deze instructies om "Gedetailleerde" alarmmeldingen te bekijken.\n\n - Open telefooninstellingen en kies "Meldingen".\n - Kies de stijl voor "Gedetailleerde" meldingen\n  \nGa voor meer informatie naar www.galarmapp.com/setup-samsung-android11-and-above',
  iosSetupInstructions:
    'Standaard is de bannerstijl van iOS voor meldingen ingesteld op "Tijdelijk", waardoor de meldingen snel verdwijnen. Volg deze instructies om de bannerstijl in te stellen op "Blijvend".\n\n- Open de telefooninstellingen en scroll naar Galarm\n- Kies Meldingen en stel Banierstijl in op Blijvend\n\nGa voor meer informatie naar www.galarmapp.com/setup-ios',
  iosSetupInstructions15AndBelow:
    'Standaard is de bannerstijl van iOS voor meldingen ingesteld op "Tijdelijk", waardoor de meldingen snel verdwijnen. Volg deze instructies om de bannerstijl in te stellen op "Blijvend".\n\n- Open de telefooninstellingen en scroll naar Galarm\n- Kies Meldingen en stel Banierstijl in op Blijvend\n\nGa voor meer informatie naar www.galarmapp.com/setup-ios-15-below',
  setNotificationsStyle: 'Stijl meldingen instellen',
  setNotificationsStyleToDetailed:
    'Stel Stijl meldingen in op "Gedetailleerd".',
  setBannerStyle: 'Stijl banner instellen',
  setBannerStyleToPersistent: 'Stel bannerstijl in op "Persistent".',
  selectAtleastOneDay: 'Selecteer dagen waarop dit alarm moet afgaan.',
  selectAtLeastOneHourOrMinute:
    'Uren of minuten moeten een waarde hebben die niet nul is.',
  hourlyAlarmDefaultStartTimeSetAlert:
    'De starttijd van het alarm is ingesteld op 8 AM.',
  batteryUsage: 'Batterijgebruik',
  dontShowAgain: 'Laat je niet meer zien',
  alarmWillRingEveryHourTillSeen:
    'Het alarm zal elk uur sluimeren totdat je actie onderneemt.',
  unknown: 'Onbekend',
  alarmMarkedDone: '{{name}} heeft het alarm "Gereed" gemarkeerd.',
  alarmMarkedSkipped: '{{name}} heeft het alarm overgeslagen.',
  alarmIsMarkedDone: '{{alarmName}} is gemarkeerd als gedaan.',
  alarmIsSkipped: '{{alarmName}} wordt overgeslagen.',
  alarmIsConfirmed: '{{alarmName}} is bevestigd.',
  alarmIsDeclined: '{{alarmName}} wordt geweigerd.',
  alarmIsSnoozed: '{{alarmName}} is uitgesteld.',
  alarmIsAccepted: '{{alarmName}} wordt geaccepteerd.',
  alarmIsRejected: '{{alarmName}} wordt afgewezen.',
  dismissingCalendarEvent: "Afspraak voor '{{title}}' verwijderen",
  newContactInfo:
    'Geef de naam en het telefoonnummer van de contactpersoon.\n\nAlleen geregistreerde gebruikers kunnen als contact worden toegevoegd. Als de gebruiker geen geregistreerde Galarm-gebruiker is, dan kunt u ze uitnodigen via "Instellingen > Deze app delen". U kunt ze toevoegen als contact nadat ze zich hebben geregistreerd met hun telefoonnummer. ',
  cantEditContactMobileNumber:
    'Je kunt het telefoonnummer niet bewerken. Verwijder het contact en voeg opnieuw toe als u het nummer wilt wijzigen.',
  phoneContactsNotSyncedPermissionDenied:
    'Galarm heeft geen toegang tot telefooncontacten. Telefooncontacten worden niet gesynchroniseerd.',
  inviteContactMessage:
    'Hallo {{contactName}}, ik wil je opnemen in mijn alarmen en herinneringen met behulp van Galarm. Download de app van {{downloadLink}}. Registreer je met dit nummer en begin met het delen van alarmen.',
  noRepeat: 'Herhaalt niet',
  deepLinkNoLongerValidTitle: 'Oeps!',
  deepLinkNoLongerValidMessage:
    'Alarm is niet aangemaakt. Het kan een oude link zijn of een ongeldige link.',
  inviteContact: 'Contact uitnodigen',
  fromPhoneBook: 'Uit adresboek',
  addFromPhoneBook: 'Uitnodigen vanuit adresboek',
  manually: 'Handmatig',
  addManualContact: 'Handmatig uitnodigen',
  noOtherContactsFound:
    'Alle contactpersonen in je adresboek gebruiken Galarm.',
  cantAddPhoneContactPermissionDenied:
    'Galarm heeft geen toegang tot telefooncontacten. Geef toestemming voor toegang tot contacten.',
  alarmWillRingWithRandomRingtone:
    'Er wordt een willekeurige beltoon gekozen voor het alarm.',
  alarmWillRingWithRandomRingtoneGlobal:
    'Er wordt een willekeurige beltoon gekozen voor alarmen.',
  createdAlarmFromDeepLinkTitle: 'Je bent er helemaal klaar voor!',
  createdAlarmFromDeepLinkMessage:
    'U wordt herinnerd aan "{{alarmName}}" op {{alarmTime}} op {{alarmDate}}',
  createdRepeatingAlarmFromDeepLinkMessage: {
    zero: 'Je wordt herinnerd aan "{{alarmName}}" {{repetitionString}}',
    one: 'U wordt herinnerd aan "{{alarmName}}" {{repetitionString}} bij {{alarmTime}} vanaf {{alarmDate}}'
  },
  deleteCategoryAlertTitle: 'Categorie verwijderen?',
  deleteCategoryAlertMessage: {
    zero: '',
    one: '1 alarm behoort tot deze categorie. Als je deze categorie verwijdert, wordt de categorie voor dat alarm opnieuw ingesteld.',
    other:
      '{{count}} Alarmen behoren tot deze categorie. Als je deze categorie verwijdert, wordt de categorie op deze alarmen teruggezet.'
  },
  updateReadyToInstallAlertTitle: 'Update installeren?',
  updateReadyToInstallAlertMessage:
    'Updates zijn klaar om te installeren. Wil je de update nu installeren? ',
  hideCategoryAlertTitle: 'Categorie verbergen?',
  hideCategoryAlertMessage: {
    zero: 'Je zult deze categorie in de toekomst niet meer kunnen gebruiken.',
    one: '1 alarm behoort tot deze categorie. Als je deze categorie verbergt, wordt de categorie van dat alarm opnieuw ingesteld.\n  \nJe zult deze categorie in de toekomst niet meer kunnen gebruiken.',
    other:
      '{{count}} Alarmen behoren tot deze categorie. Als je deze categorie verbergt, wordt de categorie van deze alarmen opnieuw ingesteld.\n  \nJe zult deze categorie in de toekomst niet meer kunnen gebruiken.'
  },
  alarmCategoryDeleteAllAlarmsPrompt: {
    one: '1 alarm behoort tot deze categorie. Wil je het verwijderen?\n\nDeelnemersalarmen worden niet verwijderd.',
    other:
      '{{count}} alarmen behoren tot deze categorie. Wil je ze verwijderen?\n\nDeelnemersalarmen worden niet verwijderd.'
  },
  enterNameForGroup: 'Voer een naam in voor de groep',
  enterMobileNumber: 'Voer uw telefoonnummer in',
  enterNotesForAlarm: 'Notities voor alarm invoeren',
  enterUserName: 'Voer je naam in',
  enterEmailId: 'Optioneel',
  enterFeedback: 'Hoe kunnen we verbeteren?',
  describeProblem: 'Beschrijf je probleem',
  invited: 'Uitgenodigd',
  resend: 'Opnieuw versturen',
  addContact: 'Contact toevoegen',
  inviteAgain: 'Opnieuw uitnodigen',
  contactNotRegistered:
    '{{contactName}} Galarm nog niet heeft geïnstalleerd. U kunt ze aan alarmen toevoegen zodra ze geïnstalleerd en geregistreerd zijn met hun telefoonnummer.',
  registration: 'Registratie',
  verify: 'Verificatie',
  profile: 'Profiel',
  profileImage: 'Profiel afbeelding',
  addProfileImage: 'Profielfoto toevoegen',
  groupDetails: 'Groep Details',
  newGroup: 'Nieuwe groep',
  uploadImage: 'Afbeelding wijzigen',
  removeImage: 'Afbeelding verwijderen',
  selectParticipants: 'Deelnemers selecteren',
  selectMembers: 'Selecteer leden',
  selectTimezone: 'Selecteer tijdzone',
  searchForATimezone: 'Een tijdzone zoeken',
  timezone: 'Tijdzone',
  deviceTimezone: 'Tijdzone apparaat',
  useDeviceTimezone: 'Gebruik de tijdzone van het apparaat',
  specifyTimezoneForAlarm: 'Tijdzone voor alarmen opgeven',
  defaultTimezoneForAlarm: 'Standaard tijdzone voor alarmen',
  changeDefaultTimezoneForAllExistingAlarms: {
    zero: 'Wilt u de tijdzone opnieuw instellen voor alle bestaande alarmen?',
    one: 'Wilt u de tijdzone voor alle bestaande alarmen wijzigen naar deze tijdzone? Alarmen zullen afgaan op de geconfigureerde tijd in de nieuwe tijdzone.'
  },
  changeDefaultRingerSettingsForAllExistingAlarms:
    'Wil je de geluids- en trilinstellingen voor bestaande alarmen wijzigen?\n\nAls u Ja kiest, zullen bestaande alarmen afgaan met de nieuwe instellingen. Als u Nee kiest, blijven bestaande alarmen afgaan met de oude instellingen.',
  defaultTimezoneChangedForAllAlarms: 'Tijdzone gewijzigd voor alle alarmen.',
  ringerSettingsChangedForAllAlarms:
    'Geluids- en trilinstellingen gewijzigd voor bestaande alarmen.',
  editName: 'Naam bewerken',
  groupImage: 'Groepsbeeld',
  addGroupImage: 'Groepsafbeelding toevoegen',
  selectAlarmType: 'Een alarm maken voor',
  contactDetails: 'Contactgegevens',
  commonAlarms: 'Alarmen',
  commonGroups: 'Groepen',
  groupAlarmsTitle: 'Alarmen',
  selectRingtone: 'Ringtone selecteren',
  selectMusic: 'Selecteer muziek',
  select: 'Selecteer',
  personalAlarm: 'Persoonlijk alarm',
  groupAlarm: 'Groepsalarm',
  newPersonalAlarm: 'Nieuw persoonlijk alarm',
  newGroupAlarm: 'Nieuw groepsalarm',
  editPersonalAlarm: 'Persoonlijk alarm bewerken',
  editTaskAlarm: 'Alarm bewerken',
  editGroupAlarm: 'Groepsalarm bewerken',
  rearrangeParticipants: 'Deelnemers herschikken',
  alarmConversation: 'Alarm-chat',
  timezoneMismatchDetected:
    'Iets zegt ons dat u zich in een andere tijdzone bevindt dan de laatste keer dat u Galarm gebruikte.\n\nOude tijdzone: {{oldTimezone}}\nNieuwe tijdzone: {{newTimezone}}\n\nDit kan het gevolg zijn van een verandering in uw locatie of een verandering in de tijdzone op uw apparaat.\n\nStart Galarm opnieuw op zodat we ons kunnen aanpassen aan de nieuwe tijdzone.',
  deviceRestartRequired: 'App herstart vereist',
  disabledAlarm: 'Uitgeschakeld alarm {{name}}',
  newContact: 'Nieuw contact',
  contactName: 'Naam contactpersoon',
  contactMobileNumber: 'Telefoonnummer contactpersoon',
  enterNameForContact: 'Voer de naam van de contactpersoon in',
  pickCountryForContact: 'Land van het contact',
  enterMobileNumberForContact:
    'Voer het telefoonnummer van de contactpersoon in',
  specifyNameForContact: 'De naam van de contactpersoon is vereist',
  specifyValidPhoneNumberForContact: 'Geldig telefoonnummer is vereist',
  addingContact: 'Contact toevoegen',
  deletingContact: 'Contact verwijderen',
  editingContact: 'Contact bewerken',
  pending: 'In afwachting van',
  deleteContact: 'Contact verwijderen',
  galarmContact: 'Handmatig toegevoegd',
  phoneContact: 'Toegevoegd uit telefooncontacten',
  confirmDeleteContactTitle: '{{name}} verwijderen?',
  confirmDeleteContact: 'Je kunt ze niet toevoegen aan je alarmen.',
  contactAdded:
    'Geweldig! Nu kun je {{name}} toevoegen als deelnemer aan je alarmen.',
  contactInvited:
    'Er is een sms verstuurd naar {{name}} met de uitnodiging om Galarm te gebruiken.',
  changeSnoozeDuration: 'Verandering Duur',
  durationOfEvent: 'Duur van het evenement',
  upgradeToPremium: 'Upgrade naar Premium',
  premium: 'Premium',
  alarmLimitReached: 'Alarmgrens bereikt',
  unableToConnectToGooglePlay:
    'Kan geen verbinding maken met Google Play. Controleer of u bent aangemeld bij uw Google-account.',
  cantLoadVideo: 'Video kan niet worden geladen',
  cantUpgradeToPremium: 'Kan niet upgraden naar Premium',
  unableToConnectToIapAndroid:
    'Kan geen verbinding maken met de Play Store. Open de Play Store-app en controleer of u bent aangemeld.',
  unableToConnectToIapIos:
    'Kan geen verbinding maken met de App Store. Open de App Store-app en controleer of u bent ingelogd.',
  premiumFeaturesIos:
    'Als premium gebruiker krijg je een verhoogde limiet van {{maxLimit}} gelijktijdige alarmen.\n\nJe aankoop helpt ons ook om meer functies te ontwikkelen.',
  premiumFeaturesAndroid:
    'Maak onbeperkt alarmen aan door te upgraden naar premium.\n\nJe aankoop helpt ons ook om meer functies te ontwikkelen.',
  upgrade: 'Upgrade',
  rvInternalError:
    'Door een interne fout konden we de video niet laden. We hebben je alarmlimiet echter met 1 verhoogd.',
  rvNetworkError:
    'Controleer of je een goede internetverbinding hebt en probeer het opnieuw.',
  rvNotFoundError:
    'We hebben op dit moment geen geschikte video kunnen vinden. We hebben je alarmlimiet echter met 1 verhoogd.',
  dontRemindMe: 'Herinner me er niet aan',
  sameTimeAsBuddy: 'Zelfde tijd als vriend',
  noAlertForBuddyAlarm:
    'U hebt ervoor gekozen om niet te worden gewaarschuwd voor dit alarm.',
  noAlertRecipientIntervalDescription: 'U wordt niet gewaarschuwd.',
  chooseHours: 'Kies uren',
  chooseMins: 'Kies minuten',
  changeHours: 'Uren veranderen',
  moreOptions: 'Meer opties...',
  specificDates: 'Specifieke data',
  specificDatesRepetition: {
    one: 'Specifieke data (1 gebeurtenis)',
    other: 'Specifieke data ({{count}} voorvallen)'
  },
  specificDatesRepetitionSummary:
    'Specifieke data ({{remaining}}/{{total}} resterend)',
  nOccurrences: {
    one: '1 Voorval',
    other: '{{count}} Voorvallen'
  },
  addOrRemoveAlarmOccurrences:
    'Je kunt gebeurtenissen in een willekeurige volgorde toevoegen. Je kunt op een datum of tijd tikken om deze te wijzigen.',
  chooseTime: 'Kies een tijd...',
  set: 'Stel in',
  chooseNumberOfDays: 'Voer aantal dagen in',
  chooseNumberOfWeeks: 'Voer aantal weken in',
  numberOfDaysShouldBeAtLeastOne: 'Het aantal dagen moet minstens 1 zijn',
  numberOfWeeksShouldBeAtLeastOne: 'Het aantal weken moet minstens 1 zijn',
  numberOfMonthsShouldBeAtLeastOne: 'Aantal maanden moet minstens 1 zijn',
  numberOfYearsShouldBeAtLeastOne: 'Het aantal jaren moet minstens 1 zijn',
  frequency: 'Frequentie',
  configuration: 'Configuratie',
  endDate: 'Einddatum alarm',
  noEndDate: 'Geen Einddatum',
  alarmEndDateSetOnAlarm:
    'De einddatum van het alarm is ingesteld op {{endDateString}}.',
  noAlarmDateSetForAlarm: 'Er is geen einddatum ingesteld voor dit alarm.',
  noOccurrenceForThisAlarmAsPerEndDate:
    'Einddatum staat geen voorvallen toe voor het alarm.',
  alarmDateShouldBeBiggerThanAlarmStartDate:
    'De einddatum van het alarm moet na de begindatum van het alarm liggen.',
  aWeek: 'Een week',
  aMonth: 'Een maand',
  allInactiveAlarms: 'Alle inactieve alarmen',
  chooseAlarmEndDate: 'Kies einddatum alarm',
  next: 'Volgende',
  next7Days: '7 dagen vanaf vandaag',
  next30Days: '30 dagen vanaf vandaag',
  next12Months: '12 maanden vanaf vandaag',
  next10Years: '10 jaar vanaf vandaag',
  chooseDate: 'Kies een datum...',
  learnMore: 'Meer informatie',
  repeatEvery: 'Herhaalt elke',
  repeatEveryDays: 'dag(en)',
  repeatEveryWeeks: 'week(en)',
  repeatEveryMonths: 'maand(en)',
  repeatEveryYears: 'jaar',
  repeatOnce: 'Eén keer herhalen',
  repeatEveryDay: 'Elke dag herhalen',
  repeatEveryWeek: 'Elke week herhalen',
  repeatEveryMonth: 'Elke maand herhalen',
  repeatEveryYear: 'Elk jaar herhalen',
  selectRepeatOption: 'Herhalingsoptie selecteren',
  autoSnooze: 'Automatisch alarmen sluimeren',
  autoSnoozePerAlarm: 'Automatisch sluimeralarm',
  unableToUploadGroupAvatar:
    'Kan nu geen groepsafbeelding uploaden. Probeer het later opnieuw',
  addNewMembersToExistingAlarms:
    'Je hebt de volgende alarmen met deze groep:\n\n{{alarmNames}}\n    \nWil je de nieuwe leden toevoegen aan deze alarmen?',
  removeGroupMemberAlert:
    'Het verwijderen van het lid heeft invloed op de volgende alarmen:\n\n{{alarmNames}}\n\nWil je het lid nog steeds verwijderen?',
  leaveGroupAlert:
    'Het verlaten van de groep heeft gevolgen voor de volgende alarmen:\n\n{{alarmNames}}\n\nWil je de groep nog steeds verlaten?',
  updateAppAfterFeedback:
    'We hebben gemerkt dat je een oudere versie van de app gebruikt. Werk deze bij voor een betere ervaring.',
  changesAreLost:
    'Je hebt niet-opgeslagen wijzigingen.\n\nWilt u opslaan voordat u vertrekt?',
  recipientAlarmIntervalGreaterThanRepetitionInterval:
    'Het "Herinner me" interval moet korter zijn dan het herhalingsinterval.',
  cascadingAlarmIntervalGreaterThanRepetitionInterval:
    '"Het interval tussen deelnemerswaarschuwingen moet kleiner zijn dan het herhalingsinterval.',
  subscriptionCanceled:
    'Uw premium abonnement is geannuleerd. Premiumfuncties zijn pas beschikbaar als u uw abonnement vernieuwt.',
  unableToRenewSubscription:
    'Er is een probleem opgetreden bij het verlengen van uw premium abonnement. Controleer of uw betalingsgegevens up-to-date zijn.',
  notice: 'Kennisgeving',
  ringerSettingsWillApplyToNewAlarms:
    'Wijzigingen die u aanbrengt in de geluids- en trilinstellingen zijn alleen van toepassing op nieuwe alarmen.\n\nVoor bestaande alarmen kunt u het alarm bewerken om de geluids- en trilinstellingen te wijzigen.',
  renew: 'Vernieuw',
  galarmPremium: 'Galarm Premium',
  payMonthly: 'Betaal maandelijks op {{price}} per maand',
  payYearly: 'Betaal jaarlijks op {{price}} per jaar',
  free: 'Gratis',
  unlimited: 'Onbeperkt',
  personalAlarms: 'Persoonlijk alarm',
  groupAlarms: 'Groepsalarmen',
  buddyAlarms: 'Buddy Alarms',
  alarmRepetitions: 'Herhalingen',
  ringtones: 'Beltonen',
  alarmHistory: 'Alarm Geschiedenis',
  base: 'Basis',
  advanced: 'Geavanceerd',
  complete: 'Volledig',
  alarmHistoryFree: 'Beperkt',
  phoneMusicAsRingtone: 'Telefoonmuziek als ringtone',
  startFreeTrial: 'Start 14 dagen gratis proefabonnement',
  chargedAtEndOfFreeTrial:
    'Na afloop van de gratis proefperiode van 14 dagen worden kosten in rekening gebracht, tenzij u uw abonnement annuleert.',
  chargedAtPurchase:
    'De prijs wordt in rekening gebracht op het moment van aankoop. De prijs is inclusief 20% introductiekorting.',
  lookingForLifetimePlan: 'Klik hier voor een levenslang plan >',
  monthlySubscription: 'Maandelijks',
  yearlySubscription: 'Jaarlijks',
  premiumRingtoneRequiresUpgrade:
    'Voor deze ringtone heb je een Premium-abonnement nodig.',
  defaultPremiumFeaturesDescription:
    'Upgrade naar Premium om deze coole functies in te schakelen.',
  groupAlarmsPremiumFeaturesDescription:
    'U hebt een premium abonnement nodig om meer dan 1 groepsalarm aan te maken.',
  instantAlarmsPremiumFeaturesDescription:
    'U hebt een premium abonnement nodig om meer dan 5 directe alarmen aan te maken.',
  buddyAlarmsPremiumFeaturesDescription:
    'Je hebt een premium abonnement nodig om meer dan 1 alarm voor iemand anders ("buddy") te maken.',
  shareableAlarmLinksPremiumFeaturesDescription:
    'Je hebt een premium abonnement nodig om meer deelbare alarmlinks te maken.',
  viewPremiumFeaturesDescription:
    'Bedankt dat je een premium gebruiker bent. Je premium plan biedt deze functies.',
  accessToPremiumFeatures: 'Premium-plannen bieden je de volgende functies:',
  alarmCategoryPremiumFeaturesDescription:
    'Je hebt een premium abonnement nodig om nieuwe categorieën te maken.',
  galarmWebMovedToToolsTab:
    'Galarm Web is verplaatst naar het tabblad Hulpmiddelen. Het zal in een toekomstige release uit Instellingen worden verwijderd.',
  linkedAccountsMovedToToolsTab:
    "Gekoppelde agenda's zijn verplaatst naar het tabblad Hulpmiddelen. Ze zullen in een toekomstige release uit Instellingen worden verwijderd.",
  galarmWebPremiumFeaturesDescription:
    'Je hebt een premium abonnement nodig om Galarm in een webbrowser te gebruiken.',
  personalAlarmsFeatureDescription:
    'Gebruik een persoonlijk alarm om wakker te worden, medicijnen in te nemen of een andere taak voor jezelf uit te voeren. Je kunt optioneel deelnemers toevoegen die worden gewaarschuwd als je een alarm mist, zodat ze je eraan kunnen herinneren. De deelnemers krijgen ook een melding als je het alarm als gedaan markeert.',
  groupAlarmsFeatureDescription:
    'Gebruik een groepsalarm voor groepsactiviteiten zoals uitstapjes, feestjes of andere evenementen. Het alarm gaat op hetzelfde moment af voor alle deelnemers en zij kunnen hun deelname bevestigen.',
  instantAlarmsFeatureDescription:
    'Gebruik dit alarm om een contactpersoon of een groep contactpersonen te waarschuwen voor een noodoefening, het begin van een spel, een dringende taak/vergadering en andere dergelijke gebeurtenissen die onmiddellijke aandacht vereisen.',
  buddyAlarmsFeatureDescription:
    'Maak alarmen aan voor iemand anders ("buddy") om ze te herinneren aan dingen die ze moeten doen. U wordt gewaarschuwd om de buddy eraan te herinneren als hij of zij het alarm mist. Je krijgt ook een melding als de buddy het alarm als gedaan markeert.',
  unlimitedAlarmsFeatureDescription: 'Maak meer groeps- en buddyalarmen.',
  instantAlarmsPremiumFeature: 'Noodmeldingen verzenden',
  alarmRepetitionsFeatureDescription:
    'Maak alarmen met geavanceerde herhalingen zoals elke 30 minuten, elke 2 uur 45 minuten, om de dag, tweewekelijks en nog veel meer.',
  ringtonesFeatureDescription:
    'Kies uit een grote verscheidenheid aan eersteklas ringtones voor je alarmen. We voegen voortdurend meer ringtones toe aan het premiumaanbod.',
  phoneMusicAsRingtoneFeatureDescription:
    'Kies een willekeurig nummer/muziek op je telefoon als alarmringtone.',
  shareableAlarmLinksFeatureDescription:
    'Je kunt alarmen delen met anderen via een link.\n\nEen leerkracht kan bijvoorbeeld de link naar het klasalarm delen met leerlingen via e-mail, WhatsApp of een andere berichtenapp. Als leerlingen op de link tikken, wordt er een kopie van het klassenalarm gemaakt op hun telefoon. Alle leerlingen worden op het opgegeven tijdstip gewaarschuwd om naar de klas te komen.',
  instantAlarmFeatureDescription:
    'Waarschuw onmiddellijk een groep mensen met één klik op een knop.\n\nGebruik dit alarm om hen te waarschuwen voor een noodoefening, het begin van een wedstrijd, een dringende taak/vergadering en andere gebeurtenissen die onmiddellijke aandacht vereisen.',
  alarmHistoryFeatureDescription:
    'Bekijk alle reacties uit het verleden voor elk herhalend alarm. Zo kun je gemakkelijk achterhalen wanneer je je gymles hebt gemist, je moeder haar medicijnen heeft gemist, enz.',
  announceAlarmTitleFeatureDescription:
    'Kondig de alarmtitel aan wanneer het alarm afgaat.',
  exportToCalendarPremiumFeaturesDescription:
    'Je hebt een premium abonnement nodig om meer alarmen naar de kalender te exporteren.',
  exportToCalendarFeatureDescription:
    'Je kunt alarmen exporteren naar je kalender. Zo kun je je alarmen gemakkelijk bekijken in de agenda van je apparaat en je beschikbaarheid beter weergeven.',
  galarmWebFeatureDescription:
    'Gebruik Galarm in een webbrowser om alarmen aan te maken, te bewerken en te verwijderen.',
  preReminderFeatureDescription:
    'Stel herinneringen in om gewaarschuwd te worden voor komende alarmen. Je kunt de relatieve duur configureren om gewaarschuwd te worden vóór de eigenlijke alarmtijd, zoals 30 minuten ervoor, 1 dag ervoor, enz.',
  autoSnoozeCountUpgradeTitle:
    'Het instellen van een sluimerstand hoger dan 2 vereist een premium abonnement',
  higherAutoSnoozeCountPerAlarm:
    'U kunt een hoger aantal sluimeringen instellen per alarm. Bewerk de instellingen "Geluid en Trilling" tijdens het maken of bewerken van een alarm.',
  calendarViewFeatureDescription:
    'Bekijk alarmen in een kalender om gemakkelijk je alarmen voor elke dag te zien.',
  updatePhoneNumberFeatureDescription:
    'U kunt uw telefoonnummer dat voor deze account wordt gebruikt, wijzigen. Al uw alarmen, contactpersonen, groepen en andere instellingen worden naar het nieuwe telefoonnummer gemigreerd.',
  alarmPhotoFeatureDescription:
    'Voeg een foto toe aan een alarm voor snelle visuele aanwijzingen, zoals een foto van: een medicijn, instructies voor een taak, een voorwerp, enz. De foto wordt weergegeven wanneer het alarm afgaat.',
  taskListFeatureDescription:
    'Maak takenlijsten om gerelateerde taken bij elkaar te houden.',
  taskAlarmPremiumFeature: 'Taakalarmen',
  taskAlarmFeatureDescription:
    'Stel alarmen in voor individuele taken of hele takenlijsten om op het juiste moment herinnerd te worden.',
  duplicateAlarmPremiumFeature: 'Duplicaat alarm',
  duplicateAlarmFeatureDescription:
    'Maak snel kopieën van een alarm met dezelfde instellingen en breng wijzigingen aan voordat je het opslaat.',
  calendarViewPremiumFeature: 'Kalenderweergave',
  showingAlarmsForDate: 'Alarmen weergeven voor {{date}}',
  updatePhoneNumberPremiumFeature: 'Telefoonnummer wijzigen',
  alarmNotFound: 'Alarm niet gevonden',
  alarmNotFoundMessage:
    'Dit alarm is mogelijk onlangs verwijderd. Tik op "Verwijderen" om verdere meldingen voor dit alarm uit te schakelen.',
  alarmExistsWithDeepLinkTitle: 'Duplicaat alarm',
  alarmExistsWithDeepLinkMessage:
    'Een alarm dat met deze link is aangemaakt, bestaat al op uw telefoon.',
  errorCreatingSharedAlarmLink:
    'Kan geen gedeelde alarmkoppeling maken. Probeer het opnieuw.',
  alarmDoesntHaveNextDate: 'Alarm heeft geen geldige volgende datum.',
  sharePersonalAlarmDeepLinkDescription:
    'Raak deze link aan om een alarm aan te maken voor deze gebeurtenis op {{dateString}}.',
  joinGroupAlarmDeepLinkDescription:
    'Klik op deze link om deel te nemen aan dit groepsevenement op {{dateString}}',
  subscribedAlarmEdited:
    '{{alarmCreatorName}} heeft {{alarmName}} bijgewerkt. Wilt u uw alarm bijwerken?',
  subscribedAlarmDeleted:
    '{{alarmCreatorName}} heeft {{alarmName}} verwijderd. Wilt u uw alarm verwijderen?',
  responseReceivedForTicket:
    'We hebben gereageerd op je ticket #{{ticketId}} op: {{email}}. Als het niet in uw Postvak IN staat, controleer dan uw spammappen voor een e-mail van support@galarm.zendesk.com.',
  newTicketReceived:
    'Bedankt voor het schrijven. We hebben ticket #{{ticketId}} aangemaakt om je verzoek te volgen.\n\nWe zullen reageren op het e-mailadres dat je hebt opgegeven: {{email}}. Als dit niet correct is, dien dan uw feedback opnieuw in met het juiste e-mailadres.\n\nVoeg ook support@galarm.zendesk.com toe aan uw e-mail adresboek om er zeker van te zijn dat onze antwoorden goed aankomen. We sturen hier ook een melding wanneer we op je verzoek hebben gereageerd.',
  sentAccountBackup:
    'We hebben uw alarmgegevens verzonden naar {{email}}. Als het niet in uw Postvak IN staat, controleer dan uw spammappen voor een e-mail van noreply@acintyo.com.',
  alarmDoesntExist: 'Alarm bestaat niet.',
  shareAlarm: 'Alarmlink delen',
  shareAlarmDescription:
    'Je kunt dit alarm met iedereen delen via een link zonder ze toe te voegen als contact. Als iemand op de link op zijn telefoon tikt, wordt er een kopie van het alarm gemaakt.',
  shareLink: 'Link delen',
  joinedGroupAlarmFromDeepLinkMessage:
    'U wordt herinnerd aan "{{alarmName}}" op {{alarmTime}} op {{alarmDate}}',
  joinedRepeatingGroupAlarmFromDeepLinkMessage: {
    zero: 'Je wordt herinnerd aan "{{alarmName}}" {{repetitionString}}',
    one: 'U wordt herinnerd aan "{{alarmName}}" {{repetitionString}} bij {{alarmTime}} vanaf {{alarmDate}}'
  },
  youHaveSubscribedToThisAlarm: 'Je volgt dit alarm van {{creatorName}}.',
  alreadySharedAlarmDescription: {
    zero: 'Je hebt geen volgers voor dit alarm.\n\nU kunt dit alarm met meer mensen blijven delen via een link. Als ze op de link tikken, wordt er een kopie van dit alarm op hun telefoon gemaakt.',
    one: '{{count}} persoon volgt dit alarm.\n\nJe kunt dit alarm blijven delen met meer mensen via een link. Als ze op de link tikken, wordt er een kopie van dit alarm op hun telefoon gemaakt.',
    other:
      '{{count}} mensen volgen dit alarm.\n\nJe kunt dit alarm blijven delen met meer mensen via een link. Als ze op de link tikken, wordt er een kopie van dit alarm op hun telefoon gemaakt.'
  },
  shareParentAlarmDescription:
    'Je volgt dit alarm van {{creatorName}}.\n\nU kunt dit alarm ook delen met anderen via een link. Als ze op de link tikken, wordt er een kopie van dit alarm op hun telefoon gemaakt en kunnen ze dit alarm ook gaan volgen.',
  shareableAlarmLinks: 'Deelbare koppelingen',
  nPeopleFollowingAlarm: {
    zero: 'Je hebt geen volgers voor dit alarm.',
    one: '{{count}} persoon volgt dit alarm.',
    other: '{{count}} mensen volgen dit alarm.'
  },
  likeUsOnFacebook: 'Facebook',
  followUsOnTwitter: 'X (voorheen Twitter)',
  followUsOnInstagram: 'Instagram',
  youtube: 'YouTube',
  mediumBlog: 'Blogs op Medium',
  howtoVideos: "Instructievideo's",
  followGalarmOnSocialMedia: 'Volg Galarm op sociale media',
  galarmOnSocialMedia: 'Galarm op sociale media',
  followGalarmOnSocialMediaDescription:
    'Bekijk spannend nieuws over app-updates, het gebruik van functies, aankomende functies en belangrijke app-recensies. Je kunt er ook communiceren met het Galarm-team.',
  sharedAlarm: 'Gedeeld alarm bewerken',
  editingPublishedAlarm: {
    one: 'U bewerkt een alarm dat u eerder hebt gedeeld met behulp van een link. {{count}} persoon volgt momenteel dit alarm.\n\nAls u wijzigingen aanbrengt in dit alarm, wordt deze persoon op de hoogte gebracht van de wijzigingen.',
    other:
      'U bewerkt een alarm dat u eerder hebt gedeeld via een link. {{count}} mensen volgen momenteel dit alarm.\n\nAls u wijzigingen aanbrengt in deze waarschuwing, worden zij op de hoogte gebracht van de wijzigingen.'
  },
  editingSubscribedAlarm:
    'U volgt dit alarm van {{creatorName}}. U ontvangt geen updates voor dit alarm nadat u het alarm hebt bewerkt.',
  viewAlarm: 'Bekijk alarm',
  view: 'Bekijk',
  editAlarm: 'Alarm bewerken',
  editTimeForNextOccurrence: 'Bewerk tijd voor volgende gebeurtenis',
  editedNextOccurrenceConfirmation:
    'Dit alarm is bijgewerkt om na de bewerkte gebeurtenis af te gaan, en er is een apart alarm aangemaakt voor de bewerkte gebeurtenis.',
  thanksForTryingPremiumTitle: 'Je bent er helemaal klaar voor!',
  thanksForTryingPremiumMessage:
    'We hopen dat je geniet van de premium functies.\n\nNeem contact op met ondersteuning via "Instellingen > Feedback" of stuur een e-mail naar galarm@acintyo.com als je vragen hebt.',
  subscribedAlarmEditedInAlarmDetails:
    '{{creatorName}} hun alarm heeft gewijzigd.\nUw alarm updaten?',
  subscribedAlarmDeletedInAlarmDetails:
    '{{creatorName}} het alarm heeft verwijderd.\nUw alarm verwijderen?',
  updateSubscribedAlarm: 'Ja, bijwerken',
  deleteSubscribedAlarm: 'Ja, verwijderen',
  ignoreSubscribedAlarm: 'Nee, negeren',
  customRepetitionPremiumScreenDescription:
    'Aangepaste herhaling is een hoogwaardige functie.\n\nJe kunt deze functie gebruiken om alarmen met geavanceerde herhalingen te maken. Voorbeelden zijn:\n',
  specificDatesRepetitionPremiumScreenDescription:
    'Je kunt een alarm instellen om op specifieke data af te gaan met behulp van deze herhaling.',
  repeatAlternateDate: 'Herhaal op afwisselende dagen',
  repeatEveryNDay: 'Herhaal elke 3 dagen',
  repeatEveryNHoursAndMMinutes: 'Herhaal elke 2 uur 30 minuten',
  repeatEveryNMinutes: 'Herhaal elke 45 minuten',
  repeatBiweekly: '✅ Herhaal elke 2 weken',
  repeatEveryNWeeks: 'Herhaal elke 6 weken',
  repeatEveryNMonths: '✅ Herhaal elke 3 maanden (driemaandelijks)',
  repeatEveryLastDayOfMonth: 'Herhaal laatste dag van elke maand',
  repeatDayOfWeekOfMonth: 'Herhaling op de 2e zaterdag van elke maand',
  repeatLastDayOfWeekOfMonth: 'Herhaling op de laatste vrijdag van elke maand',
  customRepetition: 'Herhaling op maat',
  lastDayOfMonth: 'Laatste dag van elke maand',
  dayOfWeekInMonth: '{{weekNumberOfDayInMonth}} {{dayName}} van elke maand',
  lastDayOfWeekInMonth: 'Laatste {{dayName}} van elke maand',
  dayOfWeekInMonthInYearSummary:
    '{{weekNumberOfDayInMonth}} {{dayName}} van {{monthName}}',
  lastDayOfWeekInMonthInYearSummary: 'Laatste {{dayName}} van {{monthName}}',
  lastDayOfMonthInYearSummary: 'Laatste dag van {{monthName}}',
  dayOfWeekInMonthInYear:
    '{{weekNumberOfDayInMonth}} {{dayName}} van {{monthName}} elk jaar',
  lastDayOfWeekInMonthInYear: 'Laatste {{dayName}} van {{monthName}} elk jaar',
  lastDayOfMonthInYear: 'Laatste dag van {{monthName}} elk jaar',
  chooseAMonthsConfiguration: 'Kies een configuratie.',
  chooseADaysConfiguration: 'Kies een configuratie',
  chooseAYearsConfiguration: 'Kies een configuratie.',
  chooseAtLeastOneOccurrence: 'Kies minstens één voorval.',
  sendCodeAgain: 'Code opnieuw verzenden',
  didntGetCodeNewUser:
    'Heb je de code niet gekregen?\n\nJe kunt de code opnieuw aanvragen of de registratie voorlopig overslaan. Je kunt je later registreren.',
  didntGetCodeExistingUser:
    'Heb je de code niet gekregen?\n\nJe kunt de code opnieuw aanvragen of de registratie annuleren. Je kunt je later registreren.',
  didntGetCodeUpdatePhoneNumber:
    'Heb je de code niet gekregen?\n\nJe kunt de code opnieuw aanvragen of het later nog eens proberen.',
  alreadySentCodeAgain:
    'We hebben de code opnieuw naar je verzonden. Als je problemen hebt met het verkrijgen van de code, sla dan voorlopig de registratie over en registreer je later.',
  appearance: 'Uiterlijk',
  accentColor: 'Accentkleur',
  theme: 'Thema',
  announceAlarmName: 'Alarmtitel aankondigen',
  ttsHelperText:
    'De titel van het alarm wordt aangekondigd wanneer het alarm afgaat. Je kunt op de afspeelknop voor de alarmtitel tikken om een voorbeeld te horen.',
  initializingTts: 'Tekst naar spraak initialiseren',
  errorSpeakingAlarmName:
    'U kunt de titel van het alarm niet uitspreken. Neem contact op met de ondersteuning via "Instellingen > Feedback".',
  entityAlarm: 'alarm',
  entityGroup: 'groep',
  entityContact: 'neem contact op met',
  admin: 'Admin',
  specifyAlarmTitleToSpeak: 'Alarmtitel opgeven om te spreken',
  wakeup: 'Wakker worden',
  ttsPremiumScreenDescription:
    'Alarmtitel aankondigen is een premium functie.\n\nAls deze ingeschakeld is, wordt de alarmtitel aangekondigd wanneer het alarm afgaat.\n\nOm een voorbeeld te bekijken, geeft u een alarmtitel op en tikt u op afspelen.',
  unknownAlarmCategory: 'Onbekende alarmcategorie',
  cantAnnounceAlarmTitle: 'Alarmtitel wordt niet aangekondigd',
  ringtoneDurationIsSmall:
    'De beltoon moet minstens 5 seconden duren voordat de alarmtitel wordt aangekondigd.\n\nWilt u doorgaan met deze instellingen?',
  noActionItems: 'Geen actiepunten.',
  personNotInContacts: 'Deze persoon staat niet in je Galarm-contacten.',
  light: 'Licht',
  dark: 'Donker',
  systemDefault: 'Apparaatinstelling gebruiken',
  chooseTheme: 'Thema kiezen',
  dontSeeAllYourContacts: 'Zie je niet al je contacten?',
  lastContactsSyncedAt: 'Laatst gesynchroniseerd op {{dateString}}',
  refresh: 'Vernieuw',
  forever: 'Voor altijd',
  autoSnoozeConfiguration: 'Sluimerstand configureren',
  autoSnoozeConfigurationSummary:
    '{{autoSnoozeDurationLabel}}, {{autoSnoozeCountLabel}}',
  uncategorizedCategoryName: 'Niet gecategoriseerd',
  uncategorizedCategoryScreenTitle: 'Uncategorized',
  setAlarmCategory: 'Alarmcategorie instellen',
  changeAlarmCategory: 'Alarmcategorie wijzigen',
  viewAlarmHistory: 'Alarmgeschiedenis bekijken',
  computingAlarmHistory: 'Samenvatting voor alarmgeschiedenis...',
  alarmByCategories: '{{name}} Alarmen',
  alarmCategories: 'Categorieën',
  editAlarmCategory: 'Categorie bewerken',
  deleteAlarmCategory: 'Categorie verwijderen',
  newAlarmCategoryTitle: 'Nieuwe categorie',
  newAlarmCategoryNamePlaceholder: 'Geef een naam op',
  editAlarmCategoryTitle: 'Categorie bewerken',
  alarmCategorySummary: {
    zero: '{{alarmsSummary}}',
    one: '{{alarmsSummary}}, {{count}} gemist',
    other: '{{alarmsSummary}}, {{count}} gemist'
  },
  numAlarms: {
    zero: 'Geen alarmen',
    one: '{{count}} alarm',
    other: '{{count}} alarmen'
  },
  numIncidents: {
    zero: 'Geen incidenten',
    one: '{{count}} incident',
    other: '{{count}} incidenten'
  },
  openedIncidents: 'Geopende incidenten',
  closedIncidents: 'Afgesloten incidenten',
  incidentChart: 'Incidentenoverzicht (laatste 30 dagen)',
  incidentCalendar: 'Incidenten Kalender',
  incidentDistribution: 'Incidentenverdeling (laatste 30 dagen)',
  noIncidentsOpenedClosedInLast30Days:
    'Geen incidenten geopend of gesloten in de afgelopen 30 dagen',
  noIncidentsOpenedInLast30Days:
    'Geen incidenten geopend in de afgelopen 30 dagen',
  color: 'Kleur',
  createNewAlarmCategory:
    'Maak een nieuwe categorie door op de + knop rechtsonder te tikken',
  setValidName: 'Stel een geldige naam in',
  specifyTimezoneForAlarmMessage:
    'Je kunt een tijdzone opgeven wanneer je alarmen aanmaakt. De alarmen zullen afgaan volgens de opgegeven tijdzone. \n\nAls u "Apparaat tijdzone" kiest, zullen de alarmen afgaan volgens de tijdzone van uw apparaat.',
  selectDefaultTimezoneForAlarmDefaultTooltipMessage:
    'Kies een standaardtijdzone voor je wekkers. Je kunt de tijdzone voor alarmen wijzigen wanneer je ze aanmaakt.',
  alarmCategoryFeatureDescription:
    'Maak je eigen categorieën voor alarmen. Met categorieën kun je je alarmen gemakkelijk organiseren.',
  markAlarmDoneInAdvance: 'Alarm vroegtijdig "Gereed" markeren?',
  skipAlarmInAdvance: 'Alarm vroegtijdig "overslaan"?',
  markAlarmDoneInAdvanceMessageRepeatingAlarm:
    'Het alarm gaat niet af op {{dateTimeString}} als je nu "Gereed" markeert.',
  skipAlarmInAdvanceMessageRepeatingAlarm:
    'Het alarm gaat niet af op {{dateTimeString}} als je het nu overslaat.',
  markAlarmDoneInAdvanceMessageOneTimeAlarm:
    'Het alarm gaat niet af op {{dateTimeString}} als je nu "Gereed" markeert.',
  skipAlarmInAdvanceMessageOneTimeAlarm:
    'Het alarm gaat niet af op {{dateTimeString}} als je het nu overslaat.',
  alarmsByCategories: 'Alarmen per categorie',
  workAlarmCategory: 'Werk',
  homeAlarmCategory: 'Home',
  birthdaysAlarmCategory: 'Verjaardagen',
  more: 'Meer',
  alarmCategory: 'Alarm Categorie',
  editAlarmCategoryColor: 'Kleur bewerken',
  editAlarmCategoryColorTitle: 'Kleur bewerken voor {{name}}',
  allUserCategoriesDeleted:
    'Alle alarmcategorieën die u hebt aangemaakt, zijn verwijderd omdat het premium abonnement werd geannuleerd. Alarmen in die categorieën verschijnen in "Niet gecategoriseerd".',
  calendar: 'Kalender',
  eventExportedFromGalarm:
    '"Geëxporteerd uit Galarm op {{dateString}} op {{timeString}}."',
  unableToExportEventToCalendar:
    'Kan gebeurtenis niet exporteren naar de kalender. Controleer of je toestemming hebt gegeven voor toegang tot de kalender op het apparaat. Start de app opnieuw op en probeer het opnieuw als je toestemming hebt gegeven. Stuur ons feedback via "Instellingen > Feedback" als het probleem zich blijft voordoen.',
  scanQrCode:
    'Om toegang te krijgen tot Galarm via een browser, ga je naar web.galarm.app en scan je de QR-code.',
  logOut: 'Afmelden',
  useHere: 'Hier gebruiken',
  appRunningElsewhere:
    'U bent uitgelogd uit deze sessie. Wilt u deze sessie hervatten?',
  dateTime: 'Datum en tijd',
  selectAtLeastOneDayForRepetition:
    'Kies minstens één dag waarop het alarm moet worden herhaald.',
  chooseNumberOfDaysForAlarmRepetition:
    'Voer het aantal dagen in waarna het alarm moet worden herhaald.',
  chooseNumberOfWeeksForAlarmRepetition:
    'Voer het aantal weken in waarna het alarm moet worden herhaald.',
  chooseNumberOfMonthsForAlarmRepetition:
    'Voer het aantal maanden in waarna het alarm moet worden herhaald.',
  chooseNumberOfYearsForAlarmRepetition:
    'Voer het aantal jaren in waarna het alarm moet worden herhaald.',
  previouslySelectedContactsAreUnselected:
    'Eerder geselecteerde contactpersonen zijn niet meer geselecteerd.',
  previouslySelectedGroupIsUnselected:
    'Eerder geselecteerde groep is niet meer geselecteerd.',
  galarmWebInstructions:
    '1. Open de Galarm-app op uw telefoon\n2. Ga naar het tabblad "Instellingen" en tik op "Galarm Web".\n3. Zorg ervoor dat u de nieuwste app gebruikt als u de optie niet ziet.\n4. Scan de QR-code aan de rechterkant',
  likeToCreateAlarm: 'Maak een alarm voor...',
  payUtilityBills: 'Rekeningen betalen',
  wakeupAlarmName: 'Wakker worden',
  exerciseAlarmName: 'Oefening',
  drinkWaterAlarmName: 'Water drinken',
  everyNHoursRepetitionStringShortSummary: {
    one: '{{startTimeString}} naar {{endTimeString}} Elk uur',
    other: '{{startTimeString}} naar {{endTimeString}} Elke {{count}} uur'
  },
  firstTimeManagementQuote:
    '"Het slechte nieuws is dat de tijd vliegt. Het goede nieuws is dat jij de piloot bent."',
  firstTimeManagementQuoteAuthor: 'Michael Altshuler',
  secondTimeManagementQuote: '"Alle tijdmanagement begint met plannen."',
  secondTimeManagementQuoteAuthor: 'Tom Greening',
  thirdTimeManagementQuote:
    '"Laat nooit tot morgen wachten wat je vandaag kunt doen."',
  thirdTimeManagementQuoteAuthor: 'Benjamin Franklin',
  fourthTimeManagementQuote:
    '"Tijd is wat we het liefst willen, maar wat we het slechtst gebruiken."',
  fourthTimeManagementQuoteAuthor: 'William Penn',
  fifthTimeManagementQuote:
    '"Over een jaar zou je misschien willen dat je vandaag was begonnen."',
  fifthTimeManagementQuoteAuthor: 'Karen Lamb',
  sixthTimeManagementQuote: '"Jij mag uitstellen, maar de tijd niet."',
  sixthTimeManagementQuoteAuthor: 'Benjamin Franklin',
  tapToGetStarted: 'Tik op "+" om te beginnen.',
  allCategories: 'Alle categorieën',
  createAlarmWithContact: 'Maak een alarm met {{name}}',
  createAlarmWithGroup: 'Maak een alarm met {{name}}',
  editGroup: 'Groep bewerken',
  discardChanges: 'Huidige wijzigingen worden verwijderd. Doorgaan?',
  alarmWillRingEveryNDays: {
    zero: 'Het alarm gaat elke dag af.',
    one: 'Het alarm gaat om de dag af.',
    other: 'Het alarm gaat elke {{dayWithOrdinal}} dag af.'
  },
  hoursString: {
    zero: '',
    one: '1 uur',
    other: '{{count}} uren'
  },
  minutesString: {
    zero: '',
    one: '1 minuut',
    other: '{{count}} minuten'
  },
  alarmWillRingEveryMHoursAndNMinutes:
    'Het alarm gaat na elke {{repeatString}} af, te beginnen met {{dayString}}. Daarna {{otherDaysString}} enzovoort.',
  alarmWillRingEveryNWeeks: {
    zero: 'Het alarm gaat elke week af.',
    one: 'Het alarm gaat tweewekelijks af.',
    other: 'Het alarm gaat elke {{weekWithOrdinal}} week af.'
  },
  alarmWillRingEveryNMonths: {
    zero: 'Het alarm gaat elke maand af.',
    one: 'Het alarm gaat tweemaandelijks af.',
    other: 'Het alarm gaat elke {{monthWithOrdinal}} maand af.'
  },
  alarmWillRingEveryNYears: {
    zero: 'Elk jaar gaat het alarm af.',
    one: 'Het alarm gaat twee keer per jaar af.',
    other: 'Het alarm gaat elk jaar af op {{yearWithOrdinal}}.'
  },
  ringParticipantAlarmsByDefaultTooltipMessage:
    'Als deze voorkeur is ingeschakeld, zullen alarmen van anderen afgaan zonder dat ze worden geaccepteerd. Je moet het alarm nog steeds accepteren om de maker te laten weten dat je van plan bent om deel te nemen aan het alarm.\n\nAls deze voorkeur is uitgeschakeld, gaan alarmen die door anderen voor jou zijn toegevoegd niet af op je telefoon, tenzij je ze expliciet accepteert.',
  specifyTimezoneForAlarmDefaultTooltipMessage:
    'Als deze voorkeur is ingeschakeld, kun je een tijdzone opgeven wanneer je alarmen aanmaakt. De alarmen zullen afgaan volgens de opgegeven tijdzone.\n\nAls deze voorkeur is uitgeschakeld, gaan de alarmen af volgens de tijdzone van het apparaat.',
  ringOnEarphoneOnlyTooltipTitle:
    'Alarmgedrag wanneer oortelefoon is aangesloten',
  ringOnEarphoneOnlyTooltipMessage:
    'Als er oortelefoons zijn aangesloten, kunt u uw alarmen zo instellen dat ze alleen afgaan op de oortelefoons of zowel op de luidspreker van de telefoon als op de oortelefoons.\n\nAls er geen oortelefoon is aangesloten, gaan de alarmen af via de luidspreker van de telefoon.',
  gestureOptionsTooltipTitle: 'Gebaar om een alarm af te zetten',
  gestureOptionsTooltipMessage:
    'Als een alarm afgaat op het vergrendelscherm, kun je het afzetten door op een knop te tikken of een knop te verschuiven.\n\nMet deze instelling kun je kiezen hoe je een alarm wilt afwijzen.',
  notificationSettingsTooltipTitle: 'Instellingen meldingen',
  notificationSettingsTooltipMessage:
    'Schakel de meldingen in die je wilt ontvangen en schakel de meldingen uit die je niet wilt ontvangen.',
  messagesForAlarm: 'Berichten voor {{name}}',
  systemNotificationsTooltipMessage:
    'Meldingen gegenereerd door de app voor gebeurtenissen zoals:\n  - wanneer alarmen worden beïnvloed als gevolg van contactpersonen die van tijdzone veranderen\n  - wanneer een uitgenodigd contact zich registreert op Galarm\n  - wanneer alarmen worden beïnvloed doordat iemand zijn account verwijdert',
  galarmWebNotificationsTooltipMessage:
    'Kennisgevingen die naar u worden verzonden vanuit Galarm Web.',
  alarmsfromOthersNotificationsTooltipMessage:
    'Meldingen die worden verzonden wanneer je als deelnemer aan een alarm wordt toegevoegd.',
  alarmChatNotifictionsTooltipMessage:
    'Meldingen voor chatberichten in een alarm.',
  groupNotificationsTooltipMessage:
    'Meldingen die worden verzonden wanneer je aan een groep wordt toegevoegd, uit een groep wordt verwijderd of wanneer iemand anders aan een groep wordt toegevoegd of uit een groep wordt verwijderd.',
  alarmAcknowledgementNotificationsTooltipMessage:
    'Meldingen die worden verzonden wanneer een deelnemer een alarm bevestigt waaraan u ook deelneemt.',
  sharedAlarmNotificationsTooltipMessage:
    'Meldingen die worden verzonden:\n  - wanneer iemand zich via een link abonneert op een door u gedeeld alarm\n  - wanneer een alarm waarop u bent geabonneerd is gewijzigd',
  pinMode: 'Pin modus',
  pinModeTooltipMessage:
    "Schakel deze voorkeur in als je de app hebt vastgemaakt aan de bovenkant van je scherm met behulp van Android's functie voor het vastmaken van apps.",
  sleepTimer: 'Slaap Muziek',
  sleepTimerTitle: 'Muziek afspelen voor',
  ongoingSleepTimer: 'Slaapmuziek Blijvend',
  stopSleepTimer: 'Wil je de huidige muziek stoppen?',
  restartSleepTimer: 'Wil je de huidige muziek stoppen en een nieuwe starten?',
  play: 'Speel',
  youAreOffline:
    'U bent momenteel offline. Ga online om bewerkingen uit te voeren.',
  alarmLinkRelativeToTimezone: '{{timeString}} in hun tijdzone.',
  alarmLinkNotRelativeToTimezone: 'Ieders wekker gaat af op {{timeString}}',
  alarmShouldRingAt: 'Bij iedereen gaat het alarm af:',
  sleepMusicTooltip:
    'Speel natuurlijke geluiden af om je lichaam en geest te ontspannen. De muziek stopt na de opgegeven duur.',
  alarmLinkCopiedToClipboard: 'Alarmlink gekopieerd naar klembord.',
  confirmLogOut: 'Wilt u uitloggen?',
  appNotRunningMessage:
    'We hebben gedetecteerd dat Galarm niet actief is op uw telefoon. Tik op om Galarm te starten zodat u geen belangrijke alarmen mist.',
  tapToEnterNotesForAlarm: 'Tik om notities in te voeren',
  accountAlreadyExists: 'Bestaande account gevonden',
  accountsMerged:
    'We hebben een bestaande account gevonden die is gekoppeld aan dit mobiele nummer. We hebben de twee accounts samengevoegd.',
  upgradeToPremiumToAssignUserDefinedCategory:
    'Upgrade naar Premium om een door de gebruiker gedefinieerde categorie te selecteren.',
  userDefinedCategoryNotSetForAlarm:
    'Upgrade naar Premium om automatisch een door de gebruiker gedefinieerde categorie toe te wijzen. Categorie is niet ingesteld voor het alarm.',
  alarmDetails: 'Alarm details',
  profileDetails: 'Profiel',
  activeWebSession:
    'U hebt al een actieve websessie. U kunt uitloggen uit die sessie of een nieuwe sessie starten.\n\nAls u een nieuwe sessie start, wordt u automatisch afgemeld bij de huidige actieve websessie.',
  startNewSession: 'Een nieuwe sessie starten',
  confirmWebSessionLogout:
    'Hiermee log je uit je huidige websessie. U kunt een nieuwe sessie starten door de code opnieuw te scannen.',
  defaultInstantAlarmTitleForGroup:
    '{{groupName}} Waarschuwing van {{creatorName}}',
  defaultInstantAlarmTitleForContact: 'Waarschuwing van {{creatorName}}',
  atleastOneMemberShouldBeActive: 'Ten minste één deelnemer moet actief zijn.',
  activeParticipants: 'Actieve deelnemers',
  acceptAlarm: 'Alarm accepteren',
  rejectAlarm: 'Alarm weigeren',
  nConfirmed: '{{count}} bevestigd',
  nDeclined: '{{count}} geweigerd',
  nPending: '{{count}} in afwachting van',
  everyoneConfirmed: 'Iedereen heeft bevestigd',
  everyoneDeclined: 'Iedereen heeft geweigerd',
  appTagline: 'Mis nooit meer iets',
  usePreviousBackup: 'Ik ben een geregistreerde gebruiker >',
  viewAlarmsByCategories: 'Bekijk alarmen per categorie',
  viewAllAlarms: 'Alle alarmen weergeven',
  switchToSummaryView: 'Overschakelen naar overzichtsweergave',
  switchToListView: 'Overschakelen naar lijstweergave',
  hideHourlyAlarms: 'Verberg uurlijkse alarmen',
  showHourlyAlarms: 'Uuralarmen tonen',
  calendarView: 'Galarm Kalender',
  viewRecentlyDeletedAlarms: 'Onlangs verwijderde alarmen weergeven',
  deletedOnDate: 'Verwijderd op {{alarmDate}}',
  recentlyDeletedAlarmFooterText: 'Dit alarm is verwijderd op {{alarmDate}}',
  noRecentlyDeletedAlarms: 'Geen recent verwijderde alarmen',
  restoreAlarmsFromMobileApp:
    'Deze alarmen worden na 30 dagen automatisch verwijderd. Als je ze wilt herstellen, ga dan naar het scherm "Onlangs verwijderde alarmen" van je mobiele app en tik op het herstelpictogram.',
  deleteExpiredAlarms: 'Verwijder gemiste alarmen',
  deleteInactiveAlarms: 'Inactieve alarmen verwijderen',
  deleteAlarms: 'Alarmen verwijderen',
  enableAlarms: 'Wekkers inschakelen',
  disableAlarms: 'Wekkers uitschakelen',
  noItemsToDisplay: 'Geen items om weer te geven',
  sent: 'Verzonden',
  received: 'Ontvangen',
  defaultConfigurationUpdated: 'De standaardconfiguratie is bijgewerkt.',
  notAlerted: '(uitgesloten)',
  alarmKeepsRingingHelp: 'Help! Mijn alarm blijft afgaan',
  alarmKeepsRingingHelpMessage:
    'We hebben uw alarmen vernieuwd en het probleemrapport verzonden.',
  alarmKeepsRingingHelpAlert:
    'We zullen uw alarmen vernieuwen en u zou dit probleem niet langer moeten waarnemen. We sturen ook een probleemrapport naar ons ondersteuningsteam voor verder onderzoek.\n\n  Als het probleem zich blijft voordoen, neem dan contact met ons op via "Instellingen > Feedback".',
  sendingFeedback: 'Feedback sturen',
  sendingProblemReport: 'Probleemrapport verzenden',
  fixingAlarms: 'Uw alarmen verversen',
  existingAccountFound: 'Back-up hersteld',
  existingAccountDataRestored: {
    zero: 'Gefeliciteerd, alle gegevens zijn hersteld vanaf de back-up.',
    one: 'Gefeliciteerd, alle gegevens zijn hersteld vanaf de back-up.',
    other: 'Gefeliciteerd, alle gegevens zijn hersteld vanaf de back-up.'
  },
  noExistingAccountFound: 'Geen back-up gevonden',
  createdNewAccount:
    'Dit telefoonnummer is nog niet geregistreerd bij Galarm. We hebben een nieuwe account aangemaakt met dit telefoonnummer.',
  iosCloseToAllowedNumNotificationsScheduled:
    "Je bent bijna aan de limiet van het iOS-systeem voor geplande meldingen.\n\nOm ervoor te zorgen dat je alarmen op tijd afgaan, schakel je 'Verbeterde alarmbezorging' in onder 'Instellingen (tabblad) → Geavanceerde instellingen'.\n\nDeze premiumfunctie maakt gebruik van de servers van Galarm om alarmmeldingen betrouwbaar te bezorgen wanneer de limieten van het iOS-systeem zijn bereikt. Hiervoor is een actieve internetverbinding vereist.",
  acknowledgeAlarmToScheduleNextOccurrence:
    'Dit is de laatste melding voor dit alarm. Druk lang op deze melding en onderneem een actie om het volgende optreden van dit alarm te plannen.',
  lastNotificationForOneTimeAlarm: 'Dit is de laatste melding voor dit alarm.',
  criticalAlertsMessageTitle:
    'Laat alarmen afgaan wanneer je telefoon is gedempt',
  criticalAlertsMessageDescription:
    '\nJe kunt Galarm configureren om iOS-kritieke waarschuwingen te gebruiken om alarmen af te laten gaan wanneer je telefoon is gedempt. Wilt u dit inschakelen voor alle alarmen?\n\nJe kunt het ook selectief inschakelen voor sommige alarmen door de instelling "Geluid en trilling > Kritieke alarmen" te bewerken.',
  allowCriticalAlerts: 'Kritieke waarschuwingen toestaan',
  criticalAlertsPermissionDenied:
    'Galarm heeft toestemming van uw telefoon nodig om kritieke waarschuwingen weer te geven. Schakel deze toestemming in bij de instellingen van uw telefoon.',
  enableCriticalAlertsForAllAlarms: 'Ja, inschakelen voor alle alarmen',
  selectivelyEnableCriticalAlerts: 'Nee, ik schakel selectief in',
  firstName: 'Voornaam',
  lastName: 'Achternaam',
  email: 'E-mail',
  password: 'Wachtwoord',
  confirmPassword: 'Wachtwoord bevestigen',
  signup: 'Aanmelden',
  login: 'Inloggen',
  alreadySignedUp: 'Heb je je al ingeschreven?',
  notAUser: 'Geen gebruiker?',
  subscribe: 'Aanmelden',
  configurePlan: 'Plan configureren',
  choosePlan: 'Kies een plan',
  billingCycle: 'Factureringscyclus',
  needHelpToGetStarted: 'Hulp nodig om te beginnen?',
  browser: 'Browser: {{name}}',
  deviceOs: 'Apparaat: {{name}}',
  lastActive: 'Laatst actief: {{timestamp}}',
  signUp: 'Aanmelden',
  useGalarmOnWeb: 'Galarm gebruiken op het web',
  welcomeUser: 'Welkom {{name}}',
  changePassword: 'Wachtwoord wijzigen',
  saveAlarm: 'Alarm opslaan',
  galarmUserTip: 'Wist je dat?',
  sendAlarm: 'Alarm verzenden',
  saveGroup: 'Groep opslaan',
  webAppBestViewedOnDesktop:
    'De URL (web.galarm.app) is voor het starten van een Galarm-interface in een webbrowser op je laptop of desktop.\n\nAls u Galarm op uw mobiele apparaat wilt gebruiken, installeert u de Android-app van Google Play of de iOS-app van de App Store via een van de onderstaande koppelingen:',
  scanQrCodeMessage: 'QR-code scannen',
  reloadQrCode: 'Klik om QR code opnieuw te laden',
  invalidQrCodeScanned: 'Ongeldige QR-code gescand.',
  unableToScanCode: 'Kan code niet scannen',
  unableToScanCodeMessage:
    'Er is een probleem opgetreden bij het scannen van de code. Probeer het opnieuw. Als je problemen blijft ondervinden, stuur ons dan feedback vanuit de mobiele app via "Instellingen > Feedback".',
  problemWithEnterpriseAccountSetup:
    'Er is een probleem opgetreden bij het instellen van uw Galarm Pro-account. Neem contact op met de technische ondersteuning.',
  problemWithCreatingCheckoutSession:
    'Er is een probleem opgetreden bij het aanmaken van een afrekensessie. Neem contact op met de technische ondersteuning.',
  unableToLoadPremiumPlans:
    'Kan premiumplannen niet laden. Probeer het later opnieuw.',
  noPlanSelected: 'Selecteer een plan voordat u doorgaat.',
  problemWithCreatingCustomerPortalSession:
    'Er is een probleem opgetreden bij het aanmaken van een klantportaalsessie. Neem contact op met de technische ondersteuning.',
  problemWithCreatingApiKey:
    'Er is een probleem opgetreden bij het aanmaken van een API-sleutel. Neem contact op met de technische ondersteuning.',
  creatingAnAccount: 'Een account aanmaken',
  currentPlan: 'Huidig plan: {{name}} ({{quantity}} zetels)',
  myAccount: 'Accountgegevens',
  new: 'Nieuw',
  deleteAllAlarmHistoryAlertTitle: 'Alarmgeschiedenis verwijderen',
  deleteAllAlarmHistoryAlertMessage:
    'Tik op "Doorgaan" om de geschiedenis voor dit alarm te wissen. Deze actie kan niet ongedaan worden gemaakt.',
  ageOutInactiveAlarmsMessage:
    'Je hebt {{count}} alarmen die al meer dan 60 dagen inactief zijn. Veel inactieve alarmen kunnen de prestaties van de app beïnvloeden.\n\nWil je deze alarmen verwijderen?',
  duplicateAlarm: 'Duplicaat alarm',
  graduallyIncreaseVolume: 'Verhoog geleidelijk het volume',
  graduallyIncreaseVolumeTooltipMessage:
    'Als deze voorkeur is ingeschakeld, neemt het alarmvolume geleidelijk toe tot het ingestelde beltoonvolume. Hierdoor kun je het alarm stoppen voordat het te luid wordt.\n\nAls deze voorkeur is uitgeschakeld, gaan alarmen af op het ingestelde beltoonvolume gedurende de volledige beltoonduur.',
  shakeToStopAlarm: 'Schud om alarm te stoppen',
  shakeToStopAlarmTooltipMessage:
    'Als deze voorkeur is ingeschakeld, kun je je telefoon schudden om een rinkelend alarm te stoppen. Als automatisch snoozen is geconfigureerd, wordt het alarm in plaats daarvan gesnoozed.',
  shakeToStopAlarmNotAvailable:
    'Schudden om alarm te stoppen is niet beschikbaar op dit apparaat.',
  shakeSensitivity: 'Schudgevoeligheid',
  shakeSensitivityVeryHigh: 'Zeer hoog',
  shakeSensitivityHigh: 'Hoog',
  shakeSensitivityMedium: 'Gemiddeld',
  shakeSensitivityLow: 'Laag',
  shakeSensitivityVeryLow: 'Zeer laag',
  shakeTestInstructions:
    'Schud je telefoon om te testen. De balk vult zich wanneer er beweging wordt gedetecteerd; groen betekent dat het alarm zou stoppen. Je voelt ook een trilling wanneer het alarm zou stoppen.',
  teams: 'Teams',
  alerts: 'Waarschuwingen',
  listeners: 'Luisteraars',
  noMembersConfiguredInEnterpriseAccount: `U heeft nog geen leden toegevoegd.

Leden zijn gebruikers die kunnen worden gewaarschuwd wanneer er incidenten plaatsvinden in uw organisatie. Deze mensen moeten al geregistreerd zijn bij Galarm.`,
  noMembersConfiguredInBusinessAccount: `Je hebt nog geen leden toegevoegd.

Leden zijn gebruikers aan wie je Galarm premiumfuncties wilt toekennen. Deze mensen moeten al geregistreerd zijn bij Galarm.`,
  noTeamsConfiguredInEnterpriseAccount: `U heeft nog geen teams aangemaakt.

Teams zijn groepen van leden die samen kunnen worden gewaarschuwd wanneer er incidenten plaatsvinden in uw organisatie.`,
  noAlertsConfiguredInEnterpriseAccount: `U heeft nog geen luisteraars aangemaakt.

Luisteraars monitoren incidenten in uw organisatie. U kunt definiëren welke leden of teams worden gewaarschuwd wanneer een incident wordt gedetecteerd, en escalatieregels instellen als het niet op tijd wordt erkend.

Elke luisteraar biedt een webhook die u kunt integreren met uw monitoringtools om incidenten automatisch te activeren wanneer aan de voorwaarden wordt voldaan. U kunt ook handmatig incidenten aanmaken vanuit de app wanneer er iets aandacht nodig heeft.`,
  noShiftsConfiguredInEnterpriseAccount:
    'Je hebt nog geen shiftconfiguratie gemaakt.',
  noRotationsConfiguredInEnterpriseAccount:
    'Je hebt nog geen rotaties gemaakt.',
  rotations: 'Rotaties',
  addRotation: 'Rotatie toevoegen',
  editRotation: 'Rotatie bewerken',
  enterRotationName: 'Voer rotatienaam in',
  rotationType: 'Type rotatie',
  numberOfHoursInRotation: 'Aantal uren in rotatie',
  numberOfDaysInRotation: 'Aantal dagen in rotatie',
  numberOfWeeksInRotation: 'Aantal weken in rotatie',
  specify: 'Specificeer...',
  noIntegrationsConfiguredInEnterpriseAccount:
    'Je hebt nog geen integratieconfiguraties geconfigureerd.',
  loadingUser: 'Gebruikersinformatie laden',
  addMember: 'Lid toevoegen',
  add: 'Voeg  toe',
  noUserFoundWithMobileNumber:
    'Geen geregistreerde Galarm-gebruiker gevonden met dit telefoonnummer. Zorg ervoor dat u het telefoonnummer invoert met de landcode zonder speciale tekens zoals haakjes, streepjes, spaties enz.',
  memberWithPhoneNumberAlreadyAdded:
    'Het lid met dit telefoonnummer is al toegevoegd.',
  memberWithEmailAlreadyAdded: 'Lid met dit e-mailadres is al toegevoegd.',
  assignKeyToMember: 'Licentiesleutel toewijzen',
  revokeKeyFromMember: 'Licentiesleutel intrekken',
  cantAssignKeyToMember: 'Kan geen sleutel toewijzen aan lid',
  noEnterpriseLicenseKeyAvailable:
    'Er zijn geen licentiesleutels beschikbaar. Upgrade je plan.',
  addTeam: 'Team toevoegen',
  enterTeamName: 'Voer een teamnaam in',
  addAlert: 'Listener toevoegen',
  critical: 'Kritisch',
  low: 'Laag',
  medium: 'Medium',
  high: 'Hoog',
  severity: 'Ernst',
  enterAlertName: 'Voer een naam in voor de luisteraar',
  organization: 'Organisatie',
  startTime: 'Starttijd',
  endTime: 'Eindtijd',
  shiftName: 'Shift {{index}}',
  addShift: 'Shift toevoegen',
  assignees: 'Geadresseerden',
  shiftStartEndTime: '{{startTime}} - {{endTime}}',
  assignee: 'Geadresseerde',
  specifyAssigneeForShift: 'Geef aan wie verantwoordelijk is voor de dienst',
  selectAtLeastOneMember: 'Selecteer minstens één lid',
  editMember: 'Bewerk lid',
  editTeam: 'Team bewerken',
  cantRemoveMemberAssignedToTeamsOrAlerts:
    'Lid maakt deel uit van een team of is toegewezen aan een luisteraar. Verwijder het lid van deze teams/luisteraars voordat je het verwijdert.\nTeams: {{teams}}\nLuisteraars: {{alerts}}',
  cantRevokeKeyFromMemberAssignedToTeamsOrAlerts:
    'Lid maakt deel uit van een team of is toegewezen aan een luisteraar. Verwijder het lid uit deze teams/luisteraars voordat je de sleutel intrekt.\nTeams: {{teams}}\nLuisteraars: {{alerts}}',
  cantDeleteTeamAssignedToAlerts:
    'Team maakt deel uit van een luisteraar. Verwijder het team van de luisteraar voordat je het verwijdert.\nLuisteraars: {{alerts}}',
  cantDeleteRotationAssignedToAlerts:
    'Rotatie is onderdeel van een luisteraar. Verwijder het team van de luisteraar voordat je het verwijdert.\nLuisteraars: {{alerts}}',
  editAlert: 'Listener bewerken',
  timezoneDisplayString: '(GMT{{offset}}) {{timezone}}',
  apiKey: 'API-sleutel',
  viewApiKey: 'Bekijk API-sleutel',
  apiKeyWarningMessage:
    'Houd uw API-sleutel te allen tijde veilig. Deel hem met niemand. Als je denkt dat je API-sleutel gecompromitteerd is, klik dan op de knop "Wijzigen" hierboven om hem te wijzigen. Nadat je de sleutel hebt gewijzigd, moet je de nieuwe sleutel opgeven op alle plaatsen waar je incidenten activeert met behulp van de REST API',
  integrationConfigs: 'Integratie configuraties',
  addIntegrationConfig: 'Integratieconfiguratie toevoegen',
  editIntegrationConfig: 'Integratieconfiguratie bewerken',
  integrationSource: 'Integratie Bron',
  apiToken: 'API-token',
  integrations: 'Integraties',
  selectPlaceholder: 'Selecteer...',
  chooseRoleForMember: 'Kies een rol voor het lid',
  zendeskSubdomain: 'Zendesk Subdomein',
  creatorTimeForBuddyAlarm: '{{timeString}} ({{remindMeAfter}})',
  nextFiveAlarms: 'Volgende 5 alarmen',
  categories: 'Categorieën',
  viewingAlarmsDueToday: 'Alarm bekijken vandaag',
  viewingAlarmsDueTomorrow: 'Alarmmeldingen morgen inleveren',
  expiredAlarms: 'Gemiste alarmen',
  viewingExpiredAlarms: 'Gemiste alarmen bekijken',
  noAlarmsDueToday: 'Geen alarmen vandaag',
  noAlarmsDueTomorrow: 'Geen alarmen voor morgen',
  noExpiredAlarms: 'Geen gemiste alarmen',
  viewingAllAlarms: 'Alle alarmen bekijken',
  viewingRecentlyDeletedAlarms: 'Onlangs verwijderde alarmen bekijken',
  alarmsWillBeAutomaticallyDeleted:
    'Alarmen worden 30 dagen na verwijdering permanent verwijderd.',
  summaryView: 'Overzichtsweergave proberen?',
  summaryViewDescription:
    'Bekijk alarmen gerangschikt op vervaldatum en categorie.\n\nJe kunt terugschakelen naar de lijstweergave met de knop ⋮ rechtsboven.',
  disableBatteryOptimizationMessageOnStartup:
    'Galarm moet op de achtergrond draaien om alarmen betrouwbaar te laten afgaan. Geef toestemming op het volgende scherm.',
  disableBatteryOptimizationMessage:
    'Galarm moet op de achtergrond draaien om alarmen betrouwbaar te laten afgaan.',
  allowNotificationsToDisplayAlarms:
    'Galarm heeft toestemming nodig om meldingen te tonen wanneer alarmen afgaan.',
  scheduleExactAlarmsMessage:
    'Galarm heeft toestemming nodig om exacte alarmen te plannen.',
  alarmCategoryWithSameNameExists:
    'Er bestaat al een categorie met deze naam. Geef een andere naam op.',
  unlimitedAlarmsPremiumFeature: 'Onbeperkt Groeps- en Buddy-alarmen',
  alarmRepetitionsPremiumFeature: 'Geavanceerde Herhalingsopties',
  ringtonesPremiumFeature: 'Meer beltonen',
  galarmWebPremiumFeature: 'Galarm gebruiken op het web',
  taskListPremiumFeature: 'Meerdere takenlijsten maken',
  preReminderPremiumFeature: 'Herinnering vooraf voor alarmen',
  alarmCategoriesPremiumFeature: 'Aangepaste alarmcategorieën',
  shareableAlarmLinksPremiumFeature: 'Deelbare alarmkoppelingen',
  announceAlarmNamePremiumFeature: 'Alarmtitel aankondigen',
  manageSubscription: 'Abonnement beheren',
  modifySubscription: 'Abonnement wijzigen',
  purchaseRestored: 'Gerestaureerd kopen.',
  unableToRetrieveSubscriptionPlansAndroid:
    'We kunnen geen verbinding maken met Google Play om de upgrade uit te voeren. Controleer of je verbinding hebt met internet en probeer het opnieuw. \n\nMeld een probleem aan ons ondersteuningsteam als dit probleem zich blijft voordoen.',
  unableToRetrieveSubscriptionPlansIos:
    'We kunnen geen verbinding maken met de App Store om de upgrade uit te voeren. Zorg ervoor dat je verbinding hebt met internet en probeer het opnieuw. \n\nMeld een probleem aan ons ondersteuningsteam als dit probleem zich blijft voordoen.',
  drawOverOtherApps: 'Weergave boven andere apps',
  drawOverOtherAppsHelperText:
    'Galarm toestaan om alarmmeldingen bovenaan te tonen',
  nTimes: {
    one: '1 keer',
    other: '{{count}} keer'
  },
  learnHowToUseFocus: 'Focus leren',
  enhancedNotificationsDeprecated: 'Verbeterde meldingen Deprecated',
  enhancedNotificationsDeprecatedMessage:
    'We hebben ontdekt dat Verbeterde meldingen niet betrouwbaar zijn en overmatig batterijverbruik veroorzaken. Gebruik iOS Focus om Galarm alarmen te laten laten afgaan wanneer je telefoon op Niet storen staat.',
  usingIosFocus: 'iOS Focus gebruiken',
  iosFocusModePara1:
    'Galarm gaat niet over als de belsignaalschakelaar van de telefoon uit staat of als het volume van het belsignaal op 0 staat.\n\nApple raadt aan om "Focus" te gebruiken als u uw telefoon stil wilt houden maar toch wilt toestaan dat sommige apps u waarschuwen. Gebruik de volgende instructies om Focus op uw telefoon in te stellen.',
  iosFocusModePara2:
    'Je kunt meer gedetailleerde instructies met schermafbeeldingen bekijken op https://galarm.zendesk.com/hc/en-us/articles/10906890793236-Allow-alarms-to-ring-on-silent-on-iOS',
  settingFocus: 'Focus instellen:',
  settingFocusFootNotes:
    'Let op: Focus is beschikbaar op iOS 15 en hoger.\n\nNeem voor vragen of feedback contact met ons op via "Instellingen > Feedback".',
  enablingFocus: 'Focus mogelijk maken:',
  settingFocusInstruction1: 'Ga naar "Telefooninstellingen > Focus".',
  settingFocusInstruction2: 'Tik op het focusprofiel "Niet storen".',
  settingFocusInstruction3: 'Tik op "Apps" en voeg Galarm toe.',
  settingFocusInstruction4:
    'Doe hetzelfde voor andere Focus-profielen die je hebt ingesteld.',
  enablingFocusInstruction1:
    'Veeg vanaf de rechterbovenhoek naar beneden om het Control Center weer te geven.',
  enablingFocusInstruction2: 'Tik op Focus.',
  enablingFocusInstruction3:
    'Tik op Niet storen of een ander Focusprofiel dat je wilt inschakelen.',
  enablingFocusInstruction4:
    'Momenteel is Focus ingeschakeld. Je kunt er opnieuw op tikken om het uit te schakelen.',
  startDateForRotation: 'Begindatum voor rotatie',
  startTimeForRotation: 'Begintijd voor rotatie',
  member: 'Lid',
  multipleShiftsInADay: 'Meerdere diensten op een dag',
  escalationPolicy: 'Escalatiebeleid',
  atTimeOfEvent: 'Op het moment van het evenement',
  afterNMinutes: 'Na {{count}} minuten',
  afterNHours: {
    one: 'Na 1 uur',
    other: 'Na {{count}} uur'
  },
  afterDuration: 'Na {{durationString}}',
  addTrigger: 'Trigger toevoegen',
  viewCode: 'Bekijk code',
  apiCodes: 'API-codes',
  viewIncidents: 'Incidenten bekijken',
  viewInstantAlarms: 'Bekijk Directe Alarmen',
  viewTasks: 'Taken bekijken',
  incidentsForAlert: 'Incidenten voor luisteraar {{alertName}}',
  timestamp: 'Tijdstempel',
  notAcknowledged: 'Open',
  acknowledged: 'Erkend',
  closed: 'Gesloten',
  recovered: 'Automatisch hersteld',
  noIncidentsForAlert: 'Nog geen incidenten voor deze luisteraar',
  errorClosingIncident: 'Fout bij het afsluiten van incidenten',
  errorClosingIncidents: 'Fouten bij het afsluiten van incidenten',
  apiCodeCopiedToClipboard: 'API-code is gekopieerd naar het klembord.',
  triggerName: 'Trekker {{index}}',
  delay: 'Vertraging',
  chooseAssigneePlaceholder: 'Kies Geadresseerde...',
  delayForTrigger: 'Vertraging voor trigger',
  assigneeWillBeAlertedAfterDelay:
    'De geadresseerde wordt gewaarschuwd na {{durationString}}.',
  escalationForIncidentsForAlert:
    'Escalatie voor incident op {{incidentDate}} voor luisteraar {{alertName}}',
  alertIncidentAcknowledged: 'Bevestigd door {{memberName}} op {{dateString}}',
  alertIncidentClosed: 'Gesloten door {{memberName}} op {{dateString}}',
  alertIncidentAutoClosed: 'Automatisch gesloten bij {{dateString}}',
  alertIncidentRecovered: 'Automatisch hersteld bij {{dateString}}',
  alertedAssignees: 'Gealarmeerd {{assigneesString}}',
  acknowledgedBy: 'Bevestigd door {{memberName}}',
  closedBy: 'Gesloten door {{memberName}}',
  alertIncidents: 'Incidenten',
  viewingAlertIncidents: 'Incidenten bekijken',
  createOrganization: 'Organisatie maken',
  youAreNotPartOfAnyOrganization:
    'Je maakt geen deel uit van een organisatie. Maak een organisatie aan om te beginnen.',
  tellUsAboutYourOrganization: 'Vertel ons over uw organisatie',
  noActiveSubscription: 'Je hebt geen actief abonnement.',
  chooseOrganization: 'Kies een organisatie om verder te gaan.',
  noTriggersForIncident: 'Geen triggers gevonden voor dit incident.',
  role: 'Rol',
  viewer: 'Kijker',
  viewerNoLogin: 'Kijker (Geen inlog)',
  incidentCoordinator: 'Incidentcoördinator',
  assignedListeners: 'Toegewezen luisteraars',
  assignedLabels: 'Toegewezen labels',
  noListenersAssignedToCoordinator:
    'Wijs alstublieft ten minste één luisteraar of label toe aan de incidentcoördinator.',
  recipientRole: 'Rol ontvanger',
  editor: 'Bewerker',
  recipientRoleTooltipMessage: `U kunt de ontvanger toestaan om de datum en tijd van het alarm te wijzigen.

De ontvanger moet een Galarm Premium-abonnee zijn om de datum en tijd van het alarm te wijzigen.`,
  recipientChangeDateTimePremiumDescription:
    'Het wijzigen van de datum en tijd van een buddy-alarm is een premiumfunctie. Upgrade naar Galarm Premium om de datum en tijd van dit alarm te wijzigen.',
  recipientUpdatedAlarmDateAndTime:
    'Alarmtijd gewijzigd naar {{dateTimeString}}. Maker is geinformeerd.',
  recipientChangedAlarmTimeChatMessage:
    '{{username}} heeft de alarmtijd gewijzigd van {{originalTime}} naar {{newTime}}',
  allowRecipientToChangeTime: 'Ontvanger toestaan om alarmtijd te wijzigen',
  enterpriseViewerRoleDescription:
    'Gebruikers met de rol Kijker kunnen worden toegevoegd aan luisteraars om incidentalarmen te ontvangen. Ze kunnen ook inloggen op de webapplicatie om incidenten en luisteraars te bekijken, maar kunnen geen wijzigingen aanbrengen.',
  enterpriseViewerNoLoginRoleDescription:
    'Gebruikers met de rol Kijken (Geen login) kunnen worden toegevoegd aan luisteraars om incidentalarmen te ontvangen. Ze kunnen niet inloggen op de webapplicatie om incidenten en luisteraars te bekijken.',
  enterpriseAdminRoleDescription:
    'Gebruikers met de rol Beheerder kunnen worden toegevoegd aan luisteraars om incidentalarmen te ontvangen. Ze kunnen ook inloggen op de webapplicatie om incidenten en luisteraars te bekijken en wijzigingen aan te brengen.',
  enterpriseIncidentCoordinatorRoleDescription:
    'Gebruiker met de rol Incidentcoördinator kan inloggen op de applicatie om incidenten te bekijken voor luisteraars die aan hen zijn toegewezen. Ze kunnen ook incidenten voor die luisteraars sluiten vanaf het dashboard.',
  findAppleOrder: 'Zoek Apple-bestelling',
  incidentCoordinatorListenerLimitWarning:
    'U bent toegewezen aan meer dan 30 luisteraars. Alleen de incidenten van de eerste 30 worden hier getoond. Neem contact op met uw beheerder.',
  newOrganization: 'Nieuwe organisatie',
  switchOrganization: 'Organisatie wisselen',
  usageAnalytics: 'Gebruiksanalyse',
  incidentsOpened: 'Totaal geopende incidenten',
  incidentsOpen: 'Open',
  incidentsAcknowledged: 'Erkend',
  incidentsClosed: 'Gesloten',
  incidentsAutoClosed: 'Automatisch gesloten',
  alarmsSent: 'Verzonden alarmen',
  avgTimeToAcknowledge: 'Gem. tijd om te erkennen',
  avgTimeToResolve: 'Gem. tijd om op te lossen',
  noAnalyticsData:
    'Nog geen analysegegevens beschikbaar. Gegevens worden vastgelegd wanneer incidenten en andere gebeurtenissen plaatsvinden.',
  dailyTrend: 'Dagelijkse trend (laatste 30 dagen)',
  daily: 'Dagelijks',
  weekly: 'Wekelijks',
  numbersView: 'Nummers',
  chartView: 'Grafiek',
  last7Days: 'Laatste 7 dagen',
  last30Days: 'Laatste 30 dagen',
  last90Days: 'Laatste 90 dagen',
  last6Months: 'Laatste 6 maanden',
  lastYear: 'Laatste jaar',
  noOrganizations: 'Je maakt geen deel uit van een organisatie.',
  maxOrganizationsReached:
    'Gebruikers kunnen deel uitmaken van maximaal 10 organisaties.',
  yourOrganizations: 'Organisaties',
  urlNotFound: 'URL komt niet overeen met een ondersteunde route.',
  triggerAlert: 'Trekker Incident',
  recaptchaFailed: 'Verificatie met reCAPTCHA mislukt. {{error}}',
  loadingAccountInformation: 'Accountinformatie laden',
  loadingAuthInfo: 'Verificatiegegevens laden',
  allAlerts: 'Alle luisteraars',
  recentlyTriggeredAlerts: 'Recent getriggerde luisteraars',
  recentlyClosedIncidents: 'Onlangs gesloten incidenten',
  noRecentlyTriggeredAlerts:
    'Er zijn recentelijk geen luisteraars geactiveerd.',
  noRecentlyClosedIncidents: 'Er zijn recentelijk geen incidenten afgesloten.',
  closedAt: 'Gesloten op {{dateTimeString}}',
  dashboard: 'Dashboard',
  loggedIntoOrganizationAccount: 'Org: {{organizationName}}\nRol: {{role}}',
  viewIncidentEscalation: 'Incident Escalatie bekijken',
  closeIncident: 'Incident sluiten',
  closingIncident: 'Afsluitend incident',
  unableToRefreshEnterpriseAccount: 'Kan uw account niet vernieuwen.',
  viewAuthToken: 'Auth Token bekijken',
  problemWithCreatingAuthToken:
    'Er is een probleem opgetreden bij het aanmaken van een auth token. Neem contact op met de technische ondersteuning.',
  authToken: 'Auth Token',
  authTokenWarningMessage:
    'Houd dit auth token altijd veilig. Deel het met niemand. Als u denkt dat uw API-sleutel is gecompromitteerd, tikt u op de knop "Wijzigen" hierboven om deze te wijzigen. Nadat je het token hebt gewijzigd, moet je het nieuwe token opgeven op alle plaatsen waar je incidenten activeert met de REST API',
  authTokenCopiedToClipboard: 'Auth token is gekopieerd naar het klembord.',
  resendVerificationEmail: 'Verificatie-e-mail opnieuw verzenden',
  loggedInUsingEmail: 'Aangemeld via e-mail {{email}}.',
  checkingIfMemberIsAppUser: 'Controleren of lid een app-gebruiker is.',
  settingMemberDetails: 'Gegevens van leden instellen.',
  addingTeam: 'Team toevoegen.',
  editingTeam: 'Redactie.',
  addingRotation: 'Rotatie toevoegen.',
  editingRotation: 'Rotatie bewerken.',
  assigningKeyToMember: 'Sleutel toewijzen aan lid.',
  revokingKeyFromMember: 'Sleutel van lid intrekken.',
  deletingTeam: 'Team verwijderen.',
  deletingRotation: 'Rotatie verwijderen.',
  addingAlert: 'Luisteraar toevoegen.',
  editingAlert: 'Luisteraar bewerken.',
  deletingAlert: 'Luisteraar verwijderen.',
  triggeringAlert: 'Veroorzakend incident.',
  creatingOrganizationAccount: 'Organisatieaccount maken.',
  creatingCheckoutSession: 'Je afrekensessie starten.',
  creatingAnAccountForMember: 'Een account aanmaken voor lid.',
  passwordResetEmailSent:
    'We hebben je een e-mail gestuurd om je wachtwoord opnieuw in te stellen. Wijzig je wachtwoord en log opnieuw in.',
  changeOwner: 'Wijzig eigenaar',
  changeOrganizationOwner: 'Organisatie-eigenaar wijzigen',
  newOwnerEmail: 'E-mail nieuwe eigenaar',
  saveOnYearlySubscription: 'Opslaan {{percent}}%',
  annual: 'Jaarlijks',
  resetAlarms: 'Vernieuw alarmen',
  resetAlarmsAlert:
    'Alle alarmen zijn vernieuwd. Als je problemen blijft zien met de alarmen, dien dan een ticket in via de optie "Een probleem melden".',
  resetAlarmsTooltipMessage:
    'Als u problemen ondervindt met alarmen, zoals verwijderde alarmen die afgaan op de telefoon, vernieuw dan alarmen met deze optie. Als het probleem aanhoudt, dien dan een ticket in via de optie "Een probleem melden".',
  resetTempPassword: 'Tijdelijk wachtwoord opnieuw instellen',
  currPassword: 'Huidig wachtwoord',
  tempPassword: 'Tijdelijk wachtwoord',
  newPassword: 'Nieuw wachtwoord',
  reset: 'Reset',
  loggingIn: 'Inloggen',
  resettingTempPassword: 'Tijdelijk wachtwoord opnieuw instellen',
  changingPassword: 'Wachtwoord wijzigen',
  numSeats: 'Aantal zitplaatsen',
  helpMeDecide: 'Help me beslissen',
  numEnterpriseSeatsHelper:
    'Je moet het aantal seats kiezen als het aantal mensen in je organisatie die de app zullen gebruiken om incidenten te ontvangen. Bij het configureren van een listener kun je het escalatiebeleid specificeren. Je kunt meerdere niveaus hebben in een escalatiebeleid. Je kunt bijvoorbeeld aangeven dat het eerste escalatieniveau naar een team van 3 personen gaat. Als het eerste escalatieniveau niet binnen 5 minuten reageert, gaat het tweede escalatieniveau naar een team van 5 personen. Je kunt in dit geval het aantal plaatsen opgeven als 8.',
  numBusinessSeatsHelper:
    'Kies het aantal stoelen dat overeenkomt met het aantal mensen dat Galarm gaat gebruiken om alarmen en herinneringen te ontvangen.',
  perSeatPrice: '{{price}} per {{interval}} per stoel',
  doneForToday: 'Erkend',
  getStarted: 'Aan de slag',
  firstAlertInstructions: 'Instructies voor de eerste luisteraar',
  learnMoreAboutGalarmEnterprise: 'Meer informatie over Galarm Pro',
  home: 'Home',
  team: 'Team',
  alert: 'Waarschuwing',
  listener: 'Luisteraar',
  forgotPassword: 'Wachtwoord vergeten?',
  forgotPasswordTitle: 'Wachtwoord vergeten',
  sendPasswordResetEmail:
    'Stuur een e-mail om het wachtwoord opnieuw in te stellen',
  sendingPasswordResetEmail:
    'E-mail voor het opnieuw instellen van het wachtwoord verzenden',
  field: 'Veld',
  description: 'Beschrijving',
  requestIntegration: 'Een andere integratie aanvragen',
  integrationDetails: 'Integratie details',
  enterIntegrationDetails: 'Geef integratiedetails',
  galarmEnterpriseFreeTrial:
    'Meld je aan voor een gratis proefperiode van 14 dagen',
  galarmEnterpriseFreeTrialDescription: 'Incidentbeheer automatiseren',
  bySigningUpYouAgreeToOur: 'Door u aan te melden, gaat u akkoord met onze',
  and: 'en',
  alarmSubscribers: 'Alarm Volgers',
  otherSubscribersCount: {
    one: '1 volger meer die niet in je contacten staat',
    other: '{{count}} meer volgers die niet in je contacten staan'
  },
  getAccountData: 'Alarmgegevens exporteren',
  getAccountDataPrompt:
    'Geef een e-mailadres op waarnaar we een tekstbestand met al je alarmen zullen sturen.',
  getAccountDataConfirmation:
    'Houd er rekening mee dat we je een tekstbestand met al je alarmen zullen e-mailen op {{email}}.',
  sendingAccountData: 'Alarmgegevens exporteren...',
  sentAccountData: 'Alarmgegevens verzonden naar {{email}}.',
  errorSendingAccountData:
    'Fout bij het exporteren van alarmgegevens: {{error}}',
  sendingEmailVerificationLink: 'E-mailverificatielink verzenden',
  viewLogs: 'Logboeken bekijken',
  message: 'Bericht',
  billing: 'Facturering',
  newIncidentForAlert: 'Nieuw incident voor luisteraar {{alertName}}',
  triggerFailureForAlert:
    'Activeren van luisteraar {{alertName}} mislukt: {{error}}',
  clickNextAfterAddingMembers:
    'Klik op "Volgende" nadat u leden hebt toegevoegd',
  clickDoneAfterAddingAlerts:
    'Klik op "Gereed" om de installatie te voltooien en naar het Dashboard te gaan.',
  alertCreatedSuccessfully:
    'Listener is succesvol aangemaakt. Je kunt deze listener activeren via het menupictogram met drie puntjes voor de listenernaam.',
  fixSubscription: 'Abonnement herstellen',
  fixSubscriptionDescription:
    'We hebben een probleem ontdekt met je abonnement. Je abonnement bevat {{numSeats}} seat(s) maar je hebt sleutels toegewezen aan {{numSeatsAssigned}} lid (leden). U kunt maximaal {{numSeats}} sleutel(s) toewijzen.',
  fixSubscriptionChooseOption:
    'Bevestig je abonnement via een van de onderstaande opties.',
  fixSubscriptionContactAdmin:
    'Neem contact op met de beheerder van je organisatie.',
  unassignKeysFromMembers:
    'Ontgrendel ten minste {{extraKeysAssigned}} sleutel(s) van leden',
  addMoreSeatsToSubscription:
    'Voeg ten minste {{extraKeysAssigned}} stoel(en) toe aan je abonnement',
  revokeMembersKey: 'Sleutel van leden intrekken',
  revokeMembersKeyDescription:
    'Kies de leden waarvan je de sleutels wilt intrekken.',
  revoke: 'Herroep',
  unableToRevokeMembersKey:
    'Er is een fout opgetreden bij het intrekken van de sleutel van leden. Neem contact op met support.',
  problemWithLoadingProducts: 'Probleem met het laden van producten. {{error}}',
  verificationCompleted: 'Verificatie voltooid',
  deviceAlreadyRegistered:
    'Dit telefoonnummer is eerder geverifieerd op dit apparaat.',
  phoneNumberAutoFilled:
    'Galarm gebruikt het geselecteerde telefoonnummer uit uw Google-account.',
  unableToRegisterPreVerifiedUser:
    'Kan vooraf geverifieerde gebruiker niet registreren.',
  allowNotifications: 'Meldingen toestaan',
  allowNotificationsDescription: 'Alarmen weergeven wanneer ze afgaan.',
  scheduleExactAlarms: 'Alarmen plannen',
  scheduleExactAlarmsHelperText:
    'Laat Galarm op het juiste moment alarm slaan.',
  scheduleExactAlarmsDescription: 'Om op het juiste moment alarm te slaan.',
  disableBatteryOptimization: 'Batterijoptimalisatie beheren',
  disableBatteryOptimizationDescription:
    'Galarm op de achtergrond laten draaien.',
  requestRequiredPermissions:
    'Galarm heeft de volgende rechten nodig om alarmen te laten afgaan',
  allowDisallowedPermissions: 'Tik op om',
  notificationsAreEnabled:
    'Toestemming om meldingen te tonen is al toegestaan.',
  connectingToStore: 'Verbinding maken met winkel...',
  restartApp: 'App opnieuw opstarten',
  updateAvailable: 'Update beschikbaar',
  english: 'Engels',
  russian: 'Russisch',
  german: 'Duits',
  french: 'Frans',
  spanish: 'Spaans',
  italian: 'Italiaans',
  portuguese: 'Portugees',
  japanese: 'Japans',
  korean: 'Koreaans',
  indonesian: 'Indonesisch',
  changeAppLanguage: 'De taal van de app wijzigen',
  appLanguage: 'App Taal',
  iosChangeAppLanguagePara1:
    'Galarm kiest de app-taal uit de instellingen van je telefoon. Volg deze stappen om de app-taal voor Galarm te wijzigen:',
  iosChangeAppLanguageInstruction1:
    'Open "Telefooninstellingen > Algemeen > Taal & regio". Controleer of de taal die u wilt gebruiken voor Galarm voorkomt in de lijst met voorkeurstalen.',
  iosChangeAppLanguageInstruction2:
    'Ga terug naar "Telefooninstellingen" en tik op "Galarm" in de lijst met apps onderaan.',
  iosChangeAppLanguageInstruction3:
    'Tik op "Taal" en selecteer de taal die je wilt instellen voor Galarm. Ga terug naar de app na het kiezen van de taal',
  androidChangeAppLanguagePara1:
    'Galarm kiest de app-taal uit de instellingen van je telefoon. Volg deze stappen om de app-taal voor Galarm te wijzigen:',
  androidChangeAppLanguageInstruction1:
    'Tik hieronder op de knop "App-instellingen openen".',
  androidChangeAppLanguageInstruction2:
    'Tik op "Taal" en selecteer de taal die je wilt gebruiken voor Galarm.',
  androidChangeAppLanguageInstruction3:
    'Nadat je de taal hebt gekozen, kom je hier terug en klik je op de knop "App opnieuw opstarten".',
  problemRetrievingSubscriptionData:
    'Er is een probleem opgetreden bij het ophalen van je abonnementsgegevens. We leiden u nu door naar de accountpagina. Controleer uw abonnementsstatus en neem contact op met de technische ondersteuning als u problemen blijft ondervinden.',
  deletingOrganization: 'Organisatie verwijderen...',
  deleteOrganization: 'Organisatie verwijderen',
  deleteOrganizationDescription:
    'Weet je zeker dat je je organisatie wilt verwijderen?\n  \n  Dit is een onomkeerbare operatie. Alle gegevens van je organisatie worden verwijderd.\n  \n  Zorg ervoor dat je je abonnement hebt opgezegd voordat je de organisatie verwijdert.',
  galarmEnterpriseTrialDescription:
    'Er is een gratis proefperiode van 14 dagen waarin je het susbcription zonder kosten kunt annuleren.',
  galarmEnterpriseTrialAlreadyAvailed:
    'Je hebt al gebruikgemaakt van de gratis proefperiode van 14 dagen. Neem contact op met support als je meer tijd nodig hebt om het product te evalueren.',
  signinWithGoogle: 'Aanmelden met Google',
  signinWithGithub: 'Inloggen met GitHub',
  verifyAccount: 'Account verifiëren',
  verifyAccountMessage:
    'Je zou een e-mail moeten hebben ontvangen met een verificatiecode. Voer de code hieronder in om je account te verifiëren. Als je de code niet hebt ontvangen, kun je een nieuwe code aanvragen door op de knop "Code opnieuw verzenden" te klikken.',
  verificationCode: 'Verificatiecode',
  optionalString: '{{string}}',
  quickReminderTitle: 'Titel (optioneel)',
  accountVerified: 'Account geverifieerd',
  accountVerifiedMessage: 'Log in met je gegevens.',
  multipleUsersWithSameEmail:
    'Er zijn meerdere gebruikers met hetzelfde e-mailadres. Neem contact op met ondersteuning.',
  multipleUsersWithSameMobileNumber:
    'Er zijn meerdere gebruikers met hetzelfde mobiele nummer. Neem contact op met ondersteuning.',
  startTrial: 'Proef starten',
  nextSteps: 'Volgende stappen',
  firstTimeSetupComplete:
    'U heeft de initiële setup voor Galarm Enterprise voltooid en uw eerste luisteraar aangemaakt. Hieronder volgen enkele vervolgstappen die u vanaf hier kunt nemen.',
  testTheAlertInstruction:
    'Bekijk de instructies op {{link}} om te weten hoe je de listener die je zojuist hebt aangemaakt kunt testen.',
  integrateTheAlertInstruction:
    'Bekijk de instructies op {{link}} om de listener te integreren met verschillende monitoring tools.',
  createMoreAlertsInstruction:
    'Je kunt meer luisteraars toevoegen door naar het tabblad "Listeners" aan de linkerkant te gaan.',
  addMoreMembersInstruction:
    'Je kunt meer leden toevoegen door naar het tabblad "Leden" aan de linkerkant te gaan.',
  createTeamsInstruction:
    'Je kunt leden groeperen in "Teams" en een heel team waarschuwen wanneer zich een incident voordoet. Maak teams aan door naar het tabblad "Teams" aan de linkerkant te gaan en gebruik ze in de configuratie van de luisteraar.',
  testTheAlert: 'De Listener testen',
  integrateTheAlert: 'De Listener integreren',
  createMoreAlerts: 'Creëer meer luisteraars',
  addMoreMembers: 'Meer leden toevoegen',
  createTeams: 'Teams samenstellen',
  docs: 'Documentatie',
  docsSmall: 'Docs',
  contactSupport: 'Contact Ondersteuning',
  pastDue: 'Vervallen',
  canceled: 'Geannuleerd',
  unpaid: 'Onbetaald',
  incomplete: 'Onvolledig',
  incomplete_expired: 'Onvolledig Vervallen',
  trialing: 'Gratis proefabonnement',
  paused: 'Gepauzeerd',
  plan: 'Plan',
  status: 'Status',
  renewsOn: 'Vernieuwt op',
  yourRoles: 'Uw rollen',
  enterprisePlan: '{{quantity}} zetels, vernieuwt elke {{interval}}',
  currentOrganization: 'Huidige organisatie',
  useThisOrganization: 'Gebruik deze organisatie',
  fixPayment: 'Betaling herstellen',
  fixingPayment: 'Betaling vastleggen',
  addPaymentInformation: 'Betalingsinformatie toevoegen',
  noPaymentInformationAvailable:
    'Geen betalingsinformatie beschikbaar. Vernieuw de pagina als u onlangs betalingsinformatie hebt toegevoegd.',
  openBillingPortal: 'Open factureringsportal',
  openingBillingPortal: 'Portaal voor facturering openen',
  startupWizardDescription:
    'Deze wizard helpt je op weg om je eerste luisteraar aan te maken.',
  userNotFound: 'Gebruiker niet gevonden',
  wrongPassword: 'Verkeerd wachtwoord',
  emailAlreadyInUse: 'E-mail al in gebruik',
  restoreDeletedAlarms: 'Verwijderde alarmen herstellen',
  deleteAlarmAlert:
    'Verwijderde alarmen kunnen hersteld worden vanuit "Onlangs verwijderde alarmen". Je kunt ze bekijken door op het menu met drie puntjes (⋮) rechtsboven op het tabblad "Alarmen" te tikken.\n\nVerwijderde alarmen blijven daar 30 dagen staan, daarna worden ze definitief verwijderd.',
  slackVerificationCode: 'Uw Slack-verificatiecode is {{verificationCode}}.',
  dndAccess: 'Toegang niet storen',
  dndHelperText:
    'Galarm toestaan om alarmen af te laten gaan wanneer je telefoon op Niet storen staat.',
  cantRestoreInstantAlarmMessage:
    'Directe alarmen kunnen niet worden hersteld. Je kunt indien nodig chat- en andere informatie voor dit alarm bekijken. Dit alarm wordt permanent verwijderd na 30 dagen na verwijdering.',
  upgradeToUnlockAllFeatures: 'Upgrade om alle functies vrij te spelen',
  otherSignupOptions: 'Andere inschrijfopties:',
  renewSubscription: 'Abonnement verlengen',
  subscriptionOnHold:
    'On-hold (Uw plan staat {{subscriptionQty}} plaatsen toe\nmaar u hebt {{numSubscriptionKeys}} plaatsen toegewezen.',
  checklists: 'Taken',
  checklist: 'Takenlijst',
  typeToAddTask: 'Type om taak toe te voegen',
  specifyTaskName: 'Taaknaam opgeven',
  otherChecklists: 'Takenlijsten',
  defaultChecklistName: 'zonder titel',
  addTasksToChecklist: 'Taken toevoegen met het invoervak onderaan',
  addTasksToDefaultChecklist:
    'Voeg taken toe met het invoerveld onderaan... of begin een nieuwe takenlijst door op de + knop rechtsboven te klikken.',
  createNewChecklist:
    'Je kunt nieuwe takenlijsten maken om gerelateerde taken op één plek bij te houden.',
  addNewChecklist: 'Nieuwe takenlijst',
  alarmPhoto: 'Alarm Foto',
  alarmPhotoFeatureTitle: 'Alarm Foto',
  alarmPhotoFeatureDescriptionPremiumUser:
    'Met deze functie kun je een foto toevoegen aan een alarm voor snelle visuele aanwijzingen, zoals een foto van: een medicijn, instructies voor een taak, een voorwerp, enz. De foto wordt weergegeven wanneer het alarm afgaat.',
  alarmPhotoFeatureDescriptionFreeUser:
    'Met deze functie kun je een foto toevoegen aan een alarm voor snelle visuele aanwijzingen, zoals een foto van: een medicijn, instructies voor een taak, een voorwerp, enz. De foto wordt weergegeven wanneer het alarm afgaat.\n  \nDit is een premium functie. U wordt gevraagd om te upgraden naar premium om deze functie te kunnen gebruiken.',
  alarmPhotoPremiumFeature: 'Foto toevoegen aan alarmmeldingen',
  installPendingAppUpdate:
    'De nieuwste app-update is gedownload en klaar om geïnstalleerd te worden.',
  numTasks: {
    zero: 'Geen taken',
    one: '1 taak',
    other: '{{count}} taken'
  },
  numTasksWithCompleted: {
    one: '1 taak, {{completed}} voltooid',
    other: '{{count}} taken, {{completed}} voltooid'
  },
  muteAlarms: 'Alarm uitschakelen',
  unmuteAlarms: 'Alarm uitschakelen',
  alarmsAreMuted:
    'Al uw wekkers zijn momenteel gedempt. Tik op om het geluid weer aan te zetten.',
  alarmsHaveBeenMuted:
    'Uw wekkers zijn gedempt. Ze gaan pas af als je het geluid weer aanzet.',
  alarmsHaveBeenUnmuted:
    'Uw alarmen zijn gedempt. Ze zouden nu moeten afgaan zoals ingesteld.',
  deleteChecklist: 'Takenlijst verwijderen',
  confirmDeleteChecklist: 'Takenlijst verwijderen?',
  confirmDeleteCompletedTasks: 'Voltooide taken verwijderen?',
  confirmResetCompletedTasks: 'Voltooide taken resetten?',
  confirmDeleteTask: '{{taskName}} verwijderen?',
  showCompletedTasks: 'Voltooide taken weergeven',
  hideCompletedTasks: 'Verberg voltooide taken',
  deleteCompletedTasks: 'Voltooide taken verwijderen',
  resetCompletedTasks: 'Voltooide taken terugzetten',
  yourGroups: 'Uw groepen',
  newAlarmWith: 'Nieuw alarm met {{name}}',
  newGroupWith: 'Nieuwe groep met {{name}}',
  alertContact: 'Waarschuwing {{name}}',
  alertGroup: 'Waarschuwing {{name}}',
  instantAlarmMovedToFabNotice:
    'De Direct Alarm-functie is nu beschikbaar via de “+” knop rechtsonder op dit scherm. Het “luidspreker” pictogram wordt in een toekomstige release verwijderd uit de rechterbovenhoek.',
  tasksIntroTitle: 'Taken en takenlijsten',
  tasksIntroDescription:
    'Taken zijn je to-dos die geen deadline hebben. Je kunt ze hier snel toevoegen en beheren door ze af te vinken terwijl je elke taak afhandelt.\n\nJe kunt ook takenlijsten maken om gelijksoortige taken te groeperen. Je kunt bijvoorbeeld een takenlijst maken voor je boodschappen, een andere voor je werktaken, enzovoort.',
  groupsMovedToContactsScreen:
    '"Groepen" zijn samengevoegd in dit tabblad. Je groepen verschijnen bovenaan onder "Jouw groepen". Je kunt nieuwe groepen maken door rechtsonder op de knop "+" te tikken.',
  loadingTasks: 'Taken aan het laden...',
  tryPremium: 'Probeer Premium',
  buyPremiumToUnlockFeature:
    'Dit is een premium functie. Ontgrendel deze en vele andere coole functies met ons premium plan dat je 14 dagen gratis kunt uitproberen.',
  newTask: 'Nieuwe taak',
  newTaskList: 'Nieuwe takenlijst',
  enterTaskName: 'Taaknaam invoeren',
  enterTaskListName: 'Takenlijstnaam invoeren',
  taskName: 'Taak Naam',
  taskListName: 'Takenlijst Naam',
  checklistTasks: '{{name}}',
  editTaskListName: 'Takenlijstnaam bewerken',
  editTask: 'Taak bewerken',
  releaseNotes: 'Recente updates',
  currentRelease: '(momenteel geïnstalleerd)',
  loadingReleaseNotes:
    'Recente updates worden geladen. Zorg ervoor dat je verbinding hebt met het internet.',
  id: 'ID',
  subscriptionData: 'Abonnementsgegevens',
  organizations: 'Organisaties',
  showRotationCalendar: 'Toon Rotatie Kalender',
  rotationCalendar: 'Rotatiekalender',
  editShift: 'Bewerk verschuiving',
  startDateForShift: 'Begindatum voor dienst',
  startTimeForShift: 'Begintijd voor dienst',
  endDateForShift: 'Einddatum voor dienst',
  endTimeForShift: 'Eindtijd voor dienst',
  editingShift: 'Bewerkingsdienst',
  addingShift: 'Verschuiving toevoegen',
  products: 'Producten',
  prices: 'Plannen',
  planType: 'Type plan',
  business: 'Bedrijf',
  enterprise: 'Onderneming',
  compare: 'Vergelijk',
  apiSupport: 'API-ondersteuning om services te monitoren',
  accessToConsoleToViewAndCloseIncidents: 'Dashboard om incidenten te beheren',
  triggerInstantAlertsFromTheConsole:
    'Incidenten triggeren vanuit de Enterprise Console',
  coreFeatures: 'Belangrijkste kenmerken:',
  everythingInBusiness: 'Alles in Businessplan en:',
  updatePlanInstructions:
    'Je kunt je plan bijwerken door op de knop "Factureringsportal openen" aan de rechterkant te klikken en de knop "Plan bijwerken" te kiezen op de factureringsportal.',
  membersDescription:
    'Je hebt {{subscriptionKeysCount}} zitplaatsen gekocht -- {{assignedSubscriptionKeysCount}} toegewezen en {{unassignedSubscriptionKeysCount}} beschikbaar. Een vinkje voor de naam van een lid duidt op een toegewezen zitplaats.',
  wizardMembersDescription:
    'Begin met het toevoegen van de mensen die op de hoogte moeten worden gesteld wanneer een alarm afgaat. Een lid is iedereen in uw organisatie die meldingen over incidenten op hun telefoon via de Galarm-app moet ontvangen.',
  wizardAlertsDescription:
    'Voeg nu een luisteraar toe waarmee u kunt configureren wie u moet waarschuwen wanneer er incidenten plaatsvinden in uw organisatie. U kunt ook configureren hoe u incidenten moet escaleren wanneer ze niet op tijd worden erkend. Zodra u een luisteraar hebt gemaakt, kunt u toegang krijgen tot de webhook-URL om incidenten te activeren vanuit uw monitoringtools via het luisteraarmenu. U kunt ook handmatig een incident activeren vanuit het luisteraarmenu.',
  centralBilling: 'Centrale facturering',
  saveTwoMonths: 'Bespaar 2 maanden',
  owner: 'Eigenaar',
  enterpriseAccountSummary:
    'Je maakt deel uit van organisatie {{organizationName}} die is ingeschreven in het Galarm Pro {{planType}} plan.',
  perYearPerUser: 'per gebruiker/jaar',
  perMonthPerUser: 'per gebruiker/maand',
  creationDate: 'Aanmaakdatum',
  updatePhoneNumber: 'Telefoonnummer wijzigen',
  confirmCountryCodeAndEnterUpdatedPhoneNumber:
    'Bevestig de landcode en voer uw nieuwe telefoonnummer in. Uw account wordt aan dit telefoonnummer gekoppeld nadat u de verificatie hebt voltooid.',
  unableToUpdatePhoneNumber:
    'Kan telefoonnummer niet wijzigen: {{error}}. Neem contact op met ondersteuning.',
  phoneNumberUpdated: 'Telefoonnummer succesvol gewijzigd.',
  phoneNumberUpdatedMessage:
    'Je kunt de app normaal gebruiken. Vraag je contacten om je telefoonnummer bij te werken in hun adresboek.',
  memberChangedPhoneNumber:
    '{{memberName}} zijn telefoonnummer heeft gewijzigd. Werk je adresboek bij om ze te kunnen blijven toevoegen aan je alarmen.',
  preferredSourceForIncidents: 'Voorkeursbron voor incidenten',
  apiCodesDescription:
    'Gebruik de volgende instructies om de luisteraar met een bron te integreren',
  rotation: 'Rotatie',
  noAlarmsForThisDay: 'Geen alarmen voor deze dag',
  markAlarmsAsComplete: 'Alarmen markeren als voltooid',
  markAlarmsAsCompleteExplanation:
    'Eenmalige alarmen worden gemarkeerd als volledig en verschijnen in het gedeelte "Inactieve" alarmen.\n\nHerhalingsalarmen worden gemarkeerd als volledig en worden verplaatst naar de volgende gebeurtenis.',
  enterIncidentPrefix: 'Max. 5 tekens',
  incidentPrefix: 'Incident Voorvoegsel',
  incidentPrefixAlreadyExists: 'Incidentprefix bestaat al',
  removeTask: 'Taak verwijderen?',
  incidentPrefixLengthExceeded: 'Incidentprefix is langer dan 5 tekens',
  criticalAlerts: 'Kritieke waarschuwingen',
  criticalAlertsConfiguration:
    'Het alarm gaat af op {{criticalAlertsVolume}}% volume, zelfs wanneer je telefoon gedempt is of een Focus aan staat.',
  criticalAlertsDisabledShort:
    'Het alarm gaat niet af wanneer uw telefoon gedempt is.',
  criticalAlertsConfigurationGlobal:
    'Alarmen rinkelen op {{criticalAlertsVolume}}% volume, zelfs wanneer je telefoon gedempt is of een Focus aan staat.',
  criticalAlertsDisabledShortGlobal:
    'Alarmen gaan niet af als je telefoon gedempt is.',
  criticalAlertsEnabled:
    'Kritieke waarschuwingen zijn ingeschakeld. Alarmen rinkelen zelfs wanneer je telefoon is gedempt of een Focus is ingeschakeld.',
  criticalAlertsDisabled:
    'Kritieke waarschuwingen zijn uitgeschakeld. Alarmen gaan niet over als uw telefoon gedempt is.',
  enableCriticalAlerts: 'Kritieke waarschuwingen inschakelen',
  showFullScreenIntents: 'Toon alarm op volledig scherm',
  showFullScreenIntentsDescription:
    'Het alarm verschijnt op het volledige scherm wanneer de telefoon is vergrendeld.',
  percentVolume: '{{volume}}% volume',
  selectADate: 'Kies een datum om de alarmen te bekijken.',
  affiliates: 'Filialen',
  referralCount: 'Aantal verwijzingen',
  addAffiliate: 'Affiliate toevoegen',
  creatingAffiliate: 'Affiliate maken',
  affiliateLink: 'Affiliate link',
  upgradeRequiredForWeb: 'Upgrade vereist',
  upgradeToPremiumForWeb:
    'Voor deze functie is een premium abonnement vereist. Koop een premium abonnement vanuit de mobiele app om deze functie te gebruiken.',
  accountType: 'Type rekening',
  profileAndSettings: 'Profiel en instellingen',
  confirmIncidents: 'Incidenten bevestigen',
  removeIncidents: 'Meerdere incidenten verwijderen',
  incidents: 'Incidenten',
  closeSelectedIncidents: 'Geselecteerde incidenten sluiten',
  viewIncidentNotes: 'Incidentmeldingen bekijken',
  incidentNotes: 'Opmerkingen bij incidenten',
  incidentSummary: 'Incidentoverzicht',
  addNote: 'Opmerking toevoegen',
  noAdditionalNotesForIncident:
    'Geen aanvullende aantekeningen voor dit incident.',
  fromIncident: 'Van incident:',
  fromUsers: 'Van gebruikers:',
  chooseFirstDayOfWeek: 'Kies de eerste dag van de week',
  firstDayOfWeek: 'Eerste dag van de week',
  changePlan: 'Veranderingsplan',
  currentPremiumSubscriptionStatus:
    'Je bent momenteel geabonneerd op het plan {{planName}}.',
  purchasedLifetimePlan: 'Je hebt het Lifetime Premium-plan gekocht.',
  currentProSubscriptionStatus: 'Je bent lid van de {{orgName}} organisatie.',
  currentStripePremiumSubscriptionStatus:
    'U bent momenteel geabonneerd op het {{planName}}-plan.',
  changeToAnnualPlan: 'Wijziging van het jaarplan',
  unableToChangePlan:
    'Kan niet overschakelen naar het gebruikelijke plan. Neem contact op met de technische ondersteuning via "Instellingen > Feedback".',
  confirmChangeToAnnualPlan: 'Wil je overstappen naar het jaarplan?',
  changeToAnnualPlanDescription:
    'Voor het jaarabonnement wordt {{price}} in rekening gebracht. Resterende dagen in je huidige plan worden aangepast aan het jaarplan.',
  alarmTimezoneChanged:
    'Sommige alarmen zijn bijgewerkt om de tijdzone van het apparaat te gebruiken omdat de tijdzone die voor deze alarmen wordt gebruikt niet wordt ondersteund door dit apparaat.',
  defaultTimezoneChanged:
    'De standaardtijdzone voor alarmen is gewijzigd in de tijdzone van het apparaat, omdat de tijdzone van {{defaultTimezoneForAlarm}} niet wordt ondersteund door dit apparaat. Werk indien nodig alle bestaande alarmen bij die deze tijdzone gebruiken.',
  invalidEmail: 'Ongeldig e-mailadres.',
  unableToValidateEmail: 'Kan e-mail niet valideren. {{error}}',
  havingProblems: 'Heb je problemen?',
  alertData: 'Waarschuwingsgegevens',
  notificationActionBehavior: 'Melding Actie Gedrag',
  foreground: 'Voorgrond',
  background: 'Achtergrond',
  notificationActionBehaviorTooltipMessage:
    'Als dit is ingesteld op "Voorgrond", wordt de app op de voorgrond geopend door op een meldingsactie te tikken. Als dit is ingesteld op "Achtergrond", blijft de app op de achtergrond door op een meldingsactie te tikken.',
  getCodeOnWhatsApp: 'Ontvang een code op WhatsApp',
  getCode: 'Ontvang een code',
  dontHaveWhatsApp: 'Heb je geen WhatsApp?',
  unableToSendCodeViaWhatsAppTitle: 'Kan code niet verzenden via WhatsApp',
  unableToSendCodeViaWhatsAppMessage:
    '{{error}}\n\nVraag de code opnieuw aan op een ander kanaal.',
  dataSecurity: 'Gegevensbeveiliging',
  customSnooze: 'Andere',
  customSnoozeDuration: 'Andere ({{durationString}})',
  snoozeDuration: 'Sluimerduur',
  action: 'Actie',
  adsMessage:
    '\nBedankt voor je vertrouwen in Galarm. Om de ontwikkeling te ondersteunen, kunt u af en toe advertenties zien.\n\nUpgrade naar ons budgetvriendelijke premiumplan voor een reclamevrije ervaring en toegang tot meer geweldige functies.',
  headsUp: 'Opgelet!',
  unableToAuthenticateUser: 'Kan gebruiker niet verifiëren. {{error}}',
  addOccurrence: 'Voorval toevoegen',
  closeIncidents: 'Incidenten sluiten',
  closingIncidents: 'Incidenten sluiten',
  olderThanHours: 'Ouder dan (uur)',
  errorLoadingRecaptcha:
    'Er is een fout opgetreden bij het laden van de reCAPTCHA-uitdaging. Probeer het na enige tijd opnieuw en neem contact op met de technische ondersteuning als het probleem zich blijft voordoen.',
  completeRecaptcha:
    'Voltooi de volgende uitdaging om verder te gaan met de registratie.',
  incidentNotesPlaceholder:
    'Opmerkingen toevoegen voor dit incident (optioneel)',
  incidentSummaryPlaceholder:
    'Voeg een korte samenvatting toe voor dit incident (optioneel)',
  rotationMustHaveMembers: 'Rotatie moet minstens één lid hebben.',
  listenerMustHaveTriggers: 'Listener moet minstens één trigger hebben.',
  rotationExpiresOn: 'Verloopt op {{dateString}}',
  rotationExpiredOn: 'Verlopen op {{dateString}}',
  editAndSaveRotationToSetExpirationDate:
    'Bewerk en sla rotatie op om vervaldatum in te stellen.',
  cantEnableAlarmNoValidNextDate:
    'Kan het alarm niet inschakelen. Geen geldige volgende datum voor het alarm.',
  noValidNextDateForAlarm: 'Geen geldige volgende datum voor het alarm.',
  lifetimePremium: 'Levenslange premie',
  buyNow: 'Nu kopen',
  checkout: 'Afrekenen',
  cancelProduct: 'Product annuleren',
  endTimeForCreatorCrossesMidnightForRecipientAlarm:
    'De eindtijd voor de wekker van de maker kruist middernacht. Stel een geldige eindtijd in.',
  dataRetention: 'Bewaren van gegevens',
  retainIncidentsForDuration: 'Duur van het bewaren van het incident',
  retainIncidentsForDurationDescription:
    'Bepaalt hoe lang een incident in het systeem blijft nadat het is gesloten. Zelfs als de instelling "Geen retentie" is, kunnen incidenten maximaal vier uur blijven bestaan voordat ze worden verwijderd tijdens de periodieke opschooncyclus.',
  noRetention: 'Geen retentie',
  fetchingData: 'Gegevens ophalen...',
  errorFetchingData: 'Fout bij het ophalen van gegevens: {{message}}',
  incidentsCleanupLevel: 'Incidenten Reinigingsniveau',
  incidentsCleanupLevelDescription:
    'Specificeert de incidentstatus tot wanneer incidenten worden opgeschoond tijdens de periodieke opschooncyclus. Als de status is ingesteld op "Gesloten", worden alle incidenten die zijn gesloten opgeschoond. Als de status is ingesteld op "Bevestigd", worden alle incidenten die zijn bevestigd of gesloten opgeschoond.',
  connectedAccounts: 'Gekoppelde Google-accounts',
  incidentNameTemplate: 'Sjabloon incidentnaam',
  invalidIncidentNameTemplate:
    'Ongeldig incidentnaam sjabloon. Let op dat u alleen "identifier", "name" en "summary" als variabelenamen kunt gebruiken. Controleer het sjabloon en probeer het opnieuw. Neem contact op met de ondersteuning als u problemen blijft ondervinden.',
  preferredSourceForIncidentsDescription:
    'Als je de listener wilt gebruiken als webhook of incidenten wilt ontvangen van een monitoringtool, selecteer dan de bron uit de onderstaande lijst. Wanneer je een bron selecteert, tonen we instructies over hoe je de listener met de bron kunt integreren.\n\nDit is optioneel en u kunt de instructies voor elke bron later ook bekijken met de menuoptie "Code bekijken" voor de luisteraar.',
  noCalendarsFoundForConnectedAccount:
    'Geen agenda\'s gevonden voor het gekoppelde account. Verwijder het account en voeg het opnieuw toe, zorg ervoor dat Galarm toegang heeft tot uw agenda\'s. Als het probleem aanhoudt, neem dan contact op met de technische ondersteuning via "Instellingen > Feedback".',
  attachScreenshotsToFeedback:
    'Je ontvangt een e-mail ter bevestiging dat we je feedback hebben ontvangen. Als je schermafbeeldingen wilt delen om ons te helpen het probleem beter te begrijpen, beantwoord dan de e-mail met de schermafbeeldingen.',
  checkFeedbackReceipt:
    'Controleer uw Postvak IN voor een e-mail ter bevestiging van uw inzending. Als je deze niet in je Postvak In ziet, controleer dan je Spam-map en voeg support@galarm.zendesk.com toe aan je e-mail adresboek.\n\nAls u schermafbeeldingen wilt delen om ons te helpen het probleem beter te begrijpen, kunt u reageren op de e-mail met de schermafbeeldingen.',
  watchRewardedAdToUnlockMessage: `U ziet nu een advertentie op volledig scherm. U kunt deze na enkele seconden sluiten. U ziet slechts één dergelijke advertentie per dag. Dit helpt ons om de app gratis te houden.

Om advertenties te verwijderen en extra functies te ontgrendelen, overweeg om te upgraden naar ons premiumplan.`,
  watchRewardedAdToUnlockMessageAndroid: `U ziet nu een advertentie op volledig scherm die maximaal 30 seconden duurt. Zodra deze is afgelopen, verschijnt er een bericht 'Beloning toegekend' en een X-knop bovenaan. Tik op de X om de advertentie te sluiten en door te gaan.

Druk alstublieft niet op de terugknop voordat het bericht 'Beloning toegekend' verschijnt. U ziet slechts één dergelijke advertentie per dag.

Om advertenties te verwijderen en extra functies te ontgrendelen, overweeg alstublieft om te upgraden naar ons premiumplan.`,
  watchRewardedAdToUnlockMessageIos: `U ziet nu een advertentie op volledig scherm die maximaal 30 seconden duurt. Zodra deze is afgelopen, verschijnt er een bericht 'Beloning toegekend' en een X-knop bovenaan. Tik op de X om de advertentie te sluiten en door te gaan.

U ziet slechts één dergelijke advertentie per dag. Om advertenties te verwijderen en extra functies te ontgrendelen, overweeg alstublieft om te upgraden naar ons premiumplan.`,
  dontShowMessageAgain: 'Dit bericht niet meer tonen',
  alphabeticalAsc: 'Alfabetisch Oplopend',
  alphabeticalDesc: 'Alfabetisch Aflopend',
  newestFirst: 'Nieuwste eerst',
  oldestFirst: 'Oudste eerst',
  sortChecklistBy: 'Taken sorteren op',
  addedTaskToDeleteAlert:
    'Een taak toegevoegd om de luisteraar te verwijderen. Deze luisteraar accepteert geen nieuwe incidenten meer en zal binnenkort worden verwijderd. Je kunt dit dialoogvenster sluiten en de app blijven gebruiken.',
  alertsData: 'Luistergegevens',
  appNotConnectedToServer:
    'De app is niet verbonden met de server. Alle wijzigingen worden lokaal opgeslagen en worden gesynchroniseerd wanneer de app verbinding maakt met de server. Tik op om opnieuw verbinding te maken.',
  unableToConnectToServer: 'Kan geen verbinding maken met de server.',
  pleaseCheckYourInternetConnection: 'Controleer je internetverbinding.',
  autoCloseIncidents: 'Incidenten bij sluiten auto',
  autoCloseIncidentsDescription:
    'Incidenten automatisch sluiten na een opgegeven tijdsduur.',
  autoClosed: 'Auto Gesloten',
  never: 'Nooit',
  dndAccessNotGranted:
    'Toegang voor Niet storen niet toegestaan. Alarmen rinkelen mogelijk niet wanneer Niet storen is ingeschakeld.',
  deviceTokenExpired:
    'Je apparaat ontvangt geen pushberichten van Galarm omdat het apparaattoken is verlopen. Start de app opnieuw op om het token te vernieuwen.',
  unableToSendRemoteNotification:
    'Je apparaat ontvangt geen pushberichten van Galarm. Foutcode: {{errorCode}}. Neem contact op met de technische ondersteuning via "Instellingen > Feedback".',
  cameraNotAvailable: 'Camera niet beschikbaar',
  removePhoneContacts: 'Telefooncontacten verwijderen',
  removePhoneContactsConfirmation:
    'Dit verwijdert alle gesynchroniseerde Galarm-contacten van uw telefooncontacten. U kunt ze niet toevoegen aan alarmen of groepen. U kunt de telefooncontacten opnieuw synchroniseren door toestemming te geven voor toegang tot contacten in de app-instellingen.',
  allowContactsPermission: 'Contactpersonen toestaan',
  allowContactsPermissionDescription:
    'Tik op het volgende scherm op Machtigingen en geef toegang tot contacten.',
  revokeContactsPermission: 'Toestemming contactpersonen intrekken',
  revokeContactsPermissionDescription:
    'Voordat je telefooncontacten verwijdert, moet je de toegang tot contacten intrekken. Tik in het volgende scherm op Contacten en trek de toegang tot contacten in.',
  phoneContactsRemoved:
    'Een taak toegevoegd om telefooncontacten te verwijderen. Neem contact op met support als de contacten na een paar minuten nog niet zijn verwijderd.',
  specifyDate: 'Datum opgeven',
  specifyTime: 'Tijd specificeren',
  summer_soft: 'Zomer Zacht',
  beeps: 'Piep',
  bollywood_nights: 'Bollywood Nachten',
  gentle_reminder: 'Zachte herinnering',
  himalayan_piper: 'Himalaya adder',
  holiday_joy: 'Vakantievreugde',
  hollywood_adventure: 'Hollywood Avontuur',
  melody: 'Melody',
  morning_rooster: 'Ochtend Haan',
  morning_sunshine: 'Ochtendzon',
  sweet_sea: 'Zoete Zee',
  old_school_ring: 'Tring Tring',
  horizon: 'Horizon',
  symphony: 'Symfonie',
  chords: 'Akkoorden',
  discovery: 'Ontdekking',
  rainforest: 'Regenwoud',
  wishes: 'Wensen',
  natural_marimba: 'Natuurlijke marimba',
  MyAlarmNotification: '{{alarmName}} - Het is tijd.',
  ParticipantCascadingAlarmNotification:
    '{{alarmName}} - Het is tijd om {{alarmCreatorName}} eraan te herinneren.',
  ParticipantSimultaneousAlarmNotification:
    '{{alarmName}}. Het is tijd om je deelname te bevestigen.',
  InstantAlarmNotification:
    '{{alarmName}}. Uw onmiddellijke aandacht is vereist.',
  MyAlarmNotificationShort: 'Het is tijd.',
  ParticipantCascadingAlarmNotificationShort:
    'Het is tijd om {{alarmCreatorName}} eraan te herinneren.',
  ParticipantSimultaneousAlarmNotificationShort:
    'Het is tijd om je deelname te bevestigen.',
  InstantAlarmNotificationShort: 'Uw onmiddellijke aandacht is vereist.',
  MyRecipientAlarmNotification:
    '{{alarmName}} - Het is tijd om {{alarmRecipientName}} eraan te herinneren.',
  MyRecipientAlarmNotificationShort:
    'Het is tijd om {{alarmRecipientName}} eraan te herinneren.',
  RecipientAlarmNotification:
    '{{alarmName}} (door {{alarmCreatorName}}) - Het is tijd.',
  RecipientAlarmNotificationShort: 'Het is tijd - door {{alarmCreatorName}}.',
  adFreeExperiencePremiumFeature: 'Advertentievrije ervaring',
  adFreeExperienceFeatureDescription:
    'Geniet van een ononderbroken ervaring zonder advertenties.',
  accountLabel: 'Accountlabel',
  editAccountLabel: 'Accountlabel bewerken',
  enterAccountLabel: 'Voer een label in voor dit account',
  failedToUpdateLabel:
    'Het bijwerken van het accountlabel is mislukt. Probeer het opnieuw.',
  considerEvents: 'Stel alarmen in voor',
  importAllDayEvents: 'Importeer hele dag evenementen',
  considerEventsStartingWith:
    'Stel alarmsignalen in voor evenementen die beginnen met',
  eventsStartingWith: 'Evenementen die beginnen met',
  allEvents: 'Alle evenementen',
  noEvents: 'Geen evenementen',
  ringAlarmsForCalendarEvents: 'Evenementherinnering',
  durationBefore: '{{duration}} vóór',
  durationBeforeEventTime: '{{duration}} vóór het evenement',
  beforeEventTime: 'vóór het evenement',
  promptForUpdates: 'Prompt om app-updates te installeren',
  calendarNotifications: 'Kalender meldingen',
  enableEnhancedNotifications: 'Inschakelen',
  calendarWithSnoozeAt: 'Het evenement vindt plaats op {{timeString}}',
  calendarEventFeedbackHeader:
    'U verstuurt een deel van de informatie over deze agenda-afspraak voor debugdoeleinden. Persoonlijke gegevens zoals de naam van de afspraak, de beschrijving of de deelnemers worden niet gedeeld.',
  screenWillCloseAutomatically:
    'Dit scherm wordt automatisch gesloten na {{seconds}} seconde(n).',
  viewingCalendarEvent: "Kalendergebeurtenis bekijken voor '{{title}}'",
  snoozingCalendarEvent: 'Snoozing-agenda-afspraak voor {{title}}',
  calendarGrantExpired:
    'De kalendertoegang voor {{connectedAccountName}} en {{userName}} is verlopen. Ga naar Instellingen -> Gekoppelde kalenders, verwijder het account en probeer het opnieuw.',
  linkedAccountsPremiumFeaturesDescription:
    'Je kunt je Google-accounts koppelen en gebeurtenissen uit je primaire agenda importeren in Galarm.',
  instantAlarmPremiumFeaturesDescription:
    'U heeft een premium-abonnement nodig om meer directe alarmen te maken.',
  linkedAccountsPremiumFeatureDescription:
    'Koppel uw Google-accounts om gebeurtenissen uit uw primaire agenda te importeren in Galarm.',
  linkedAccountsPremiumFeature: "Google Agenda's koppelen",
  calendarNotificationsTooltipMessage:
    'Meldingen voor gekoppelde agenda-afspraken.',
  hideRecentlyDeletedAlarms: 'Verberg recent verwijderde alarmen',
  loadingCalendarEvent: 'Kalendergebeurtenis laden...',
  noOpenIncidents: 'Geen openstaande incidenten',
  incidentsForMember: 'Incidenten voor {{name}}',
  noIncidentsForMember: 'Nog geen incidenten voor dit lid',
  noIncidents: 'Geen incidenten',
  labels: 'Labels',
  manageLabels: 'Labels beheren',
  addLabel: 'Label toevoegen',
  editLabel: 'Label bewerken',
  labelName: 'Labelnaam',
  enterLabelName: 'Voer de naam van het label in',
  existingLabels: 'Bestaande labels',
  noLabelsYet: 'Er zijn nog geen labels aangemaakt.',
  labelNameRequired: 'Labelnaam is verplicht',
  labelAlreadyExists: 'Er bestaat al een label met deze naam.',
  selectLabels: 'Labels selecteren',
  filterByMember: 'Filteren op lid',
  filterByTeam: 'Filteren op team',
  filterByLabel: 'Filteren op label',
  deletingLabel: 'Label verwijderen...',
  dutch: 'Nederlands',
  turkish: 'Turks',
  ukrainian: 'Oekraïens',
  appSupportedLanguages:
    'Galarm ondersteunt momenteel Engels, Russisch, Duits, Frans, Spaans, Italiaans, Portugees, Japans, Koreaans, Indonesisch, Nederlands, Turks en Oekraïens.',
  enhancedNotifications: 'Verbeterde alarmlevering',
  enhancedNotificationsPremiumFeatureDescription:
    'Wanneer deze functie is ingeschakeld, kunt u extra alarmen instellen, zelfs als het besturingssysteem van uw telefoon het instellen van meer alarmen niet toestaat. Galarm regelt dit door alarmen in de cloud in te stellen en pushmeldingen naar uw telefoon te sturen wanneer de alarmen moeten afgaan.',
  enhancedNotificationsFeatureDescription:
    'Maak alarmen aan, zelfs als het besturingssysteem van je telefoon het instellen van meerdere alarmen niet toestaat.\n\nGalarm lost dit op door alarmen in de cloud in te stellen en pushmeldingen naar je telefoon te sturen wanneer de alarmen afgaan.',
  appTerminatedNotification: 'Melding dat app is beëindigd',
  appTerminatedNotificationTooltipMessage:
    'Melding die wordt weergegeven wanneer de app wordt afgesloten. Het wordt aanbevolen om de app op de achtergrond te laten draaien om ervoor te zorgen dat alarmen op tijd afgaan.',
  cantChangeSetting: '{{settingName}} kan niet worden gewijzigd',
  fetchingAlarm: 'Alarm ophalen...',
  viewIncidentAlarms: 'Incidenten bekijken',
  showingIncidents: {
    zero: 'Geen incidenten',
    one: '{{startIndex}} - {{endIndex}} van {{count}} incident',
    other: '{{startIndex}} - {{endIndex}} van {{count}} incidenten'
  },
  noIncidentsFound: 'Geen incidenten gevonden',
  noIncidentsInSystem: 'Er zijn nog geen incidenten in het systeem gemeld.',
  sendTestIncident: 'Testincident',
  sendTestIncidentConfirmMessage:
    'Dit zal een testincident activeren voor luisteraar "{{alertName}}". Doorgaan?',
  noListenersToSendTestIncident:
    'U moet een luisteraar configureren voordat u een testincident kunt verzenden. Ga naar de sectie Luisteraars om er een te maken.',
  pageSize: 'Paginaformaat',
  incidentsPerPage: 'Incidenten per pagina',
  identifier: 'Identificatiecode',
  reportedAt: 'Gemeld bij',
  closedAtLabel: 'Gesloten om',
  priority: 'Prioriteit',
  allListeners: 'Alle luisteraars',
  allDates: 'Alle data',
  allPriorities: 'Alle prioriteiten',
  allStatuses: 'Alle statussen',
  connectedAccountsDescription:
    'U kunt uw Google-account koppelen aan Galarm om meldingen te ontvangen voor agenda-afspraken in Galarm. Meer informatie vindt u op https://features.galarmapp.com/calendar-integration.',
  removeGoogleAccount: 'Google-account verwijderen',
  removeGoogleAccountDescription:
    'Weet je zeker dat je dit Google-account wilt verwijderen?',
  unableToRemoveGoogleAccount: 'Kan Google-account niet verwijderen',
  googleAccountRemoved: 'Account Verwijderd',
  googleAccountRemovedDescription: 'Dit Google-account is verwijderd.',
  calendarEvent: 'Agenda-evenement',
  connectedAccount: 'Gekoppeld account',
  linkedCalendars: 'Gekoppelde Kalenders',
  syncedCalendars: 'Gesynchroniseerde Kalenders',
  availableCalendars: 'Beschikbare Kalenders',
  noSyncedCalendars:
    'Geen gesynchroniseerde kalenders gevonden. Voeg kalenders toe vanuit de sectie "Beschikbare Kalenders" hieronder.',
  noAvailableCalendars: 'Geen kalenders beschikbaar om te synchroniseren.',
  removeCalendar: 'Kalender Verwijderen',
  calendarDetails: 'Kalenderdetails',
  addingCalendar: 'Kalender toevoegen...',
  calendarAdded: 'Kalender succesvol toegevoegd',
  errorAddingCalendar: 'Fout bij toevoegen van kalender: {{error}}',
  duplicateCalendarDetectedTitle: 'Dubbele Kalender Gedetecteerd',
  removingCalendar: 'Kalender verwijderen...',
  calendarRemoved:
    'We hebben een taak toegevoegd om de kalender te verwijderen. U kunt dit dialoogvenster sluiten en de app blijven gebruiken. Neem contact op met de ondersteuning als de kalender na een paar minuten niet is verwijderd.',
  errorRemovingCalendar: 'Fout bij verwijderen van kalender: {{error}}',
  removeCalendarDescription:
    'Weet u zeker dat u de kalender "{{calendarName}}" wilt verwijderen?',
  default: 'Standaard',
  join_meeting_action: 'Deelnemen aan vergadering',
  view_calendar_event: 'Bekijken',
  snooze_calendar_event: 'Snooze',
  dismiss_calendar_event: 'Afwijzen',
  numEvents: {
    one: '1 evenement',
    other: '{{count}} evenementen'
  },
  calendarEvents: 'Agenda-evenementen',
  viewingCalendarEvents: 'Kalendergebeurtenissen bekijken',
  calendarEventAlarmName: 'Agenda-evenement',
  calendarName: 'Kalendername',
  meetingLink: 'Link naar vergadering',
  attendees: 'Deelnemers',
  organizer: 'Organisator',
  addAccount: 'Account toevoegen',
  accountAlreadyConnected: 'Account al verbonden',
  unableToSignInWithGoogle: 'Kan niet inloggen met Google',
  unableToSignInWithGoogleDescription:
    "Er is een probleem opgetreden bij het inloggen met Google. Neem contact op met de technische ondersteuning via 'Instellingen > Feedback'.",
  requiredScopesNotGranted:
    'Galarm heeft geen toegang tot uw agenda\'s, waardoor we geen evenementen uit uw agenda kunnen importeren. Verwijder het account en voeg het opnieuw toe, waarbij u ervoor zorgt dat Galarm toegang krijgt tot uw agenda\'s. Als het probleem zich blijft voordoen, neem dan contact op met de technische ondersteuning via "Instellingen > Feedback".',
  refreshTokenNotFound:
    "Ik heb geen toegang tot het account. Verwijder het account en voeg het opnieuw toe. Als het probleem aanhoudt, verwijder het account dan nogmaals. Ga naar myaccount.google.com, tik links op 'Gegevens en privacy', scroll naar beneden naar 'Apps en services van derden', kies Galarm en tik op 'Verwijder alle verbindingen die u met Galarm hebt'. Voeg het account opnieuw toe. Neem contact op met de technische ondersteuning als u dit bericht opnieuw ziet nadat u alle stappen hebt gevolgd.",
  noCalendarsSyncedForConnectedAccount: 'Geen kalenders gesynchroniseerd.',
  calendarsNotSynced:
    'Primaire agenda niet gesynchroniseerd. Tik op de knop Vernieuwen om uw agenda te synchroniseren.',
  calendarsSynced: 'Kalenders succesvol gesynchroniseerd.',
  refreshGoogleAccount: 'Google-account vernieuwen',
  refreshingGoogleAccount: 'Google-account vernieuwen...',
  googleAccountRefreshed: 'Google-account succesvol vernieuwd',
  errorRefreshingGoogleAccount:
    'Fout bij het vernieuwen van Google-account: {{error}}',
  refreshGoogleAccountDescription:
    'Importeer gebeurtenissen opnieuw vanuit uw Google-agenda en stel automatische updates in.',
  ignoreEvents: 'Gebeurtenissen negeren',
  ignoreEvent: 'Gebeurtenis negeren',
  unignoreEvent: 'Evenement plannen',
  yourIgnoredEvents: 'Je genegeerde evenementen',
  ignoredCalendarEvents: 'Genegeerde agenda-afspraken',
  noEventsSelected: 'Geen evenementen geselecteerd',
  selectEventsToIgnore: 'Selecteer gebeurtenissen die u wilt negeren',
  showInCalendar: 'Weergeven in kalender',
  viewingIgnoredCalendarEvents: 'Genegeerde agenda-afspraken bekijken',
  viewIgnoredEvents: 'Genegeerde gebeurtenissen bekijken',
  general: 'Algemeen',
  addMembersAsContacts: 'Leden toevoegen als Galarm-contacten',
  addMembersAsContactsDescription:
    'Gesynchroniseerde leden kunnen worden toegevoegd aan alarmen en groepen in de Galarm-app. Gebruik het vernieuwingspictogram om opnieuw te synchroniseren nadat u deze instelling hebt gewijzigd.',
  resyncMembersPrompt:
    'Wilt u de leden opnieuw synchroniseren met de nieuwe instelling?',
  toAdmins: 'Aan beheerders',
  toEveryone: 'Aan iedereen',
  accountManagers: 'Accountmanagers',
  accountManager: 'Accountmanager',
  viewAccountManagers: 'Bekijk accountmanagers',
  addAccountManager: 'Accountmanager toevoegen',
  userAlreadyManager: 'De gebruiker is al accountmanager.',
  noAccountManagersConfigured: 'Er zijn geen accountmanagers geconfigureerd.',
  addingAccountManager: 'Accountmanager toevoegen...',
  filterByCalendar: 'Filteren op kalendernaam',
  calendarEventNotFound: 'Agenda-item niet gevonden',
  calendarEventNotFoundMessage:
    'De agenda-afspraak met ID {{eventId}} is niet gevonden. Deze is mogelijk verwijderd of de agenda is niet langer toegankelijk.',
  proMemberContact: 'Lid van organisatie in Galarm Pro',
  viewCalendarEvents: 'Bekijk kalendergebeurtenissen',
  noScheduledCalendarEvents: 'Geen geplande agenda-afspraken',
  notSpecified: 'Niet gespecificeerd',
  addedTaskToRemoveGoogleAccount:
    'Er is een taak toegevoegd om het Google-account te verwijderen. U kunt dit dialoogvenster sluiten en doorgaan met het gebruik van de app. Neem contact op met de ondersteuning als het account na enkele minuten nog niet is verwijderd.',
  success: 'Succes',
  addingTaskToRemoveGoogleAccount:
    'Een taak toevoegen om Google-account te verwijderen...',
  addingGoogleCalendar:
    'Een taak toevoegen om Google Agenda te synchroniseren...',
  googleCalendarAdded:
    'We hebben uw Google-account gekoppeld en importeren gebeurtenissen uit de primaire agenda. Tik op het gekoppelde account om de geluids- en trilinstellingen te configureren.\n\nNeem contact op met de ondersteuning als de gebeurtenissen na enkele minuten nog niet zijn geïmporteerd.',
  googleAccountLinkedSelectCalendars:
    'We hebben uw Google-account gekoppeld en importeren evenementen van de geselecteerde kalenders.',
  multipleCalendarsUpgradeMessage:
    'We hebben ondersteuning toegevoegd voor het importeren van meerdere kalenders van een account. Als u meerdere kalenders van dit account wilt importeren, verwijder dan het account en voeg het opnieuw toe.',
  errorAddingGoogleCalendar:
    'Fout bij het toevoegen van Google Agenda: {{error}}',
  acceptedEvents: 'Evenementen die je hebt geaccepteerd',
  declinedEvents: 'Evenementen die u hebt geweigerd',
  tentativeEvents: "Evenementen die je hebt gemarkeerd als 'Misschien'",
  needsActionEvents: 'Evenementen die op uw reactie wachten',
  show: 'Tonen',
  hide: 'Verbergen',
  showAndRing: 'Show en Ring',
  chooseBehavior: 'Kies Gedrag',
  calendarEventBehavior: 'Omgaan met evenementen waarvoor u bent uitgenodigd',
  lastSyncedAt: 'Laatst gesynchroniseerd op {{dateTimeString}}',
  apiConfiguration: 'API-configuratie',
  apiVersion: 'API-versie',
  apiVersionDescription:
    'De API-versie wordt gebruikt om compatibiliteit tussen de app en de server te garanderen. Als u V2 gebruikt, moet de mobiele app versie 9.9.0 of hoger zijn. Neem contact op met de technische ondersteuning als u problemen ondervindt met de API.',
  reschedulingEventsAsNeeded: 'Evenementen indien nodig verplaatsen...',
  failedToUpdateSetting: 'Kan instelling niet bijwerken: {{error}}',
  selectEventsToSchedule:
    'Selecteer gebeurtenissen om alarmen voor in te stellen',
  scheduleEvents: 'Evenementen plannen',
  unableToRefreshGoogleAccount:
    'Kan geen gebeurtenissen opnieuw importeren vanuit Google Agenda',
  calendarEventBehaviorDescription:
    'Kies hoe je wilt dat Galarm omgaat met evenementen waarvoor je bent uitgenodigd.',
  ringAlarmsForCalendarEventsTooltip:
    "Geef aan wanneer u aan een gebeurtenis herinnerd wilt worden.\n\n  Om extra herinneringen te ontvangen, kunt u automatische snooze inschakelen in de instellingen voor 'Geluid en trillen'.",
  sortAlarmCategories: 'Sorteer alarmcategorieën op',
  byNumAlarms: 'Aantal alarmen',
  byName: 'Naam',
  preReminderRingtone: 'Pre-herinnering beltoon',
  timerRingtone: 'Timer beltoon',
  sortAlarmCategoriesTooltipMessage:
    'Kies hoe u uw alarmcategorieën wilt sorteren. U kunt ze sorteren op het aantal alarmen in elke categorie of alfabetisch op naam.',
  resetFilters: 'Filters resetten',
  alarm: 'Persoonlijk Alarm',
  alarmWithContacts: 'Alarm met Contacten',
  instantAlarm: 'Directe Waarschuwing',
  buddyAlarm: 'Vriendenalarm',
  proMembersSyncCompleted: 'Synchronisatie van Pro-leden voltooid.',
  errorSyncingProMembers:
    'Fout bij het synchroniseren van Pro-leden: {{error}}',
  label: 'Label',
  iosNotificationsLimitReached:
    "Je bereikt de meldingslimiet van iOS voor een app.\n\nSchakel 'Verbeterde alarmbezorging' in om ervoor te zorgen dat alle alarmen afgaan. Wanneer deze functie is ingeschakeld, plant Galarm de alarmen die buiten de toegestane limiet vallen in de cloud en stuurt het pushmeldingen naar je telefoon wanneer die alarmen moeten afgaan.",
  notificationLimitReached: 'Waarschuwing meldingslimiet',
  remoteAlarmCloudMessage:
    'Dit alarm wordt op afstand gepland in de cloud en vereist een actieve internetverbinding op het moment dat het alarm afgaat.',
  signUpForMailingList: 'Meld u aan voor Belangrijke Aankondigingen',
  signedUpForMailingList: 'Aangemeld voor Belangrijke Aankondigingen',
  unsubscribe: 'Afmelden',
  confirmUnsubscribeFromMailingList:
    'Weet u zeker dat u zich wilt afmelden van belangrijke aankondigingen?',
  unsubscribingFromMailingList: 'Afmelden van belangrijke aankondigingen...',
  successfullyUnsubscribedFromMailingList:
    'Succesvol afgemeld van belangrijke aankondigingen.',
  errorUnsubscribingFromMailingList:
    'Er is een fout opgetreden bij het afmelden van belangrijke aankondigingen. Probeer het later opnieuw.',
  signingUpForMailingList:
    'Aanmelden om belangrijke aankondigingen te ontvangen...',
  successfullySignedUpForMailingList:
    'Je hebt je succesvol aangemeld om belangrijke updates te ontvangen.',
  errorSigningUpForMailingList:
    'Er is een fout opgetreden bij het aanmelden voor belangrijke updates. Probeer het later nog eens.',
  recentlyUsed: 'Onlangs gebruikt',
  startStopWatch: 'Stopwatch starten',
  stopWatch: 'Stopwatch',
  stopWatches: 'Stopwatches',
  utilities: 'Hulpmiddelen',
  addAlarmForTask: 'Alarm toevoegen voor taak',
  noExpiredAlarmsToDelete: 'Geen gemiste alarmen om te verwijderen',
  noAlarmsToDelete: 'Geen alarmen om te verwijderen',
  noAlarmsToEnable: 'Geen alarmen om in te schakelen',
  noAlarmsToDisable: 'Geen alarmen om uit te schakelen',
  noAlarmsToMarkAsComplete: 'Geen alarmen om als voltooid te markeren',
  noIncidentsToConfirm: 'Geen incidenten om te bevestigen',
  noIncidentsToClose: 'Geen incidenten om te sluiten',
  noEventsToIgnore: 'Geen evenementen om te negeren',
  noEventsToSchedule: 'Geen evenementen om te plannen',
  addAlarmForChecklist: 'Alarm toevoegen voor takenlijst',
  openTaskList: 'Takenlijst openen',
  alarmForTask: 'Taak',
  alarmForTaskList: 'Takenlijst',
  EnterpriseAlertIncidentTriggered:
    'Er is een incident voor het alarm{{alertName}}, geactiveerd.',
  docChatbotWelcome:
    'Hallo! Ik ben hier om u te helpen bij het leren gebruiken van Galarm Enterprise. Stel mij al uw vragen over functies, installatie of het uitvoeren van specifieke taken.',
  docChatbotError:
    'Het spijt me, er is een fout opgetreden. Probeer het opnieuw of neem contact op met de helpdesk.',
  docChatbotTitle: 'Allie',
  docChatbotPlaceholder: 'Stel een vraag...',
  helpAssistant: 'Help',
  needHelp: 'Hulp nodig?',
  helpPopupMessage:
    '"Allie", onze chatassistent, staat klaar om je te helpen! Je kunt het op elk moment starten vanuit het "Help"-menu in de bovenste balk.',
  askTheHelpAssistant: 'Vraag het aan "Allie"',
  newConversation: 'Nieuw gesprek',
  setupStep: 'Stap {{current}} van {{total}}',
  escalationPolicyTooltip:
    'Een escalatiebeleid bepaalt wie er wordt geïnformeerd wanneer er een incident plaatsvindt en in welke volgorde. U kunt meerdere triggers toevoegen om verschillende mensen op verschillende tijdstippen te waarschuwen als het incident niet wordt erkend.',
  stopwatchTotal: 'Totaal',
  stopwatchCurrent: 'Huidig',
  stopwatchStart: 'Start',
  stopwatchStop: 'Stop',
  stopwatchFinish: 'Voltooien',
  stopwatchStartNextLap: 'Volgende ronde starten',
  startTimer: 'Start',
  stopwatchLapAndContinue: 'Ronde en doorgaan',
  stopwatchLapAndPause: 'Ronde en pauzeren',
  stopwatchLapAndStop: 'Ronde en stoppen',
  savingStopwatch: 'Stopwatch opslaan...',
  errorSavingStopwatch: 'Fout bij het opslaan van de stopwatch.',
  timerRequiresValidDuration: 'Stel eerst een timerduur in.',
  stopwatchLapAndContinueHelp:
    'Registreert de huidige ronde en start onmiddellijk een nieuwe.',
  stopwatchLapAndPauseHelp:
    'Registreert de huidige ronde en pauzeert. U kunt ronde-aantekeningen toevoegen en hervatten wanneer u klaar bent om de volgende ronde te starten.',
  stopwatchLapAndStopHelp:
    'Registreert de laatste ronde en stopt de stopwatch. U kunt een label en notities voor elke ronde toevoegen voordat u opslaat.',
  stopwatchDiscardConfirmMessage:
    'U heeft een actieve stopwatch in gebruik. Teruggaan zal deze verwijderen. Doorgaan?',
  stopwatchLapLabel: 'Ronde {{index}}',
  stopwatchAddNote: 'Notitie toevoegen',
  stopwatchLabelPlaceholder: 'Voeg een label toe',
  stopwatchStoppedAt: 'Gestopt op',
  stopwatchDetails: 'Stopwatchdetails',
  deleteStopwatches: 'Stopwatches verwijderen',
  deleteStopwatch: 'Stopwatch verwijderen',
  deleteStopwatchConfirmMessage:
    'Weet je zeker dat je deze stopwatch wilt verwijderen?',
  noStopwatchesToDelete: 'Geen stopwatches om te verwijderen',
  noStopwatchesYet:
    'Tik op + om een stopwatch te starten. Uw voltooide stopwatches met rondetijden worden hier weergegeven.',
  stopwatchInProgress: 'Stopwatch bezig — tik om te openen',
  stopwatchLaps: {
    one: '1 ronde',
    other: '{{count}} rondes'
  },
  newAlarmButtonBehavior: 'Nieuw alarmknopgedrag',
  newAlarmButtonBehaviorTooltipMessage:
    'Wijzig de opties die worden weergegeven in de nieuwe alarmknop',
  classic: 'Standaard',
  mode: 'Modus',
  classicFabDescription: 'Toon opties voor Snelle Herinnering en Alarm',
  classicAlarmDescription: 'Toont opties om een alarmtype te kiezen',
  custom: 'Aangepast',
  customFabDescription: 'Kies welke opties getoond moeten worden',
  chooseNewAlarmButtonOptions: 'Opties voor nieuwe alarmknop',
  fabOptionsMustHaveAtLeastOne:
    'Er moet ten minste één optie worden geselecteerd',
  actUtilities: 'Handelen',
  connectUtilities: 'Verbinden',
  timer: 'Timer',
  setTimer: 'Timer instellen',
  timerFinished: 'Tijd is om!',
  hoursShort: 'Uren',
  minutesShort: 'Minuten',
  secondsShort: 'Seconden',
  adBelow: 'Advertentie hieronder',
  buyGalarmPremium: 'Koop Galarm Premium',
  phoneNumberForPremiumDescription: `Voer het telefoonnummer in dat bij Galarm is geregistreerd. We sturen een verificatiecode naar je Galarm-app.

Om te controleren of je telefoonnummer is geregistreerd, open je het tabblad Instellingen in Galarm. Je geregistreerde telefoonnummer staat onder je profielnaam.

Als je nog geen telefoonnummer hebt geregistreerd, kun je dat doen via het tabblad Contacten in de Galarm-app. Zodra het is geregistreerd, voer je hier hetzelfde telefoonnummer in om een Premium-abonnement te kopen.`,
  enterPhoneNumberForPremiumValidation:
    'Voer alstublieft uw landcode en telefoonnummer in.',
  pleaseCompleteCaptcha: 'Voltooi alstublieft de CAPTCHA-verificatie.',
  requestVerificationCode: 'Code aanvragen',
  unableToSendAppVerificationCode:
    'Kan verificatiecode niet verzenden. Probeer het opnieuw. {{error}}',
  enterVerificationCodeForPremium: 'Voer verificatiecode in',
  verificationCodeForPremiumDescription: `Voer de verificatiecode in die naar je Galarm-app is verzonden.

Om de code te vinden, open je het tabblad Meldingen en tik je op Systeemberichten.

Als je de code niet ziet:
  - Controleer of je de nieuwste versie van de Galarm-app gebruikt.
  - Controleer of je apparaat een actieve internetverbinding heeft.
  - Als je de app net hebt bijgewerkt, ga dan terug en vraag de code opnieuw aan.

Als de code nog steeds niet verschijnt, neem dan contact op met support vanuit de app via tabblad Instellingen > Feedback.`,
  enterVerificationCodeForPremiumValidation:
    'Voer alstublieft de verificatiecode in.',
  verifyCode: 'Verifiëren',
  unableToVerifyAppCode:
    'Kan code niet verifiëren. Controleer en probeer het opnieuw. {{error}}',
  buyPremiumMonthly: 'Maandelijks',
  buyPremiumYearly: 'Jaarlijks (Beste waarde)',
  monthlyPrice: '{{price}}/maand',
  yearlyPrice: '{{price}}/jaar',
  buyPremiumLifetime: 'Levenslang',
  lifetimePrice: '{{price}} eenmalig',
  creatingStripeCustomer: 'Uw account voorbereiden...',
  problemCreatingStripeCustomer:
    'Er was een probleem bij het instellen van uw account. Probeer het opnieuw. {{error}}',
  premiumPurchaseSuccessTitle: 'Welkom bij Galarm Premium!',
  premiumPurchaseSuccess:
    'Uw aankoop was succesvol. Bedankt voor uw abonnement op Galarm Premium. Open de Galarm-app op uw telefoon om van uw nieuwe functies te genieten.',
  goToGalarmWeb: 'Ga naar Galarm Web',
  premiumPurchaseCancelledTitle: 'Aankoop geannuleerd',
  premiumPurchaseCancelled:
    'Uw aankoop is niet voltooid. U kunt het op elk moment opnieuw proberen.',
  countryCode: 'Landcode',
  appVerificationCodeToBuyPremiumSubscription:
    'Verificatiecode om premium-abonnement te kopen: {{verificationCode}}',
  loadingProducts: 'Producten laden...',
  invoicesSentToThisEmail: 'Facturen worden naar dit e-mailadres verzonden.',
  tryPremiumFreeCancelAnytime:
    '🎉 14 dagen gratis proefperiode — Probeer premium gratis, annuleer op elk moment. Eén proefperiode per account.',
  galarmWebPremium: 'Galarm Web is een premiumfunctie',
  subscribeToGetAccess:
    'Abonneer je om toegang te krijgen. Inclusief een gratis proefperiode van 14 dagen.',
  subscribeToPremium: 'Abonneer op Galarm Premium',
  havingTroubleWithPremium: 'Problemen met het kopen van Premium?',
  purchaseOnWebsite: 'Koop op de website',
  purchaseOnWebsiteDescription:
    'Als u problemen ondervindt bij het kopen van premium in de app, kunt u het op onze website kopen.',
  manageSubscriptionFromBillingPortal:
    'U kunt wijzigingen aanbrengen in uw abonnement via het factureringsportaal.',
  docChatbotDefaultResponse:
    'Het spijt me, ik heb de informatie die u zoekt niet. Raadpleeg onze documentatie op https://docs.galarmapp.com of neem contact op met de helpdesk voor verdere assistentie.'
}
